var Zi = Object.defineProperty;
var Qi = (e, t, n) => t in e ? Zi(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var Me = (e, t, n) => (Qi(e, typeof t != "symbol" ? t + "" : t, n), n);
var pt = /* @__PURE__ */ ((e) => (e.TRADE = "trade", e.READ = "read", e.WITHDRAW = "withdraw", e))(pt || {});
const $i = {
  // transport related errors
  rpc: {
    parse: {
      code: -32700,
      message: "JSON parsing error",
      description: "{data.description}",
      documentation: "An error occurred on the server while parsing the JSON text"
    },
    invalidRequest: {
      code: -32600,
      message: "Invalid request object",
      description: "{data.description}",
      documentation: "The JSON sent is not a valid Request object"
    },
    methodNotFound: {
      code: -32601,
      message: "Method not found",
      description: "{data.description}",
      documentation: "The method does not exist / is not available"
    },
    invalidParams: {
      code: -32602,
      message: "Invalid method parameter(s)",
      description: "{data.description}",
      documentation: "Provided parameters do not match the method signature"
    },
    internal: {
      code: -32603,
      message: "Internal JSON-RPC error",
      description: "{data.description}",
      documentation: "Something went wrong in the communication engine of cede.store"
    }
  },
  defaultError: {
    code: 1e3,
    message: "cede.store default error",
    description: "{vault_and_account}: An error occurred",
    documentation: "Something went wrong in cede.store"
  },
  // ccxt library specific errors
  ccxt: {
    baseError: {
      code: 3e3,
      message: "CEX error",
      description: "{account}: {error.message}",
      documentation: "The exchange has a system abnormality. The original exchange error is provided."
    },
    requestExpired: {
      code: 3001,
      message: "Request expired",
      description: "{account}: request expired. This happens when ccxt throttler drops pending requests",
      documentation: "The request has expired"
    }
    // general: {
    //   cexError: {
    //     code: 3001,
    //     message: "CEX error",
    //     description: `${ErrorPlaceholder.ACCOUNT}: {error.message}`,
    //     documentation: "The exchange has a system abnormality. The original exchange error is provided.",
    //   },
    //   cexApiAuthError: {
    //     code: 3002,
    //     message: "CEX API authentication error",
    //     description: `${ErrorPlaceholder.ACCOUNT}: {error.message}`,
    //     documentation: "Invalid API key or permission denied",
    //   },
    //   cexNotAvailable: {
    //     code: 3003,
    //     message: "CEX is not available",
    //     description: `${ErrorPlaceholder.ACCOUNT}: {error.message}`,
    //     documentation: "Exchange is not available, please try again later",
    //   },
    //   cexOnMaintenance: {
    //     code: 3004,
    //     message: "CEX on maintenance",
    //     description: `${ErrorPlaceholder.ACCOUNT}: {error.message}`,
    //     documentation: "Exchange is on maintenance, please try again later",
    //   },
    //   invalidNonce: {
    //     code: 3005,
    //     message: "Invalid nonce",
    //     description: `${ErrorPlaceholder.ACCOUNT}: {error.message}`,
    //     documentation:
    //       "The API keys seem to be used by another app. The user should create new API keys and use them only for cede.store.",
    //   },
    //   notSupported: {
    //     code: 3006,
    //     message: "Not supported",
    //     description: `${ErrorPlaceholder.ACCOUNT}: {error.message}`,
    //     documentation: "This error is raised if the endpoint is not offered/not supported by the exchange API",
    //   },
    // },
    // order: {
    //   orderNotFound: {
    //     code: 3100,
    //     message: "Could not find the order",
    //     description: `${ErrorPlaceholder.ACCOUNT}: {error.message}`,
    //     documentation: "Raised when you are trying to fetch or cancel a non-existent order",
    //   },
    //   orderImmediatelyFillable: {
    //     code: 3101,
    //     message: "The order is immediately fillable",
    //     description: `${ErrorPlaceholder.ACCOUNT}: {error.message}`,
    //     documentation:
    //       "Raised when the order you're trying to place would immediately be triggered and filled, and not be placed on the order book",
    //   },
    //   orderNotFillable: {
    //     code: 3102,
    //     message: "The order is not fillable",
    //     description: `${ErrorPlaceholder.ACCOUNT}: {error.message}`,
    //     documentation: "Unable to fill this order",
    //   },
    //   invalidOrder: {
    //     code: 3103,
    //     message: "The order is invalid",
    //     description: `${ErrorPlaceholder.ACCOUNT}: {error.message}`,
    //     documentation: "Raised when the order you're trying to place is not valid",
    //   },
    //   duplicateOrderId: {
    //     code: 3104,
    //     message: "Two or more orders have identical ids",
    //     description: `${ErrorPlaceholder.ACCOUNT}: {error.message}`,
    //     documentation: "Raised when two or more orders have identical ids",
    //   },
    // },
    // request: {
    //   badRequest: {
    //     code: 3200,
    //     message: "Bad request",
    //     description: `${ErrorPlaceholder.ACCOUNT}: {error.message}`,
    //     documentation: "The request is malformed, the content of the request is not valid",
    //   },
    //   requestTimeout: {
    //     code: 3201,
    //     message: "Request timeout",
    //     description: `${ErrorPlaceholder.ACCOUNT}: {error.message}`,
    //     documentation: "The request timed out",
    //   },
    //   badResponse: {
    //     code: 3202,
    //     message: "Bad response",
    //     description: `${ErrorPlaceholder.ACCOUNT}: {error.message}`,
    //     documentation: "The response from the exchange is malformed",
    //   },
    //   rateLimitExceeded: {
    //     code: 3203,
    //     message: "Rate limit exceeded",
    //     description: `${ErrorPlaceholder.ACCOUNT}: {error.message}`,
    //     documentation: "The request rate limit has been exceeded",
    //   },
    //   argumentsRequired: {
    //     code: 3204,
    //     message: "Method requires some arguments",
    //     description: `${ErrorPlaceholder.ACCOUNT}: {error.message}`,
    //     documentation: "The method requires some arguments",
    //   },
    //   nullResponse: {
    //     code: 3205,
    //     message: "Null response",
    //     description: `${ErrorPlaceholder.ACCOUNT}: {error.message}`,
    //     documentation: "The response from the exchange is null",
    //   },
    //   ddosProtection: {
    //     code: 3206,
    //     message: "DDOS protection",
    //     description: `${ErrorPlaceholder.ACCOUNT}: {error.message}`,
    //     documentation: "The request has been rejected by the exchange due to DDOS protection",
    //   },
    //   badSymbol: {
    //     code: 3207,
    //     message: "Bad symbol",
    //     description: `${ErrorPlaceholder.ACCOUNT}: {error.message}`,
    //     documentation: "The symbol is not valid",
    //   },
    // },
    // account: {
    //   accountSuspended: {
    //     code: 3300,
    //     message: "Account suspended",
    //     description: `${ErrorPlaceholder.ACCOUNT}: {error.message}`,
    //     documentation: "The user account is suspended",
    //   },
    //   permissionDenied: {
    //     code: 3301,
    //     message: "Permission denied",
    //     description: `${ErrorPlaceholder.ACCOUNT}: {error.message}`,
    //     documentation: "The user doesn't have enough permission to perform the action",
    //   },
    //   insufficientFunds: {
    //     code: 3302,
    //     message: "Insufficient funds",
    //     description: `${ErrorPlaceholder.ACCOUNT}: {error.message}`,
    //     documentation: "The user doesn't have enough funds to perform the action",
    //   },
    //   invalidAddress: {
    //     code: 3303,
    //     message: "Invalid address",
    //     description: `${ErrorPlaceholder.ACCOUNT}: {error.message}`,
    //     documentation: "The address is not valid",
    //   },
    //   addressPending: {
    //     code: 3304,
    //     message: "Address pending",
    //     description: `${ErrorPlaceholder.ACCOUNT}: {error.message}`,
    //     documentation: "The address is pending",
    //   },
    //   cancelPending: {
    //     code: 3305,
    //     message: "Cancel pending",
    //     description: `${ErrorPlaceholder.ACCOUNT}: {error.message}`,
    //     documentation: "The cancel is pending",
    //   },
    // },
  },
  internal: {
    general: {
      badPassword: {
        code: 4e3,
        message: "Bad password",
        description: "Bad password",
        documentation: "The password provided is incorrect"
      }
    },
    misc: {
      jobs: {
        fetchTransactionHistoryError: {
          code: 4100,
          message: "Transaction history cannot be fetched through the job",
          description: "An error happened while fetching the transaction history",
          documentation: "An error happened while fetching the transaction history"
        },
        getLastTxUpdateError: {
          code: 4101,
          message: "Last transaction update cannot be fetched through the job",
          description: "An error happened while getting the last transaction update",
          documentation: "An error happened while getting the last transaction update"
        }
      }
    },
    vault: {
      accountAlreadyExists: {
        code: 4200,
        message: "Vault account already exists",
        description: "The exchange account has already been added to the vault",
        documentation: "The exchange account has already been added to the vault"
      },
      nameExists: {
        code: 4201,
        message: "Vault name already exists",
        description: "The vault {vault} already exists",
        documentation: "Raised when trying to create the vault with same name as the existent vault"
      },
      nameCannotBeGenerated: {
        code: 4202,
        message: "Vault name cannot be generated",
        description: "The vault name cannot be generated",
        documentation: "Raised when there is an error in the vault name generation"
      },
      accountKeysInconsistent: {
        code: 4203,
        message: "Account keys inconsistent. They may not relate to the same account",
        description: "The Api Keys are not related to the same CEX account",
        documentation: "Raised when the user is trying to a second pair of API keys for the 2 key CEX which are not related to the same account"
      },
      cannotUnlockStorage: {
        code: 4204,
        message: "The storage cannot be unlocked",
        description: "Cede Store cannot unlock the storage",
        documentation: "Raised when the storage cannot be unlocked"
      },
      cannotPersisted: {
        code: 4205,
        message: "Vaults cannot persisted",
        description: "The vaults cannot be persisted",
        documentation: "Raised when the vaults cannot be persisted"
      },
      creationError: {
        code: 4206,
        message: "Vault creation error",
        description: "{vault}: An error happened while creating the vault",
        documentation: "Raised when an error happened while creating the vault"
      },
      deletionError: {
        code: 4207,
        message: "Vault deletion error",
        description: "{vault}: An error happened while deleting the vault",
        documentation: "Raised when an error happened while deleting the vault"
      },
      checkApiCredentialsError: {
        code: 4208,
        message: "API check credentials failure",
        description: "{vault}: An error happened while checking the API credentials",
        documentation: "Raised when an error happened while checking the API credentials when adding a new CEX"
      },
      updateApiCredentialsError: {
        code: 4209,
        message: "API update credentials failure",
        description: "{vault_and_account}: An error happened while updating the API credentials",
        documentation: "Raised when an error happened while updating the API credentials when updating a CEX"
      },
      updateCexSettingsError: {
        code: 4210,
        message: "Vault CEX update settings error",
        description: "{vault_and_account}: An error happened while updating the CEX settings",
        documentation: "Raised when an error happened while updating the CEX settings when updating a CEX"
      },
      accountCreationError: {
        code: 4211,
        message: "Vault account creation error",
        description: "{vault}: An error happened while creating the account",
        documentation: "Raised when an error happened while creating the account"
      },
      accountUpdateError: {
        code: 4212,
        message: "Vault account update error",
        description: "{vault_and_account}: An error happened while updating the account",
        documentation: "Raised when an error happened while updating the account"
      },
      globalUnlockError: {
        code: 4213,
        message: "Vault cannot be unlocked",
        description: "An error happened while unlocking the vaults",
        documentation: "Raised when an error happened while unlocking globally the vaults"
      },
      notWhitelisted: {
        code: 4214,
        message: "IP not whitelisted for API keys",
        description: "IP addresses weren't whitelisted. Please, whitelist them first.",
        documentation: "Raised when cede.store proxy IP was not whitelisted on the CEX side"
      },
      accountKeyAlreadyExists: {
        code: 4215,
        message: "API key already exists",
        description: "The API Key already exists",
        documentation: "Raised when the user is trying to update a key using one that already exists in the vault for the same CEX"
      },
      whitelistCheckFail: {
        code: 4216,
        message: "Whitelist check failed",
        description: "Whitelist check failed. Please try again later.",
        documentation: "Raised when the whitelist check failed"
      }
    }
  },
  // cede.store background errors
  cede: {
    general: {
      dispatcherDefaultError: {
        code: 5e3,
        message: "Dispatcher default error",
        description: "An error occured while {data.humanizedAction}",
        documentation: "An error occured while executing the method."
      },
      approvalNotFound: {
        code: 5001,
        message: "Approval not found",
        description: "The approval {data.approvalId} isn't found",
        documentation: "The approval isn't found. This can happen if the approval is not in pending approvals array"
      },
      vaultNotAllowedToAccess: {
        code: 5002,
        message: "Vault is not allowed to access",
        description: "You aren't allowed to access to this vault",
        documentation: "You aren't allowed to access to this vault"
      },
      accountNotPermission: {
        code: 5003,
        message: "Account does not have sufficient permissions to perform this action",
        description: "The account {account} doesn't have the permission to {data.permission} : {vault}",
        documentation: "The account doesn't have the permission to perform this action. If the account is read-only, you can't perform trades/withdrawals"
      },
      notAllowedMethod: {
        code: 5004,
        message: "Method not allowed",
        description: "You aren't available to access to the method {data.method}",
        documentation: "You aren't available to access to the given method"
      },
      notConnected: {
        code: 5005,
        message: "Not connected",
        description: "Connect with cede.store to perfom this request",
        documentation: "Connect with cede.store to perfom this request"
      },
      notInitialized: {
        code: 5006,
        message: "Not initialized",
        description: "The user must set up at least one vault in the cede.store first",
        documentation: "Raised when cede.store has been downloaded but not initialized. The user must set up at least one vault in the cede.store first"
      },
      oauthAccessRevoked: {
        code: 5007,
        message: "Access token revoked",
        description: "{vault}: Access token revoked. You should remove the {account} account and add it again.",
        documentation: "Raised when user adds an account via OAuth2. The user must remove and add the account again to get the new access token."
      },
      notSupportedFeature: {
        code: 5008,
        message: "This feature is not supported by the {account}",
        description: "This feature is not supported by the {account}",
        documentation: "Verify if the feature is supported by the CEX"
      },
      userDeniedApproval: {
        code: 5009,
        message: "User denied approval",
        description: "User denied approval",
        documentation: "User denied approval"
      },
      accountInvalidSetOfPermissions: {
        code: 5010,
        message: "Invalid set of permissions",
        description: "The account has an invalid set of permissions",
        documentation: "The account has an invalid set of permissions"
      },
      methodNotAvailableForThisExchange: {
        code: 5011,
        message: "Method not available",
        description: "This method is not available on this exchange",
        documentation: "The provider was requested to perform an action on an exchange that does not support the action"
      },
      invalidPermissionsSetup: {
        code: 5012,
        message: "Invalid key permissions",
        description: "Missing API permissions, please reimport your API key with the valid permissions",
        documentation: "API key permissions aren't valid, you should add missing permissions to the key and try again"
      }
    },
    vault: {
      notFound: {
        code: 5100,
        message: "Vault not found",
        description: "The vault was not found",
        documentation: "The vault was not found. Verify the vauld id"
      },
      accountNotFound: {
        code: 5101,
        message: "Vault account not found",
        // TODO make sure the error handler puts accountId in the context
        description: "{vault}: The account {account} was not found",
        documentation: "The account was not found. Verify the account name"
      },
      fetchVaultsError: {
        code: 5102,
        message: "Vaults cannot be retrieved",
        description: "An error happened while retrieveing the vaults",
        documentation: "Raised when the vaults cannot be retrieved from cede.store"
      },
      generateAccountNameError: {
        code: 5103,
        message: "An error occured while generating the account name",
        description: "An error occured while generating the account name",
        documentation: "The generate account name method shouldn't fail"
      },
      validateAccountNameError: {
        code: 5104,
        message: "An error occured while validating the account name",
        description: "An error occured while validating the account name",
        documentation: "The validate account name method shouldn't fail"
      },
      updateAccountNameError: {
        code: 5105,
        message: "An error occured while updating the account name",
        description: "An error occured while updating the account name",
        documentation: "Verify if the old account name is valid because we are using it to update the account"
      },
      getAccountError: {
        code: 5106,
        message: "An error occured while getting the account",
        description: "An error occured while getting the account",
        documentation: "Verify if the account id is valid"
      },
      getAccountsError: {
        code: 5107,
        message: "An error occured while getting the accounts",
        description: "An error occured while getting the accounts",
        documentation: "Verify if the vault id is valid"
      },
      notOAuthAccount: {
        code: 5108,
        message: "The account is not an OAuth account",
        description: "The account is not an OAuth account",
        documentation: "This error is raised when we try to perform an action on an OAuth account and the account is not using OAuth"
      },
      accountAlreadyContainsApiKeys: {
        code: 5109,
        message: "The account already contains these API keys",
        description: "The account already contains these API keys",
        documentation: "The account already contains the API keys added for different permissions. The CEX requires different keys for different permissions."
      }
    },
    exchange: {
      // public data, such as available tickers, tokens, etc.
      public: {
        fetchTickerFromTokenError: {
          code: 5201,
          message: "Cannot fetch ticker from token",
          description: "{vault_and_account}: An error happened while fetching tickers",
          documentation: "Raised when the ticker for a given token symbol cannot be retrieved from the CEX"
        },
        tokenNotFound: {
          code: 5202,
          message: "Token not found",
          description: "{vault_and_account}: The token {data.tokenSymbol} was not found",
          documentation: "Raised when the token cannot be found on the CEX"
        },
        marketNotFound: {
          code: 5203,
          message: "Market not found",
          description: "{vault_and_account}: The market {data.pairSymbol} was not found",
          documentation: "Raised when the market cannot be found on the CEX"
        },
        serverDown: {
          code: 5204,
          message: "Exchange's server is down",
          description: "The exchange's server is down",
          documentation: "Raised when the exchange server status is offline."
        },
        underMaintenance: {
          code: 5205,
          message: "Exchange is under maintenance",
          description: "The exchange is under maintenance",
          documentation: "Raised when the exchange server status is under maintenance."
        },
        supportedTokensError: {
          code: 5206,
          message: "Supported tokens not found",
          description: "{account}: The supported tokens were not found",
          documentation: "Raised when getSupportedTokens returns an error."
        },
        unavailableInThisCountry: {
          code: 5207,
          message: "The exchange is not available in this country",
          description: "{account}: The exchange is not available in this country",
          documentation: "Raised when the exchange is not available in this country"
        }
      },
      // fungible and non-fungible balances (tokens, nfts, fiat)
      balances: {
        getBalancesError: {
          code: 5210,
          message: "Cannot retrieve vault portfolio from CEX",
          description: "{vault_and_account}: An error happened while fetching the portfolio from the CEX",
          documentation: "Raised when the portfolio cannot be retrieved from the CEX"
        },
        getNftFromCexError: {
          code: 5211,
          message: "NFTs cannot be fetched from CEX",
          description: "{vault_and_account}: An error happened while fetching the NFTs",
          documentation: "Raised when the NFTs cannot be retrieved from the CEX"
        }
      },
      transactions: {
        getVaultTransactionsError: {
          code: 5220,
          message: "Cannot retrieve vault transactions",
          description: "{vault_and_account}: An error happened while fetching the vault transactions",
          documentation: "Raised when the transactions cannot be retrieved from the CEX"
        }
      },
      deposit: {
        getDepositableTokensError: {
          code: 5230,
          message: "Cannot get depositable tokens",
          description: "{vault_and_account}: An error happened while fetching the depositable tokens",
          documentation: "Raised when the depositable tokens cannot be retrieved from the CEX"
        },
        getDepositAddressError: {
          code: 5231,
          message: "Cannot get deposit address",
          description: "{vault_and_account}: An error happened while fetching the deposit address",
          documentation: "Raised when the deposit address cannot be retrieved from the CEX"
        }
      },
      trade: {
        postOrderError: {
          code: 5240,
          message: "Error encountered while posting order",
          description: "{vault_and_account}: An error occured with the market order",
          documentation: "Raised when the order cannot be posted to the CEX"
        },
        fetchMarketPairsError: {
          code: 5241,
          message: "Market pairs cannot be fetched",
          description: "{vault_and_account}: An error happened while fetching the market pairs",
          documentation: "Raised when the market pairs cannot be retrieved from the CEX"
        },
        fetchAllTickersFromSymbolsError: {
          code: 5242,
          message: "Tickers cannot be fetched from symbols",
          description: "{vault_and_account}: An error happened while fetching the tickers",
          documentation: "Raised when the tickers cannot be retrieved from the CEX"
        },
        orderNotFound: {
          code: 5243,
          message: "Order not found",
          description: "{vault_and_account}: The order {data.orderId} was not found",
          documentation: "Raised when the order cannot be found on the CEX"
        },
        minAmountError: {
          code: 5244,
          message: "Minimum amount error",
          description: "{vault_and_account}: The amount should be greater than {data.minAmount}",
          documentation: "Raised when the amount is too low to execute the trade"
        },
        tickerNotFound: {
          code: 5245,
          message: "Ticker not found",
          description: "{vault_and_account}: The ticker for {data.pairSymbol} was not found",
          documentation: "Raised when the ticker cannot be found on the CEX"
        },
        invalidOrderRequest: {
          code: 5246,
          message: "Invalid order request",
          description: "{vault_and_account}: The order request is invalid: {data.error}",
          documentation: "This error is triggered by invalid order requests. It could arise due to inappropriate data inputs, such as a price set to zero. To streamline error handling, we avoid generating overly specific errors for each scenario. This approach assumes that proper data validation is performed within the dApp, ensuring user inputs are correct."
        },
        fetchMarketPriceError: {
          code: 5247,
          message: "Market rates cannot be fetched",
          description: "{vault_and_account}: An error happened while fetching market rates",
          documentation: "Raised when market rates cannot be retrieved from the CEX"
        },
        getTradePathError: {
          code: 5248,
          message: "Trade path cannot be fetched",
          description: "{vault_and_account}: An error happened while fetching trade path",
          documentation: "Raised when trade path cannot be retrieved from the CEX"
        }
      },
      network: {
        networkNotFound: {
          code: 5250,
          message: "Network not found",
          description: "The network {data.network} isn't found",
          documentation: "Raised when the network isn't found"
        },
        networkNotProvided: {
          code: 5251,
          message: "Network not provided",
          description: "The network is not provided",
          documentation: "Raised when the network is not provided, but required"
        },
        networksNotStandardized: {
          code: 5252,
          message: "Networks are not standardized",
          description: "The networks are not standardized",
          documentation: "Raised when the networks are not standardized"
        }
      },
      withdrawal: {
        tokenToDefiAddressError: {
          code: 5260,
          message: "Error encountered while withdrawing token to DeFi address",
          description: "{vault_and_account}: An error happened while withdrawing to a DeFi address",
          documentation: "Raised when the withdrawal cannot be posted to DeFi address"
        },
        tokenToAnotherCexError: {
          code: 5261,
          message: "Error encountered while withdrawing token to another CEX",
          description: "{vault_and_account}: An error happened while withdrawing to another CEX",
          documentation: "Raised when the withdrawal cannot be posted to the CEX"
        },
        notFound: {
          code: 5262,
          message: "Withdrawal not found",
          description: "The withdrawal with id {data.withdrawalId} isn't found",
          documentation: "Raised when the withdrawal isn't found"
        },
        infoError: {
          code: 5263,
          message: "Withdrawal info error",
          description: "{vault_and_account}: Withdrawal info not found",
          documentation: "Raised when the withdrawal info cannot be retrieved from the CEX"
        },
        notEnoughBalance: {
          code: 5265,
          message: "Not enough balance to withdraw",
          description: "{vault_and_account}: Not enough balance to withdraw",
          documentation: "Raised when the balance hasn't enough funds to execute the withdrawal"
        },
        underWithdrawMin: {
          code: 5266,
          message: "Amount under the minimum withdrawal amount",
          description: "{vault_and_account}: Amount under the minimum withdrawal amount",
          documentation: "Raised when the amount is under the minimum withdrawal amount"
        },
        overWithdrawMax: {
          code: 5267,
          message: "Amont over the maximum withdrawal amount",
          description: "{vault_and_account}: Amount over the maximum withdrawal amount",
          documentation: "Raised when the amount is over the maximum withdrawal amount"
        },
        invalidAddress: {
          code: 5268,
          message: "Invalid address",
          description: "{vault_and_account}: Invalid address",
          documentation: "Raised when the address is invalid"
        }
      },
      coinbase: {
        accountNotFound: {
          code: 5270,
          message: "Coinbase account not found",
          description: "{account}: The account for currency {data.currency} was not found",
          documentation: "Raised when the account for currency cannot be found on the CEX"
        }
      },
      binance: {
        readonlyBinanceNotProvided: {
          code: 5280,
          message: "Read-only Binance account not provided",
          description: "{account}: The read-only Binance account was not provided",
          documentation: "Raised when the read-only Binance account was not provided"
        }
      },
      exchangeInstance: {
        invalidExchangeId: {
          code: 5290,
          message: "Error encountered while registering an exchange instance",
          description: "Invalid exchange id",
          documentation: "Raised when the exchange id isn't recognized"
        },
        invalidExchangeInstanceId: {
          code: 5291,
          message: "Error encountered while getting an exchange instance",
          description: "Invalid exchange instance id",
          documentation: "Raised when the exchange instance id isn't recognized"
        },
        invalidCredentials: {
          code: 5292,
          message: "Error encountered while checking credentials of an exchange instance",
          description: "Invalid credentials",
          documentation: "Raised when the credentials are invalid"
        },
        notFound: {
          code: 5293,
          message: "Exchange instance not found",
          description: "The exchange instance was not found",
          documentation: "Raised when the exchange instance was not found"
        }
      },
      authentication: {
        authenticationFlowNotSupported: {
          code: 5300,
          message: "Authentication flow not supported",
          description: "Authentication flow not supported",
          documentation: "Raised when the authentication flow is not supported"
        },
        oauthFlowInterruptedByTheUser: {
          code: 5301,
          message: "Connection has been interrupted. Please try again.",
          description: "Connection has been interrupted. Please try again.",
          documentation: "Raised when the OAuth flow is interrupted by the user (e.g. user closes the authorization popup)"
        }
      },
      nft: {
        notSupportedNfts: {
          code: 5400,
          message: "NFTs are not supported",
          description: "{account}: NFTs aren't supported.",
          documentation: "NFTs aren't supported on the given exchange"
        }
      }
    }
  },
  api: {
    invalidRequest: {
      code: 6e3,
      message: "Error encountered when sending a request to the api",
      description: "Request failed",
      documentation: "Raised when an API request failed"
    }
  }
}, Cr = {
  LOCKED_FOR_INACTIVITY: "Cede.store has been automatically locked due to a period of inactivity.",
  MESSAGE_SENT_TO_CEDE_TEAM: "Message sent to Cede Labs team",
  FEEDBACK_ERROR: "Error when sending feedback",
  API_KEY: {
    ALREADY_EXISTS: "API keys already exist.",
    CREDENTIALS_INCORRECT: "API credentials are incorrect",
    SUCCESSFULLY: (e) => `API key successfully ${e}`,
    REMOVED: "API key successfully removed",
    VERIFYING_VALIDITY: "Just verifying the validity of your keys…"
  },
  VAULT: {
    CANT_DELETE_SINGLE: "You can't delete your single vault.",
    REQUIRE_NON_EMPTY: "You must have at least one account in your vault to perform this action.",
    CREATED_SUCCESSFULLY: "Vault created successfully",
    NOT_FOUND: "Vault not found"
  },
  TRANSACTION: {
    TOKEN_FROM_NOT_FOUND: "Token from not found for this transaction",
    ACCOUNT_NOT_FOUND: "Account not found for this transaction",
    ORDER_NOT_FOUND: "Order not found for this transaction"
  },
  ACCOUNT: {
    NOT_FOUND: "Account not found",
    NOT_FOUND_WITH_NAME: (e) => `Account ${e} not found`,
    RECONNECT: (e) => `Please, reconnect your ${e} account`,
    DELETED: (e) => `${e} has been deleted.`,
    RECONNECTION_REQUIRED: "Reconnection required"
  },
  MARKET_NOT_FOUND: (e) => `Market ${e} not found`,
  CANCELLATION_FAILED: "The cancellation failed",
  OAUTH: {
    FAILED: "OAuth2 Connection failed, please try again.",
    SUCCESSFULLY_SETUP: "OAuth successfully setup"
  },
  UNKNOWN_ERROR: "Oups, something went wrong.",
  PRICES: {
    CANT_FETCH: "Sorry, we can't fetch the prices."
  },
  WIDGETS: {
    SEND: {
      LOGIN_LOADING_FIRST_LINE: "Select the vault you want to connect to from cede.store extension.",
      LOGIN_LOADING_SECOND_LINE: "You will be transferring your assets from the CEX accounts connected in the vault.",
      TRANSACTION_LOADING_FIRST_LINE: "Confirm the transaction on the cede.store popup.",
      TRANSACTION_LOADING_SECOND_LINE: "Make sure all the parameters are correct before confirming.",
      TRANSFER_CEX_ASSETS: "Transfer your CEX assets to your blockchain address from any dApp",
      CONNECT: "Connect",
      CONNECT_WALLET: "Connect wallet",
      CANT_FETCH_BUNDLE: "Could not connect to Cede.store. Please make sure you have the latest version of the extension."
    },
    TRADE_SEND: {
      ACTIONS_LABEL: "What actions you will validate:",
      WITHDRAW_CURRENCY: (e, t, n) => `Withdraw ${e} to ${t} on ${n}`,
      RECEIVE_CURRENCY: (e) => `In the end, you will receive ${e} in your wallet`,
      MODAL_CONFIRM: "Continue",
      PERFORM_TRADE_PATH: (e, t) => `You will need to perform the following ${e} trade(s) in order to withdraw on the ${t} network.`,
      NO_TRADE_PATH: "There is no trade path available for the destination currency. Please select another currency.",
      CONFIRM_TX: (e) => `Confirm Transaction ${e}`,
      FINISH: "Finish"
    }
  },
  EXCHANGES_STATUSES: {
    SINGLE_DOWN: (e) => `${e} server is temporarily down, please try again later.`,
    TWO_DOWN: (e, t) => `${e} and ${t} servers are temporarily down, please try again later.`,
    THREE_DOWN: (e, t, n) => `${e}, ${t} and ${n} servers are temporarily down, please try again later.`,
    SINGLE_BACK_ONLINE: (e) => `${e} server is back available.`,
    TWO_BACK_ONLINE: (e, t) => `${e} and ${t} servers are back available.`,
    THREE_BACK_ONLINE: (e, t, n) => `${e}, ${t} and ${n} servers are back available.`,
    UNDER_MAINTENANCE: "Under maintenance",
    ADD_PERMISSION: "Add permission +",
    TEMPORARILY_UNAVAILABLE: "Temporarily unavailable",
    TEMPORARILY_UNAVAILABLE_IN_YOUR_COUNTRY: "Temporarily unavailable in your country"
  },
  STATE_MACHINE_ROUTER: {
    ERRORS: {
      MISSING_PARAMETERS: "Missing parameters from the redirection.",
      TWO_KEY_NOT_SUPPORTED: (e) => `The exchange ${e} doesn't support 2 key system.`
    }
  },
  READ_ONLY_ONBOARDING: {
    TITLE: "Specific server-side onboarding",
    PERMISSION_HINT: "Trade and withdraw permissions are not available for this specific onboarding"
  },
  AVAILABLE_SOON: "Available soon"
};
pt.WITHDRAW, pt.TRADE, pt.READ;
function Hi(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var vn = { exports: {} }, ge = vn.exports = {}, xe, ve;
function Ar() {
  throw new Error("setTimeout has not been defined");
}
function Lr() {
  throw new Error("clearTimeout has not been defined");
}
(function() {
  try {
    typeof setTimeout == "function" ? xe = setTimeout : xe = Ar;
  } catch {
    xe = Ar;
  }
  try {
    typeof clearTimeout == "function" ? ve = clearTimeout : ve = Lr;
  } catch {
    ve = Lr;
  }
})();
function On(e) {
  if (xe === setTimeout)
    return setTimeout(e, 0);
  if ((xe === Ar || !xe) && setTimeout)
    return xe = setTimeout, setTimeout(e, 0);
  try {
    return xe(e, 0);
  } catch {
    try {
      return xe.call(null, e, 0);
    } catch {
      return xe.call(this, e, 0);
    }
  }
}
function Ji(e) {
  if (ve === clearTimeout)
    return clearTimeout(e);
  if ((ve === Lr || !ve) && clearTimeout)
    return ve = clearTimeout, clearTimeout(e);
  try {
    return ve(e);
  } catch {
    try {
      return ve.call(null, e);
    } catch {
      return ve.call(this, e);
    }
  }
}
var _e = [], Je = !1, We, yt = -1;
function Xi() {
  !Je || !We || (Je = !1, We.length ? _e = We.concat(_e) : yt = -1, _e.length && zn());
}
function zn() {
  if (!Je) {
    var e = On(Xi);
    Je = !0;
    for (var t = _e.length; t; ) {
      for (We = _e, _e = []; ++yt < t; )
        We && We[yt].run();
      yt = -1, t = _e.length;
    }
    We = null, Je = !1, Ji(e);
  }
}
ge.nextTick = function(e) {
  var t = new Array(arguments.length - 1);
  if (arguments.length > 1)
    for (var n = 1; n < arguments.length; n++)
      t[n - 1] = arguments[n];
  _e.push(new kn(e, t)), _e.length === 1 && !Je && On(zn);
};
function kn(e, t) {
  this.fun = e, this.array = t;
}
kn.prototype.run = function() {
  this.fun.apply(null, this.array);
};
ge.title = "browser";
ge.browser = !0;
ge.env = {};
ge.argv = [];
ge.version = "";
ge.versions = {};
function Pe() {
}
ge.on = Pe;
ge.addListener = Pe;
ge.once = Pe;
ge.off = Pe;
ge.removeListener = Pe;
ge.removeAllListeners = Pe;
ge.emit = Pe;
ge.prependListener = Pe;
ge.prependOnceListener = Pe;
ge.listeners = function(e) {
  return [];
};
ge.binding = function(e) {
  throw new Error("process.binding is not supported");
};
ge.cwd = function() {
  return "/";
};
ge.chdir = function(e) {
  throw new Error("process.chdir is not supported");
};
ge.umask = function() {
  return 0;
};
var Vi = vn.exports;
const q = /* @__PURE__ */ Hi(Vi);
var ie = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Ki(e) {
  if (e.__esModule)
    return e;
  var t = e.default;
  if (typeof t == "function") {
    var n = function s() {
      return this instanceof s ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    n.prototype = t.prototype;
  } else
    n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(e).forEach(function(s) {
    var u = Object.getOwnPropertyDescriptor(e, s);
    Object.defineProperty(n, s, u.get ? u : {
      enumerable: !0,
      get: function() {
        return e[s];
      }
    });
  }), n;
}
var _r = {}, Nt = {};
Nt.byteLength = to;
Nt.toByteArray = no;
Nt.fromByteArray = ao;
var Oe = [], Ne = [], qi = typeof Uint8Array < "u" ? Uint8Array : Array, Gt = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for (var $e = 0, eo = Gt.length; $e < eo; ++$e)
  Oe[$e] = Gt[$e], Ne[Gt.charCodeAt($e)] = $e;
Ne["-".charCodeAt(0)] = 62;
Ne["_".charCodeAt(0)] = 63;
function _n(e) {
  var t = e.length;
  if (t % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  var n = e.indexOf("=");
  n === -1 && (n = t);
  var s = n === t ? 0 : 4 - n % 4;
  return [n, s];
}
function to(e) {
  var t = _n(e), n = t[0], s = t[1];
  return (n + s) * 3 / 4 - s;
}
function ro(e, t, n) {
  return (t + n) * 3 / 4 - n;
}
function no(e) {
  var t, n = _n(e), s = n[0], u = n[1], d = new qi(ro(e, s, u)), c = 0, p = u > 0 ? s - 4 : s, y;
  for (y = 0; y < p; y += 4)
    t = Ne[e.charCodeAt(y)] << 18 | Ne[e.charCodeAt(y + 1)] << 12 | Ne[e.charCodeAt(y + 2)] << 6 | Ne[e.charCodeAt(y + 3)], d[c++] = t >> 16 & 255, d[c++] = t >> 8 & 255, d[c++] = t & 255;
  return u === 2 && (t = Ne[e.charCodeAt(y)] << 2 | Ne[e.charCodeAt(y + 1)] >> 4, d[c++] = t & 255), u === 1 && (t = Ne[e.charCodeAt(y)] << 10 | Ne[e.charCodeAt(y + 1)] << 4 | Ne[e.charCodeAt(y + 2)] >> 2, d[c++] = t >> 8 & 255, d[c++] = t & 255), d;
}
function io(e) {
  return Oe[e >> 18 & 63] + Oe[e >> 12 & 63] + Oe[e >> 6 & 63] + Oe[e & 63];
}
function oo(e, t, n) {
  for (var s, u = [], d = t; d < n; d += 3)
    s = (e[d] << 16 & 16711680) + (e[d + 1] << 8 & 65280) + (e[d + 2] & 255), u.push(io(s));
  return u.join("");
}
function ao(e) {
  for (var t, n = e.length, s = n % 3, u = [], d = 16383, c = 0, p = n - s; c < p; c += d)
    u.push(oo(e, c, c + d > p ? p : c + d));
  return s === 1 ? (t = e[n - 1], u.push(
    Oe[t >> 2] + Oe[t << 4 & 63] + "=="
  )) : s === 2 && (t = (e[n - 2] << 8) + e[n - 1], u.push(
    Oe[t >> 10] + Oe[t >> 4 & 63] + Oe[t << 2 & 63] + "="
  )), u.join("");
}
var Br = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
Br.read = function(e, t, n, s, u) {
  var d, c, p = u * 8 - s - 1, y = (1 << p) - 1, D = y >> 1, M = -7, m = n ? u - 1 : 0, z = n ? -1 : 1, R = e[t + m];
  for (m += z, d = R & (1 << -M) - 1, R >>= -M, M += p; M > 0; d = d * 256 + e[t + m], m += z, M -= 8)
    ;
  for (c = d & (1 << -M) - 1, d >>= -M, M += s; M > 0; c = c * 256 + e[t + m], m += z, M -= 8)
    ;
  if (d === 0)
    d = 1 - D;
  else {
    if (d === y)
      return c ? NaN : (R ? -1 : 1) * (1 / 0);
    c = c + Math.pow(2, s), d = d - D;
  }
  return (R ? -1 : 1) * c * Math.pow(2, d - s);
};
Br.write = function(e, t, n, s, u, d) {
  var c, p, y, D = d * 8 - u - 1, M = (1 << D) - 1, m = M >> 1, z = u === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, R = s ? 0 : d - 1, _ = s ? 1 : -1, B = t < 0 || t === 0 && 1 / t < 0 ? 1 : 0;
  for (t = Math.abs(t), isNaN(t) || t === 1 / 0 ? (p = isNaN(t) ? 1 : 0, c = M) : (c = Math.floor(Math.log(t) / Math.LN2), t * (y = Math.pow(2, -c)) < 1 && (c--, y *= 2), c + m >= 1 ? t += z / y : t += z * Math.pow(2, 1 - m), t * y >= 2 && (c++, y /= 2), c + m >= M ? (p = 0, c = M) : c + m >= 1 ? (p = (t * y - 1) * Math.pow(2, u), c = c + m) : (p = t * Math.pow(2, m - 1) * Math.pow(2, u), c = 0)); u >= 8; e[n + R] = p & 255, R += _, p /= 256, u -= 8)
    ;
  for (c = c << u | p, D += u; D > 0; e[n + R] = c & 255, R += _, c /= 256, D -= 8)
    ;
  e[n + R - _] |= B * 128;
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
(function(e) {
  const t = Nt, n = Br, s = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
  e.Buffer = M, e.SlowBuffer = H, e.INSPECT_MAX_BYTES = 50;
  const u = 2147483647;
  e.kMaxLength = u;
  const { Uint8Array: d, ArrayBuffer: c, SharedArrayBuffer: p } = globalThis;
  M.TYPED_ARRAY_SUPPORT = y(), !M.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error(
    "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
  );
  function y() {
    try {
      const l = new d(1), r = { foo: function() {
        return 42;
      } };
      return Object.setPrototypeOf(r, d.prototype), Object.setPrototypeOf(l, r), l.foo() === 42;
    } catch {
      return !1;
    }
  }
  Object.defineProperty(M.prototype, "parent", {
    enumerable: !0,
    get: function() {
      if (M.isBuffer(this))
        return this.buffer;
    }
  }), Object.defineProperty(M.prototype, "offset", {
    enumerable: !0,
    get: function() {
      if (M.isBuffer(this))
        return this.byteOffset;
    }
  });
  function D(l) {
    if (l > u)
      throw new RangeError('The value "' + l + '" is invalid for option "size"');
    const r = new d(l);
    return Object.setPrototypeOf(r, M.prototype), r;
  }
  function M(l, r, i) {
    if (typeof l == "number") {
      if (typeof r == "string")
        throw new TypeError(
          'The "string" argument must be of type string. Received type number'
        );
      return _(l);
    }
    return m(l, r, i);
  }
  M.poolSize = 8192;
  function m(l, r, i) {
    if (typeof l == "string")
      return B(l, r);
    if (c.isView(l))
      return b(l);
    if (l == null)
      throw new TypeError(
        "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof l
      );
    if (ce(l, c) || l && ce(l.buffer, c) || typeof p < "u" && (ce(l, p) || l && ce(l.buffer, p)))
      return S(l, r, i);
    if (typeof l == "number")
      throw new TypeError(
        'The "value" argument must not be of type number. Received type number'
      );
    const h = l.valueOf && l.valueOf();
    if (h != null && h !== l)
      return M.from(h, r, i);
    const C = F(l);
    if (C)
      return C;
    if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof l[Symbol.toPrimitive] == "function")
      return M.from(l[Symbol.toPrimitive]("string"), r, i);
    throw new TypeError(
      "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof l
    );
  }
  M.from = function(l, r, i) {
    return m(l, r, i);
  }, Object.setPrototypeOf(M.prototype, d.prototype), Object.setPrototypeOf(M, d);
  function z(l) {
    if (typeof l != "number")
      throw new TypeError('"size" argument must be of type number');
    if (l < 0)
      throw new RangeError('The value "' + l + '" is invalid for option "size"');
  }
  function R(l, r, i) {
    return z(l), l <= 0 ? D(l) : r !== void 0 ? typeof i == "string" ? D(l).fill(r, i) : D(l).fill(r) : D(l);
  }
  M.alloc = function(l, r, i) {
    return R(l, r, i);
  };
  function _(l) {
    return z(l), D(l < 0 ? 0 : $(l) | 0);
  }
  M.allocUnsafe = function(l) {
    return _(l);
  }, M.allocUnsafeSlow = function(l) {
    return _(l);
  };
  function B(l, r) {
    if ((typeof r != "string" || r === "") && (r = "utf8"), !M.isEncoding(r))
      throw new TypeError("Unknown encoding: " + r);
    const i = ye(l, r) | 0;
    let h = D(i);
    const C = h.write(l, r);
    return C !== i && (h = h.slice(0, C)), h;
  }
  function Z(l) {
    const r = l.length < 0 ? 0 : $(l.length) | 0, i = D(r);
    for (let h = 0; h < r; h += 1)
      i[h] = l[h] & 255;
    return i;
  }
  function b(l) {
    if (ce(l, d)) {
      const r = new d(l);
      return S(r.buffer, r.byteOffset, r.byteLength);
    }
    return Z(l);
  }
  function S(l, r, i) {
    if (r < 0 || l.byteLength < r)
      throw new RangeError('"offset" is outside of buffer bounds');
    if (l.byteLength < r + (i || 0))
      throw new RangeError('"length" is outside of buffer bounds');
    let h;
    return r === void 0 && i === void 0 ? h = new d(l) : i === void 0 ? h = new d(l, r) : h = new d(l, r, i), Object.setPrototypeOf(h, M.prototype), h;
  }
  function F(l) {
    if (M.isBuffer(l)) {
      const r = $(l.length) | 0, i = D(r);
      return i.length === 0 || l.copy(i, 0, 0, r), i;
    }
    if (l.length !== void 0)
      return typeof l.length != "number" || Ft(l.length) ? D(0) : Z(l);
    if (l.type === "Buffer" && Array.isArray(l.data))
      return Z(l.data);
  }
  function $(l) {
    if (l >= u)
      throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + u.toString(16) + " bytes");
    return l | 0;
  }
  function H(l) {
    return +l != l && (l = 0), M.alloc(+l);
  }
  M.isBuffer = function(r) {
    return r != null && r._isBuffer === !0 && r !== M.prototype;
  }, M.compare = function(r, i) {
    if (ce(r, d) && (r = M.from(r, r.offset, r.byteLength)), ce(i, d) && (i = M.from(i, i.offset, i.byteLength)), !M.isBuffer(r) || !M.isBuffer(i))
      throw new TypeError(
        'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
      );
    if (r === i)
      return 0;
    let h = r.length, C = i.length;
    for (let N = 0, E = Math.min(h, C); N < E; ++N)
      if (r[N] !== i[N]) {
        h = r[N], C = i[N];
        break;
      }
    return h < C ? -1 : C < h ? 1 : 0;
  }, M.isEncoding = function(r) {
    switch (String(r).toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "latin1":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return !0;
      default:
        return !1;
    }
  }, M.concat = function(r, i) {
    if (!Array.isArray(r))
      throw new TypeError('"list" argument must be an Array of Buffers');
    if (r.length === 0)
      return M.alloc(0);
    let h;
    if (i === void 0)
      for (i = 0, h = 0; h < r.length; ++h)
        i += r[h].length;
    const C = M.allocUnsafe(i);
    let N = 0;
    for (h = 0; h < r.length; ++h) {
      let E = r[h];
      if (ce(E, d))
        N + E.length > C.length ? (M.isBuffer(E) || (E = M.from(E)), E.copy(C, N)) : d.prototype.set.call(
          C,
          E,
          N
        );
      else if (M.isBuffer(E))
        E.copy(C, N);
      else
        throw new TypeError('"list" argument must be an Array of Buffers');
      N += E.length;
    }
    return C;
  };
  function ye(l, r) {
    if (M.isBuffer(l))
      return l.length;
    if (c.isView(l) || ce(l, c))
      return l.byteLength;
    if (typeof l != "string")
      throw new TypeError(
        'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof l
      );
    const i = l.length, h = arguments.length > 2 && arguments[2] === !0;
    if (!h && i === 0)
      return 0;
    let C = !1;
    for (; ; )
      switch (r) {
        case "ascii":
        case "latin1":
        case "binary":
          return i;
        case "utf8":
        case "utf-8":
          return Le(l).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return i * 2;
        case "hex":
          return i >>> 1;
        case "base64":
          return Ae(l).length;
        default:
          if (C)
            return h ? -1 : Le(l).length;
          r = ("" + r).toLowerCase(), C = !0;
      }
  }
  M.byteLength = ye;
  function se(l, r, i) {
    let h = !1;
    if ((r === void 0 || r < 0) && (r = 0), r > this.length || ((i === void 0 || i > this.length) && (i = this.length), i <= 0) || (i >>>= 0, r >>>= 0, i <= r))
      return "";
    for (l || (l = "utf8"); ; )
      switch (l) {
        case "hex":
          return w(this, r, i);
        case "utf8":
        case "utf-8":
          return f(this, r, i);
        case "ascii":
          return v(this, r, i);
        case "latin1":
        case "binary":
          return U(this, r, i);
        case "base64":
          return re(this, r, i);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return j(this, r, i);
        default:
          if (h)
            throw new TypeError("Unknown encoding: " + l);
          l = (l + "").toLowerCase(), h = !0;
      }
  }
  M.prototype._isBuffer = !0;
  function te(l, r, i) {
    const h = l[r];
    l[r] = l[i], l[i] = h;
  }
  M.prototype.swap16 = function() {
    const r = this.length;
    if (r % 2 !== 0)
      throw new RangeError("Buffer size must be a multiple of 16-bits");
    for (let i = 0; i < r; i += 2)
      te(this, i, i + 1);
    return this;
  }, M.prototype.swap32 = function() {
    const r = this.length;
    if (r % 4 !== 0)
      throw new RangeError("Buffer size must be a multiple of 32-bits");
    for (let i = 0; i < r; i += 4)
      te(this, i, i + 3), te(this, i + 1, i + 2);
    return this;
  }, M.prototype.swap64 = function() {
    const r = this.length;
    if (r % 8 !== 0)
      throw new RangeError("Buffer size must be a multiple of 64-bits");
    for (let i = 0; i < r; i += 8)
      te(this, i, i + 7), te(this, i + 1, i + 6), te(this, i + 2, i + 5), te(this, i + 3, i + 4);
    return this;
  }, M.prototype.toString = function() {
    const r = this.length;
    return r === 0 ? "" : arguments.length === 0 ? f(this, 0, r) : se.apply(this, arguments);
  }, M.prototype.toLocaleString = M.prototype.toString, M.prototype.equals = function(r) {
    if (!M.isBuffer(r))
      throw new TypeError("Argument must be a Buffer");
    return this === r ? !0 : M.compare(this, r) === 0;
  }, M.prototype.inspect = function() {
    let r = "";
    const i = e.INSPECT_MAX_BYTES;
    return r = this.toString("hex", 0, i).replace(/(.{2})/g, "$1 ").trim(), this.length > i && (r += " ... "), "<Buffer " + r + ">";
  }, s && (M.prototype[s] = M.prototype.inspect), M.prototype.compare = function(r, i, h, C, N) {
    if (ce(r, d) && (r = M.from(r, r.offset, r.byteLength)), !M.isBuffer(r))
      throw new TypeError(
        'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof r
      );
    if (i === void 0 && (i = 0), h === void 0 && (h = r ? r.length : 0), C === void 0 && (C = 0), N === void 0 && (N = this.length), i < 0 || h > r.length || C < 0 || N > this.length)
      throw new RangeError("out of range index");
    if (C >= N && i >= h)
      return 0;
    if (C >= N)
      return -1;
    if (i >= h)
      return 1;
    if (i >>>= 0, h >>>= 0, C >>>= 0, N >>>= 0, this === r)
      return 0;
    let E = N - C, X = h - i;
    const le = Math.min(E, X), ae = this.slice(C, N), de = r.slice(i, h);
    for (let ne = 0; ne < le; ++ne)
      if (ae[ne] !== de[ne]) {
        E = ae[ne], X = de[ne];
        break;
      }
    return E < X ? -1 : X < E ? 1 : 0;
  };
  function ue(l, r, i, h, C) {
    if (l.length === 0)
      return -1;
    if (typeof i == "string" ? (h = i, i = 0) : i > 2147483647 ? i = 2147483647 : i < -2147483648 && (i = -2147483648), i = +i, Ft(i) && (i = C ? 0 : l.length - 1), i < 0 && (i = l.length + i), i >= l.length) {
      if (C)
        return -1;
      i = l.length - 1;
    } else if (i < 0)
      if (C)
        i = 0;
      else
        return -1;
    if (typeof r == "string" && (r = M.from(r, h)), M.isBuffer(r))
      return r.length === 0 ? -1 : fe(l, r, i, h, C);
    if (typeof r == "number")
      return r = r & 255, typeof d.prototype.indexOf == "function" ? C ? d.prototype.indexOf.call(l, r, i) : d.prototype.lastIndexOf.call(l, r, i) : fe(l, [r], i, h, C);
    throw new TypeError("val must be string, number or Buffer");
  }
  function fe(l, r, i, h, C) {
    let N = 1, E = l.length, X = r.length;
    if (h !== void 0 && (h = String(h).toLowerCase(), h === "ucs2" || h === "ucs-2" || h === "utf16le" || h === "utf-16le")) {
      if (l.length < 2 || r.length < 2)
        return -1;
      N = 2, E /= 2, X /= 2, i /= 2;
    }
    function le(de, ne) {
      return N === 1 ? de[ne] : de.readUInt16BE(ne * N);
    }
    let ae;
    if (C) {
      let de = -1;
      for (ae = i; ae < E; ae++)
        if (le(l, ae) === le(r, de === -1 ? 0 : ae - de)) {
          if (de === -1 && (de = ae), ae - de + 1 === X)
            return de * N;
        } else
          de !== -1 && (ae -= ae - de), de = -1;
    } else
      for (i + X > E && (i = E - X), ae = i; ae >= 0; ae--) {
        let de = !0;
        for (let ne = 0; ne < X; ne++)
          if (le(l, ae + ne) !== le(r, ne)) {
            de = !1;
            break;
          }
        if (de)
          return ae;
      }
    return -1;
  }
  M.prototype.includes = function(r, i, h) {
    return this.indexOf(r, i, h) !== -1;
  }, M.prototype.indexOf = function(r, i, h) {
    return ue(this, r, i, h, !0);
  }, M.prototype.lastIndexOf = function(r, i, h) {
    return ue(this, r, i, h, !1);
  };
  function J(l, r, i, h) {
    i = Number(i) || 0;
    const C = l.length - i;
    h ? (h = Number(h), h > C && (h = C)) : h = C;
    const N = r.length;
    h > N / 2 && (h = N / 2);
    let E;
    for (E = 0; E < h; ++E) {
      const X = parseInt(r.substr(E * 2, 2), 16);
      if (Ft(X))
        return E;
      l[i + E] = X;
    }
    return E;
  }
  function Q(l, r, i, h) {
    return pe(Le(r, l.length - i), l, i, h);
  }
  function V(l, r, i, h) {
    return pe(Ee(r), l, i, h);
  }
  function W(l, r, i, h) {
    return pe(Ae(r), l, i, h);
  }
  function K(l, r, i, h) {
    return pe(ze(r, l.length - i), l, i, h);
  }
  M.prototype.write = function(r, i, h, C) {
    if (i === void 0)
      C = "utf8", h = this.length, i = 0;
    else if (h === void 0 && typeof i == "string")
      C = i, h = this.length, i = 0;
    else if (isFinite(i))
      i = i >>> 0, isFinite(h) ? (h = h >>> 0, C === void 0 && (C = "utf8")) : (C = h, h = void 0);
    else
      throw new Error(
        "Buffer.write(string, encoding, offset[, length]) is no longer supported"
      );
    const N = this.length - i;
    if ((h === void 0 || h > N) && (h = N), r.length > 0 && (h < 0 || i < 0) || i > this.length)
      throw new RangeError("Attempt to write outside buffer bounds");
    C || (C = "utf8");
    let E = !1;
    for (; ; )
      switch (C) {
        case "hex":
          return J(this, r, i, h);
        case "utf8":
        case "utf-8":
          return Q(this, r, i, h);
        case "ascii":
        case "latin1":
        case "binary":
          return V(this, r, i, h);
        case "base64":
          return W(this, r, i, h);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return K(this, r, i, h);
        default:
          if (E)
            throw new TypeError("Unknown encoding: " + C);
          C = ("" + C).toLowerCase(), E = !0;
      }
  }, M.prototype.toJSON = function() {
    return {
      type: "Buffer",
      data: Array.prototype.slice.call(this._arr || this, 0)
    };
  };
  function re(l, r, i) {
    return r === 0 && i === l.length ? t.fromByteArray(l) : t.fromByteArray(l.slice(r, i));
  }
  function f(l, r, i) {
    i = Math.min(l.length, i);
    const h = [];
    let C = r;
    for (; C < i; ) {
      const N = l[C];
      let E = null, X = N > 239 ? 4 : N > 223 ? 3 : N > 191 ? 2 : 1;
      if (C + X <= i) {
        let le, ae, de, ne;
        switch (X) {
          case 1:
            N < 128 && (E = N);
            break;
          case 2:
            le = l[C + 1], (le & 192) === 128 && (ne = (N & 31) << 6 | le & 63, ne > 127 && (E = ne));
            break;
          case 3:
            le = l[C + 1], ae = l[C + 2], (le & 192) === 128 && (ae & 192) === 128 && (ne = (N & 15) << 12 | (le & 63) << 6 | ae & 63, ne > 2047 && (ne < 55296 || ne > 57343) && (E = ne));
            break;
          case 4:
            le = l[C + 1], ae = l[C + 2], de = l[C + 3], (le & 192) === 128 && (ae & 192) === 128 && (de & 192) === 128 && (ne = (N & 15) << 18 | (le & 63) << 12 | (ae & 63) << 6 | de & 63, ne > 65535 && ne < 1114112 && (E = ne));
        }
      }
      E === null ? (E = 65533, X = 1) : E > 65535 && (E -= 65536, h.push(E >>> 10 & 1023 | 55296), E = 56320 | E & 1023), h.push(E), C += X;
    }
    return A(h);
  }
  const g = 4096;
  function A(l) {
    const r = l.length;
    if (r <= g)
      return String.fromCharCode.apply(String, l);
    let i = "", h = 0;
    for (; h < r; )
      i += String.fromCharCode.apply(
        String,
        l.slice(h, h += g)
      );
    return i;
  }
  function v(l, r, i) {
    let h = "";
    i = Math.min(l.length, i);
    for (let C = r; C < i; ++C)
      h += String.fromCharCode(l[C] & 127);
    return h;
  }
  function U(l, r, i) {
    let h = "";
    i = Math.min(l.length, i);
    for (let C = r; C < i; ++C)
      h += String.fromCharCode(l[C]);
    return h;
  }
  function w(l, r, i) {
    const h = l.length;
    (!r || r < 0) && (r = 0), (!i || i < 0 || i > h) && (i = h);
    let C = "";
    for (let N = r; N < i; ++N)
      C += Gi[l[N]];
    return C;
  }
  function j(l, r, i) {
    const h = l.slice(r, i);
    let C = "";
    for (let N = 0; N < h.length - 1; N += 2)
      C += String.fromCharCode(h[N] + h[N + 1] * 256);
    return C;
  }
  M.prototype.slice = function(r, i) {
    const h = this.length;
    r = ~~r, i = i === void 0 ? h : ~~i, r < 0 ? (r += h, r < 0 && (r = 0)) : r > h && (r = h), i < 0 ? (i += h, i < 0 && (i = 0)) : i > h && (i = h), i < r && (i = r);
    const C = this.subarray(r, i);
    return Object.setPrototypeOf(C, M.prototype), C;
  };
  function T(l, r, i) {
    if (l % 1 !== 0 || l < 0)
      throw new RangeError("offset is not uint");
    if (l + r > i)
      throw new RangeError("Trying to access beyond buffer length");
  }
  M.prototype.readUintLE = M.prototype.readUIntLE = function(r, i, h) {
    r = r >>> 0, i = i >>> 0, h || T(r, i, this.length);
    let C = this[r], N = 1, E = 0;
    for (; ++E < i && (N *= 256); )
      C += this[r + E] * N;
    return C;
  }, M.prototype.readUintBE = M.prototype.readUIntBE = function(r, i, h) {
    r = r >>> 0, i = i >>> 0, h || T(r, i, this.length);
    let C = this[r + --i], N = 1;
    for (; i > 0 && (N *= 256); )
      C += this[r + --i] * N;
    return C;
  }, M.prototype.readUint8 = M.prototype.readUInt8 = function(r, i) {
    return r = r >>> 0, i || T(r, 1, this.length), this[r];
  }, M.prototype.readUint16LE = M.prototype.readUInt16LE = function(r, i) {
    return r = r >>> 0, i || T(r, 2, this.length), this[r] | this[r + 1] << 8;
  }, M.prototype.readUint16BE = M.prototype.readUInt16BE = function(r, i) {
    return r = r >>> 0, i || T(r, 2, this.length), this[r] << 8 | this[r + 1];
  }, M.prototype.readUint32LE = M.prototype.readUInt32LE = function(r, i) {
    return r = r >>> 0, i || T(r, 4, this.length), (this[r] | this[r + 1] << 8 | this[r + 2] << 16) + this[r + 3] * 16777216;
  }, M.prototype.readUint32BE = M.prototype.readUInt32BE = function(r, i) {
    return r = r >>> 0, i || T(r, 4, this.length), this[r] * 16777216 + (this[r + 1] << 16 | this[r + 2] << 8 | this[r + 3]);
  }, M.prototype.readBigUInt64LE = Ue(function(r) {
    r = r >>> 0, Ce(r, "offset");
    const i = this[r], h = this[r + 7];
    (i === void 0 || h === void 0) && De(r, this.length - 8);
    const C = i + this[++r] * 2 ** 8 + this[++r] * 2 ** 16 + this[++r] * 2 ** 24, N = this[++r] + this[++r] * 2 ** 8 + this[++r] * 2 ** 16 + h * 2 ** 24;
    return BigInt(C) + (BigInt(N) << BigInt(32));
  }), M.prototype.readBigUInt64BE = Ue(function(r) {
    r = r >>> 0, Ce(r, "offset");
    const i = this[r], h = this[r + 7];
    (i === void 0 || h === void 0) && De(r, this.length - 8);
    const C = i * 2 ** 24 + this[++r] * 2 ** 16 + this[++r] * 2 ** 8 + this[++r], N = this[++r] * 2 ** 24 + this[++r] * 2 ** 16 + this[++r] * 2 ** 8 + h;
    return (BigInt(C) << BigInt(32)) + BigInt(N);
  }), M.prototype.readIntLE = function(r, i, h) {
    r = r >>> 0, i = i >>> 0, h || T(r, i, this.length);
    let C = this[r], N = 1, E = 0;
    for (; ++E < i && (N *= 256); )
      C += this[r + E] * N;
    return N *= 128, C >= N && (C -= Math.pow(2, 8 * i)), C;
  }, M.prototype.readIntBE = function(r, i, h) {
    r = r >>> 0, i = i >>> 0, h || T(r, i, this.length);
    let C = i, N = 1, E = this[r + --C];
    for (; C > 0 && (N *= 256); )
      E += this[r + --C] * N;
    return N *= 128, E >= N && (E -= Math.pow(2, 8 * i)), E;
  }, M.prototype.readInt8 = function(r, i) {
    return r = r >>> 0, i || T(r, 1, this.length), this[r] & 128 ? (255 - this[r] + 1) * -1 : this[r];
  }, M.prototype.readInt16LE = function(r, i) {
    r = r >>> 0, i || T(r, 2, this.length);
    const h = this[r] | this[r + 1] << 8;
    return h & 32768 ? h | 4294901760 : h;
  }, M.prototype.readInt16BE = function(r, i) {
    r = r >>> 0, i || T(r, 2, this.length);
    const h = this[r + 1] | this[r] << 8;
    return h & 32768 ? h | 4294901760 : h;
  }, M.prototype.readInt32LE = function(r, i) {
    return r = r >>> 0, i || T(r, 4, this.length), this[r] | this[r + 1] << 8 | this[r + 2] << 16 | this[r + 3] << 24;
  }, M.prototype.readInt32BE = function(r, i) {
    return r = r >>> 0, i || T(r, 4, this.length), this[r] << 24 | this[r + 1] << 16 | this[r + 2] << 8 | this[r + 3];
  }, M.prototype.readBigInt64LE = Ue(function(r) {
    r = r >>> 0, Ce(r, "offset");
    const i = this[r], h = this[r + 7];
    (i === void 0 || h === void 0) && De(r, this.length - 8);
    const C = this[r + 4] + this[r + 5] * 2 ** 8 + this[r + 6] * 2 ** 16 + (h << 24);
    return (BigInt(C) << BigInt(32)) + BigInt(i + this[++r] * 2 ** 8 + this[++r] * 2 ** 16 + this[++r] * 2 ** 24);
  }), M.prototype.readBigInt64BE = Ue(function(r) {
    r = r >>> 0, Ce(r, "offset");
    const i = this[r], h = this[r + 7];
    (i === void 0 || h === void 0) && De(r, this.length - 8);
    const C = (i << 24) + // Overflow
    this[++r] * 2 ** 16 + this[++r] * 2 ** 8 + this[++r];
    return (BigInt(C) << BigInt(32)) + BigInt(this[++r] * 2 ** 24 + this[++r] * 2 ** 16 + this[++r] * 2 ** 8 + h);
  }), M.prototype.readFloatLE = function(r, i) {
    return r = r >>> 0, i || T(r, 4, this.length), n.read(this, r, !0, 23, 4);
  }, M.prototype.readFloatBE = function(r, i) {
    return r = r >>> 0, i || T(r, 4, this.length), n.read(this, r, !1, 23, 4);
  }, M.prototype.readDoubleLE = function(r, i) {
    return r = r >>> 0, i || T(r, 8, this.length), n.read(this, r, !0, 52, 8);
  }, M.prototype.readDoubleBE = function(r, i) {
    return r = r >>> 0, i || T(r, 8, this.length), n.read(this, r, !1, 52, 8);
  };
  function Y(l, r, i, h, C, N) {
    if (!M.isBuffer(l))
      throw new TypeError('"buffer" argument must be a Buffer instance');
    if (r > C || r < N)
      throw new RangeError('"value" argument is out of bounds');
    if (i + h > l.length)
      throw new RangeError("Index out of range");
  }
  M.prototype.writeUintLE = M.prototype.writeUIntLE = function(r, i, h, C) {
    if (r = +r, i = i >>> 0, h = h >>> 0, !C) {
      const X = Math.pow(2, 8 * h) - 1;
      Y(this, r, i, h, X, 0);
    }
    let N = 1, E = 0;
    for (this[i] = r & 255; ++E < h && (N *= 256); )
      this[i + E] = r / N & 255;
    return i + h;
  }, M.prototype.writeUintBE = M.prototype.writeUIntBE = function(r, i, h, C) {
    if (r = +r, i = i >>> 0, h = h >>> 0, !C) {
      const X = Math.pow(2, 8 * h) - 1;
      Y(this, r, i, h, X, 0);
    }
    let N = h - 1, E = 1;
    for (this[i + N] = r & 255; --N >= 0 && (E *= 256); )
      this[i + N] = r / E & 255;
    return i + h;
  }, M.prototype.writeUint8 = M.prototype.writeUInt8 = function(r, i, h) {
    return r = +r, i = i >>> 0, h || Y(this, r, i, 1, 255, 0), this[i] = r & 255, i + 1;
  }, M.prototype.writeUint16LE = M.prototype.writeUInt16LE = function(r, i, h) {
    return r = +r, i = i >>> 0, h || Y(this, r, i, 2, 65535, 0), this[i] = r & 255, this[i + 1] = r >>> 8, i + 2;
  }, M.prototype.writeUint16BE = M.prototype.writeUInt16BE = function(r, i, h) {
    return r = +r, i = i >>> 0, h || Y(this, r, i, 2, 65535, 0), this[i] = r >>> 8, this[i + 1] = r & 255, i + 2;
  }, M.prototype.writeUint32LE = M.prototype.writeUInt32LE = function(r, i, h) {
    return r = +r, i = i >>> 0, h || Y(this, r, i, 4, 4294967295, 0), this[i + 3] = r >>> 24, this[i + 2] = r >>> 16, this[i + 1] = r >>> 8, this[i] = r & 255, i + 4;
  }, M.prototype.writeUint32BE = M.prototype.writeUInt32BE = function(r, i, h) {
    return r = +r, i = i >>> 0, h || Y(this, r, i, 4, 4294967295, 0), this[i] = r >>> 24, this[i + 1] = r >>> 16, this[i + 2] = r >>> 8, this[i + 3] = r & 255, i + 4;
  };
  function G(l, r, i, h, C) {
    we(r, h, C, l, i, 7);
    let N = Number(r & BigInt(4294967295));
    l[i++] = N, N = N >> 8, l[i++] = N, N = N >> 8, l[i++] = N, N = N >> 8, l[i++] = N;
    let E = Number(r >> BigInt(32) & BigInt(4294967295));
    return l[i++] = E, E = E >> 8, l[i++] = E, E = E >> 8, l[i++] = E, E = E >> 8, l[i++] = E, i;
  }
  function o(l, r, i, h, C) {
    we(r, h, C, l, i, 7);
    let N = Number(r & BigInt(4294967295));
    l[i + 7] = N, N = N >> 8, l[i + 6] = N, N = N >> 8, l[i + 5] = N, N = N >> 8, l[i + 4] = N;
    let E = Number(r >> BigInt(32) & BigInt(4294967295));
    return l[i + 3] = E, E = E >> 8, l[i + 2] = E, E = E >> 8, l[i + 1] = E, E = E >> 8, l[i] = E, i + 8;
  }
  M.prototype.writeBigUInt64LE = Ue(function(r, i = 0) {
    return G(this, r, i, BigInt(0), BigInt("0xffffffffffffffff"));
  }), M.prototype.writeBigUInt64BE = Ue(function(r, i = 0) {
    return o(this, r, i, BigInt(0), BigInt("0xffffffffffffffff"));
  }), M.prototype.writeIntLE = function(r, i, h, C) {
    if (r = +r, i = i >>> 0, !C) {
      const le = Math.pow(2, 8 * h - 1);
      Y(this, r, i, h, le - 1, -le);
    }
    let N = 0, E = 1, X = 0;
    for (this[i] = r & 255; ++N < h && (E *= 256); )
      r < 0 && X === 0 && this[i + N - 1] !== 0 && (X = 1), this[i + N] = (r / E >> 0) - X & 255;
    return i + h;
  }, M.prototype.writeIntBE = function(r, i, h, C) {
    if (r = +r, i = i >>> 0, !C) {
      const le = Math.pow(2, 8 * h - 1);
      Y(this, r, i, h, le - 1, -le);
    }
    let N = h - 1, E = 1, X = 0;
    for (this[i + N] = r & 255; --N >= 0 && (E *= 256); )
      r < 0 && X === 0 && this[i + N + 1] !== 0 && (X = 1), this[i + N] = (r / E >> 0) - X & 255;
    return i + h;
  }, M.prototype.writeInt8 = function(r, i, h) {
    return r = +r, i = i >>> 0, h || Y(this, r, i, 1, 127, -128), r < 0 && (r = 255 + r + 1), this[i] = r & 255, i + 1;
  }, M.prototype.writeInt16LE = function(r, i, h) {
    return r = +r, i = i >>> 0, h || Y(this, r, i, 2, 32767, -32768), this[i] = r & 255, this[i + 1] = r >>> 8, i + 2;
  }, M.prototype.writeInt16BE = function(r, i, h) {
    return r = +r, i = i >>> 0, h || Y(this, r, i, 2, 32767, -32768), this[i] = r >>> 8, this[i + 1] = r & 255, i + 2;
  }, M.prototype.writeInt32LE = function(r, i, h) {
    return r = +r, i = i >>> 0, h || Y(this, r, i, 4, 2147483647, -2147483648), this[i] = r & 255, this[i + 1] = r >>> 8, this[i + 2] = r >>> 16, this[i + 3] = r >>> 24, i + 4;
  }, M.prototype.writeInt32BE = function(r, i, h) {
    return r = +r, i = i >>> 0, h || Y(this, r, i, 4, 2147483647, -2147483648), r < 0 && (r = 4294967295 + r + 1), this[i] = r >>> 24, this[i + 1] = r >>> 16, this[i + 2] = r >>> 8, this[i + 3] = r & 255, i + 4;
  }, M.prototype.writeBigInt64LE = Ue(function(r, i = 0) {
    return G(this, r, i, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  }), M.prototype.writeBigInt64BE = Ue(function(r, i = 0) {
    return o(this, r, i, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  });
  function a(l, r, i, h, C, N) {
    if (i + h > l.length)
      throw new RangeError("Index out of range");
    if (i < 0)
      throw new RangeError("Index out of range");
  }
  function I(l, r, i, h, C) {
    return r = +r, i = i >>> 0, C || a(l, r, i, 4), n.write(l, r, i, h, 23, 4), i + 4;
  }
  M.prototype.writeFloatLE = function(r, i, h) {
    return I(this, r, i, !0, h);
  }, M.prototype.writeFloatBE = function(r, i, h) {
    return I(this, r, i, !1, h);
  };
  function L(l, r, i, h, C) {
    return r = +r, i = i >>> 0, C || a(l, r, i, 8), n.write(l, r, i, h, 52, 8), i + 8;
  }
  M.prototype.writeDoubleLE = function(r, i, h) {
    return L(this, r, i, !0, h);
  }, M.prototype.writeDoubleBE = function(r, i, h) {
    return L(this, r, i, !1, h);
  }, M.prototype.copy = function(r, i, h, C) {
    if (!M.isBuffer(r))
      throw new TypeError("argument should be a Buffer");
    if (h || (h = 0), !C && C !== 0 && (C = this.length), i >= r.length && (i = r.length), i || (i = 0), C > 0 && C < h && (C = h), C === h || r.length === 0 || this.length === 0)
      return 0;
    if (i < 0)
      throw new RangeError("targetStart out of bounds");
    if (h < 0 || h >= this.length)
      throw new RangeError("Index out of range");
    if (C < 0)
      throw new RangeError("sourceEnd out of bounds");
    C > this.length && (C = this.length), r.length - i < C - h && (C = r.length - i + h);
    const N = C - h;
    return this === r && typeof d.prototype.copyWithin == "function" ? this.copyWithin(i, h, C) : d.prototype.set.call(
      r,
      this.subarray(h, C),
      i
    ), N;
  }, M.prototype.fill = function(r, i, h, C) {
    if (typeof r == "string") {
      if (typeof i == "string" ? (C = i, i = 0, h = this.length) : typeof h == "string" && (C = h, h = this.length), C !== void 0 && typeof C != "string")
        throw new TypeError("encoding must be a string");
      if (typeof C == "string" && !M.isEncoding(C))
        throw new TypeError("Unknown encoding: " + C);
      if (r.length === 1) {
        const E = r.charCodeAt(0);
        (C === "utf8" && E < 128 || C === "latin1") && (r = E);
      }
    } else
      typeof r == "number" ? r = r & 255 : typeof r == "boolean" && (r = Number(r));
    if (i < 0 || this.length < i || this.length < h)
      throw new RangeError("Out of range index");
    if (h <= i)
      return this;
    i = i >>> 0, h = h === void 0 ? this.length : h >>> 0, r || (r = 0);
    let N;
    if (typeof r == "number")
      for (N = i; N < h; ++N)
        this[N] = r;
    else {
      const E = M.isBuffer(r) ? r : M.from(r, C), X = E.length;
      if (X === 0)
        throw new TypeError('The value "' + r + '" is invalid for argument "value"');
      for (N = 0; N < h - i; ++N)
        this[N + i] = E[N % X];
    }
    return this;
  };
  const k = {};
  function O(l, r, i) {
    k[l] = class extends i {
      constructor() {
        super(), Object.defineProperty(this, "message", {
          value: r.apply(this, arguments),
          writable: !0,
          configurable: !0
        }), this.name = `${this.name} [${l}]`, this.stack, delete this.name;
      }
      get code() {
        return l;
      }
      set code(C) {
        Object.defineProperty(this, "code", {
          configurable: !0,
          enumerable: !0,
          value: C,
          writable: !0
        });
      }
      toString() {
        return `${this.name} [${l}]: ${this.message}`;
      }
    };
  }
  O(
    "ERR_BUFFER_OUT_OF_BOUNDS",
    function(l) {
      return l ? `${l} is outside of buffer bounds` : "Attempt to access memory outside buffer bounds";
    },
    RangeError
  ), O(
    "ERR_INVALID_ARG_TYPE",
    function(l, r) {
      return `The "${l}" argument must be of type number. Received type ${typeof r}`;
    },
    TypeError
  ), O(
    "ERR_OUT_OF_RANGE",
    function(l, r, i) {
      let h = `The value of "${l}" is out of range.`, C = i;
      return Number.isInteger(i) && Math.abs(i) > 2 ** 32 ? C = P(String(i)) : typeof i == "bigint" && (C = String(i), (i > BigInt(2) ** BigInt(32) || i < -(BigInt(2) ** BigInt(32))) && (C = P(C)), C += "n"), h += ` It must be ${r}. Received ${C}`, h;
    },
    RangeError
  );
  function P(l) {
    let r = "", i = l.length;
    const h = l[0] === "-" ? 1 : 0;
    for (; i >= h + 4; i -= 3)
      r = `_${l.slice(i - 3, i)}${r}`;
    return `${l.slice(0, i)}${r}`;
  }
  function he(l, r, i) {
    Ce(r, "offset"), (l[r] === void 0 || l[r + i] === void 0) && De(r, l.length - (i + 1));
  }
  function we(l, r, i, h, C, N) {
    if (l > i || l < r) {
      const E = typeof r == "bigint" ? "n" : "";
      let X;
      throw N > 3 ? r === 0 || r === BigInt(0) ? X = `>= 0${E} and < 2${E} ** ${(N + 1) * 8}${E}` : X = `>= -(2${E} ** ${(N + 1) * 8 - 1}${E}) and < 2 ** ${(N + 1) * 8 - 1}${E}` : X = `>= ${r}${E} and <= ${i}${E}`, new k.ERR_OUT_OF_RANGE("value", X, l);
    }
    he(h, C, N);
  }
  function Ce(l, r) {
    if (typeof l != "number")
      throw new k.ERR_INVALID_ARG_TYPE(r, "number", l);
  }
  function De(l, r, i) {
    throw Math.floor(l) !== l ? (Ce(l, i), new k.ERR_OUT_OF_RANGE(i || "offset", "an integer", l)) : r < 0 ? new k.ERR_BUFFER_OUT_OF_BOUNDS() : new k.ERR_OUT_OF_RANGE(
      i || "offset",
      `>= ${i ? 1 : 0} and <= ${r}`,
      l
    );
  }
  const be = /[^+/0-9A-Za-z-_]/g;
  function x(l) {
    if (l = l.split("=")[0], l = l.trim().replace(be, ""), l.length < 2)
      return "";
    for (; l.length % 4 !== 0; )
      l = l + "=";
    return l;
  }
  function Le(l, r) {
    r = r || 1 / 0;
    let i;
    const h = l.length;
    let C = null;
    const N = [];
    for (let E = 0; E < h; ++E) {
      if (i = l.charCodeAt(E), i > 55295 && i < 57344) {
        if (!C) {
          if (i > 56319) {
            (r -= 3) > -1 && N.push(239, 191, 189);
            continue;
          } else if (E + 1 === h) {
            (r -= 3) > -1 && N.push(239, 191, 189);
            continue;
          }
          C = i;
          continue;
        }
        if (i < 56320) {
          (r -= 3) > -1 && N.push(239, 191, 189), C = i;
          continue;
        }
        i = (C - 55296 << 10 | i - 56320) + 65536;
      } else
        C && (r -= 3) > -1 && N.push(239, 191, 189);
      if (C = null, i < 128) {
        if ((r -= 1) < 0)
          break;
        N.push(i);
      } else if (i < 2048) {
        if ((r -= 2) < 0)
          break;
        N.push(
          i >> 6 | 192,
          i & 63 | 128
        );
      } else if (i < 65536) {
        if ((r -= 3) < 0)
          break;
        N.push(
          i >> 12 | 224,
          i >> 6 & 63 | 128,
          i & 63 | 128
        );
      } else if (i < 1114112) {
        if ((r -= 4) < 0)
          break;
        N.push(
          i >> 18 | 240,
          i >> 12 & 63 | 128,
          i >> 6 & 63 | 128,
          i & 63 | 128
        );
      } else
        throw new Error("Invalid code point");
    }
    return N;
  }
  function Ee(l) {
    const r = [];
    for (let i = 0; i < l.length; ++i)
      r.push(l.charCodeAt(i) & 255);
    return r;
  }
  function ze(l, r) {
    let i, h, C;
    const N = [];
    for (let E = 0; E < l.length && !((r -= 2) < 0); ++E)
      i = l.charCodeAt(E), h = i >> 8, C = i % 256, N.push(C), N.push(h);
    return N;
  }
  function Ae(l) {
    return t.toByteArray(x(l));
  }
  function pe(l, r, i, h) {
    let C;
    for (C = 0; C < h && !(C + i >= r.length || C >= l.length); ++C)
      r[C + i] = l[C];
    return C;
  }
  function ce(l, r) {
    return l instanceof r || l != null && l.constructor != null && l.constructor.name != null && l.constructor.name === r.name;
  }
  function Ft(l) {
    return l !== l;
  }
  const Gi = function() {
    const l = "0123456789abcdef", r = new Array(256);
    for (let i = 0; i < 16; ++i) {
      const h = i * 16;
      for (let C = 0; C < 16; ++C)
        r[h + C] = l[i] + l[C];
    }
    return r;
  }();
  function Ue(l) {
    return typeof BigInt > "u" ? Wi : l;
  }
  function Wi() {
    throw new Error("BigInt not supported");
  }
})(_r);
const so = _r.Buffer, uo = _r.Buffer, co = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Buffer: uo,
  default: so
}, Symbol.toStringTag, { value: "Module" }));
function qr() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}
const lo = (e) => {
  const t = {};
  function n(s, u = "") {
    for (const d in s) {
      const c = s[d], p = u ? `${u}.${d}` : d;
      typeof c == "object" && "code" in c && typeof c.code == "number" && typeof c.documentation == "string" && typeof c.message == "string" ? t[p] = {
        code: c.code,
        message: c.message,
        documentation: c.documentation
      } : typeof c == "object" && n(c, p);
    }
  }
  return n(e), t;
}, Dt = `
    <svg width="110" height="110" viewBox="0 0 110 110" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.00745909 26.3991C0.00745909 11.815 11.8292 0 26.4048 0H83.6027C98.1857 0 110 11.8225 110 26.3991V83.6009C110 98.185 98.1783 110 83.6027 110H26.2704C11.762 110 0 98.2372 0 83.7278V26.3917L0.00745909 26.3991Z" fill="url(#paint0_linear_2187_113375)"/>
        <path d="M6.35721 29.6979C6.35721 16.8006 16.8131 6.34399 29.7095 6.34399H80.31C93.2064 6.34399 103.662 16.8006 103.662 29.6979V80.3018C103.662 93.1991 93.2064 103.656 80.31 103.656H29.5901C16.7534 103.656 6.34974 93.2513 6.34974 80.4138V29.6904L6.35721 29.6979Z" fill="black"/>
        <path d="M12.6995 32.9969C12.6995 21.7789 21.7896 12.6881 33.0068 12.6881H77.0098C88.227 12.6881 97.3171 21.7789 97.3171 32.9969V77.0029C97.3171 88.2208 88.227 97.3116 77.0098 97.3116H32.9098C21.7523 97.3116 12.7069 88.2656 12.7069 77.0999V32.9969H12.6995Z" fill="white"/>
        <path d="M45.7361 59.2219C49.8786 52.0466 48.6935 43.6066 43.0892 40.3708C37.485 37.1349 29.5838 40.3286 25.4414 47.5039C21.2989 54.6793 22.484 63.1192 28.0882 66.355C33.6925 69.5909 41.5937 66.3973 45.7361 59.2219Z" fill="black"/>
        <path d="M41.3015 52.747C43.7375 52.747 45.7123 50.7721 45.7123 48.3359C45.7123 45.8998 43.7375 43.9249 41.3015 43.9249C38.8656 43.9249 36.8908 45.8998 36.8908 48.3359C36.8908 50.7721 38.8656 52.747 41.3015 52.747Z" fill="white"/>
        <path d="M82.1606 66.4148C87.7649 63.1789 88.9499 54.739 84.8075 47.5636C80.6651 40.3883 72.7639 37.1947 67.1596 40.4305C61.5554 43.6663 60.3703 52.1063 64.5127 59.2817C68.6551 66.457 76.5564 69.6506 82.1606 66.4148Z" fill="black"/>
        <path d="M68.9501 52.814C71.3861 52.814 73.3608 50.8392 73.3608 48.403C73.3608 45.9669 71.3861 43.9919 68.9501 43.9919C66.5141 43.9919 64.5393 45.9669 64.5393 48.403C64.5393 50.8392 66.5141 52.814 68.9501 52.814Z" fill="white"/>
        <path d="M55.1234 71.4422C55.1234 71.4422 51.9739 71.3153 50.8469 72.1213C49.72 72.9274 49.7946 74.1739 49.7946 74.1739C49.7946 74.1739 49.6454 75.4501 50.0185 76.2786C50.3917 77.1071 52.5784 76.9653 53.6531 78.8088C53.6531 78.8088 54.6382 79.1447 55.1234 79.0477" fill="black"/>
        <path d="M55.1234 71.4422C55.1234 71.4422 58.273 71.3154 59.4 72.1215C60.5269 72.9276 60.4523 74.174 60.4523 74.174C60.4523 74.174 60.6015 75.4503 60.2284 76.2788C59.8552 77.1073 57.6685 76.9655 56.5938 78.809C56.5938 78.809 55.6085 79.1447 55.1234 79.0477" fill="black"/>
        <defs>
            <linearGradient id="paint0_linear_2187_113375" x1="55" y1="0" x2="55" y2="123.049" gradientUnits="userSpaceOnUse">
                <stop stop-color="currentColor"/>
                <stop offset="1" stop-color="currentColor" stop-opacity="0.4"/>
            </linearGradient>
        </defs>
    </svg>
`, fo = (e) => `
  .error-container {
    height: 100%;
    text-align: center;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    padding: ${e.custom.gutterMargin} 0;
    gap: ${e.custom.gutterMargin};
  }
  .error-logo {
    height: ${e.custom.imgSize.large};
    width: ${e.custom.imgSize.large};
  }
  .error-title {
    color: ${e.palette.error.main};
  }
  .error-content {
    color: ${e.palette.error.main};
    text-align: center;
    font-size: ${e.typography(e.palette).body1.fontSize};;
    font-weight: normal;
  }
`, go = (e, { error: t }) => `
  <section class="error-container">
    <div class="error-logo cede-logo">
      ${Dt}
    </div>
    <h1 class="error-title">
      Error
    </h1>
    <h2 class="error-content">
      ${t}
    </h2>
  </section>
`, ho = {
  style: fo,
  html: go
}, en = "https://discord.gg/V7hgKf6NWf", po = (e) => `
  .help-container {
    position: absolute;
    top: 2%;
    right: 4%;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: ${e.custom.smallGutterMargin};
    z-index: 3;
  }

  .help-button {
    cursor: pointer;
    display: inline-flex;
    border-radius: 100%;
    border: none;
    background: transparent;
  }

  .help-button svg {
    fill: ${e.palette.text.primary};
  }

  .help-popper__hidden {
    display: none;
  }

  .help-popper__exit {
    animation: scale-out 0.2s ease-in-out forwards;
  }

  .help-popper__visible {
    animation: scale-in 0.2s ease-in;
  }

  .help-popper {
    transform-origin: top right;
    background: ${e.palette.background.help};
    padding: ${e.custom.smallGutterMargin};
    border-radius: ${e.custom.buttonDefaultRadius}px;
  }

  .help-popper a {
    text-decoration: none;
    transition: 0.2s;
    display: inline-flex;
    align-items: center;
    gap: ${e.custom.gutterMargin};
  }

  .help-popper a:hover {
    opacity: 0.6;
  }

  .help-popper svg {
    fill: ${e.palette.text.primary};
  }

  .help-inner-icon {
    fill: ${e.palette.background.default};
  }

  @keyframes scale-in {
    from {
      transform: scale(0.7);
      opacity: 0;
    }
    to {
      transform: scale(1);
      opacity: 1;
    }
  }

  @keyframes scale-out {
    from {
      transform: scale(1);
      opacity: 1;
    }
    to {
      transform: scale(0.7);
      opacity: 0;
    }
  }
`, yo = () => `
  <div class="help-container">
    <a href="${en}" target="_blank" id="help-button" class="help-button">
     <svg width="20" height="20" focusable="false" aria-hidden="true" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z">
        </path>
      </svg>
    </a>
    <div id="help-popper" class="help-popper help-popper__hidden">
      <a href="${en}" target="_blank">
        Get help on Discord 
        <svg width="24" height="24" focusable="false" aria-hidden="true" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24 12C24 18.627 18.627 24 12 24C5.373 24 0 18.627 0 12C0 5.373 5.373 0 12 0C18.627 0 24 5.373 24 12Z"
          />
          <path
            fill="transparent"
            class="help-inner-icon"
            d="M16.8515 7.82936C15.959 7.44605 15.0024 7.16274 14.002 7.00164C13.9931 7.00001 13.9839 7.00106 13.9756 7.00464C13.9674 7.00823 13.9605 7.01416 13.9559 7.02164C13.8334 7.22662 13.6969 7.49383 13.6013 7.70493C12.5403 7.55396 11.4616 7.55396 10.4006 7.70493C10.2941 7.47097 10.1739 7.24286 10.0407 7.02164C10.0362 7.01407 10.0294 7.008 10.0211 7.00423C10.0129 7.00046 10.0037 6.99917 9.99464 7.00053C8.99483 7.16163 8.03819 7.44494 7.14513 7.82881C7.13745 7.83188 7.13094 7.83711 7.12647 7.84381C5.31119 10.3853 4.81362 12.864 5.05803 15.3116C5.05871 15.3176 5.06066 15.3234 5.06377 15.3287C5.06688 15.3339 5.07108 15.3385 5.07611 15.3422C6.13564 16.0768 7.31741 16.6365 8.57193 16.9976C8.58067 17.0002 8.59003 17.0002 8.59877 16.9976C8.60751 16.9951 8.61523 16.99 8.62092 16.9832C8.89088 16.6394 9.1301 16.2746 9.33607 15.8927C9.33893 15.8875 9.34058 15.8818 9.3409 15.8759C9.34123 15.87 9.34022 15.8641 9.33795 15.8586C9.33569 15.8532 9.33221 15.8482 9.32776 15.8441C9.32331 15.84 9.31799 15.8369 9.31216 15.8349C8.93534 15.6998 8.57023 15.5367 8.22019 15.3472C8.2139 15.3438 8.2086 15.3389 8.20476 15.3331C8.20093 15.3272 8.19868 15.3206 8.19822 15.3137C8.19775 15.3068 8.19909 15.2999 8.20211 15.2936C8.20513 15.2874 8.20974 15.2819 8.21552 15.2778C8.28902 15.2261 8.36252 15.1722 8.43251 15.1183C8.43882 15.1135 8.44641 15.1104 8.45444 15.1094C8.46247 15.1084 8.47063 15.1096 8.47801 15.1128C10.7687 16.0927 13.2495 16.0927 15.5134 15.1128C15.5208 15.1094 15.529 15.1081 15.5372 15.109C15.5453 15.1099 15.5531 15.1129 15.5595 15.1178C15.6295 15.1722 15.7024 15.2261 15.7765 15.2778C15.7823 15.2818 15.787 15.2872 15.7901 15.2934C15.7932 15.2996 15.7947 15.3065 15.7943 15.3134C15.794 15.3203 15.7918 15.3269 15.7881 15.3329C15.7844 15.3388 15.7792 15.3437 15.773 15.3472C15.4241 15.5383 15.0613 15.7 14.6804 15.8344C14.6746 15.8364 14.6692 15.8396 14.6648 15.8437C14.6603 15.8479 14.6569 15.8529 14.6546 15.8584C14.6523 15.8639 14.6513 15.8698 14.6517 15.8758C14.652 15.8817 14.6536 15.8875 14.6565 15.8927C14.8665 16.2744 15.1068 16.6377 15.3711 16.9826C15.3766 16.9897 15.3842 16.995 15.393 16.9978C15.4017 17.0006 15.4112 17.0007 15.4201 16.9982C16.6767 16.638 17.8604 16.0781 18.9211 15.3422C18.9263 15.3388 18.9306 15.3343 18.9339 15.3291C18.9371 15.3239 18.9391 15.3182 18.9398 15.3122C19.2315 12.4824 18.451 10.0237 16.8696 7.84492C16.8657 7.83784 16.8593 7.83232 16.8515 7.82936ZM9.67848 13.8212C8.989 13.8212 8.42026 13.2273 8.42026 12.4991C8.42026 11.7702 8.97791 11.1769 9.67848 11.1769C10.3843 11.1769 10.9478 11.7752 10.9367 12.4991C10.9367 13.2279 10.379 13.8212 9.67848 13.8212ZM14.3304 13.8212C13.6404 13.8212 13.0722 13.2273 13.0722 12.4991C13.0722 11.7702 13.6293 11.1769 14.3304 11.1769C15.0362 11.1769 15.5997 11.7752 15.5886 12.4991C15.5886 13.2279 15.0368 13.8212 14.3304 13.8212Z"
          />
        </svg>
      </a>

    </div>
  </div>
`, Mo = (e) => {
  const t = e.html.querySelector(".help-container"), n = e.html.querySelector("#help-button"), s = e.html.querySelector("#help-popper");
  let u = !1;
  if (!n || !s || !t)
    throw new Error("Could not find help button or popper");
  n.addEventListener("mouseenter", () => {
    u = !0, s.classList.remove("help-popper__hidden"), s.classList.remove("help-popper__exit"), s.classList.add("help-popper__visible");
  }), t.addEventListener("mouseleave", () => {
    u = !1, s.classList.add("help-popper__exit"), s.classList.remove("help-popper__visible"), setTimeout(() => {
      u || (s.classList.add("help-popper__hidden"), s.classList.remove("help-popper__exit"));
    }, 250);
  });
}, Io = {
  style: po,
  html: yo,
  action: Mo
}, wo = "data:image/svg+xml;base64,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", Co = (e) => `
  .loader-container {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0;
    left: 0;
    background: ${e.palette.background.default};
  }


  .cede-loader-wrapper {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    height: ${e.custom.imgSize.large};
    width: ${e.custom.imgSize.large};
    padding: 6px;
    overflow: hidden;
    border-radius: 25%;
    box-sizing: border-box;
  }

  .cede-loader-wrapper::before {
    content: "";
    position: absolute;
    top: -20px;
    bottom: -20px;
    left: -20px;
    right: -20px;
    background: linear-gradient(${e.palette.logoBorderColor}, ${e.palette.logoBorderColor}, ${e.palette.logoBorderColor}, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1));
    z-index: 0;
    border-radius: 50%;
    animation: spinner-spin 2s linear infinite;
  }

  @keyframes spinner-spin {
    100% {
      transform: rotate(360deg); 
    }
  }

  .cede-loader-img {
    height: 100%;
    width: 100%;
    z-index: 1;
  }
`, Ao = () => `
  <div id="cede-loader" class="loader-container">
    <div class="cede-loader-wrapper">
      <img class="cede-loader-img" src="${wo}" />
    </div>
  </div>
`, Lo = {
  style: Co,
  html: Ao
}, mo = "data:image/svg+xml;base64,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", jo = (e) => `
  .modal-container {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    height: 100%;
    width: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    animation: fade-in 0.3s ease-in-out;
  }

  .modal {
    max-width: 100%;
    width: 600px;
    height: 500px;
    border-radius: 14px;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    background: ${e.palette.background.default};
    overflow-y: auto;
    overflow-x: hidden;
    box-shadow: 0px 4px 70px 50px #5EA6FF26;
  }

  .modal-header {
    display: flex;
    flex-direction: row-reverse;
    width: auto;
    min-height: 50px;
    padding: 8px;
  }

  .close-icon {
    width: 24px;
    height: 24px;
    fill: rgb(155, 155, 155);
  }

  .modal-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: calc(100% - 50px);
    overflow: hidden;
    padding: 10px 50px 25px 50px;
    justify-content: space-between;
  }

  .modal-title {
    width: 100%;
  }

  .modal-title img {
    width: 110px;
    height: 110px;
  }

  .modal-title h1 {
    font-weight: 600;
    margin-top: 28px;
    font-size: 24px;
    color: ${e.palette.text.primary};
  }

  .modal-title h1 span {
    color: ${e.palette.primary.main};
  }

  .modal-title p {
    font-size: 14px;
    color: ${e.palette.text.secondary};
    line-height: 18px;
    font-weight: 400;
    margin-top: 20px;
  }

  .modal-title p.modal-content-last {
    margin-top: 35px;
  }

  .modal-title p strong {
    color: ${e.palette.text.secondary};
  }

  .modal-content-image:hover {
    box-shadow: 0px 0px 20px 14px rgba(94, 166, 255, 0.31);
  }
  
  .modal-content-image {
    margin-top: 20px;
    transition: box-shadow 0.3s ease-in-out;
    box-shadow: 0px 0px 0px 0px rgba(94, 166, 255, 0.31);
    height: 67px;
    width: 220px;
    border: 1px solid ${e.palette.cedeComponentHr};
    border-radius: 13px;
    padding: 0 10px;
    cursor: pointer;
  }

  .modal-banner-link {
    color: ${e.palette.text.secondary};
    margin-top: 20px;
  }
`, No = () => `
  <div class="modal-container" id="cede-modal-onboarding">
    <div class="modal">
      <header class="modal-header">
        <button class="icon-button" id="close-modal">
          <svg class="close-icon" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="CloseIcon"><path d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path></svg>
        </button>
      </header>
      <section class="modal-content">
        <div class="modal-title">
          <div class="cede-logo">
            ${Dt}
          </div>
          <h1>
            <span>Cede.store</span>
            is not detected
          </h1>
          <p>
            To proceed, you will need to <strong>download</strong> the extension from the 
            <strong>Chrome Web Store</strong>. Let you guide by the <strong>onboarding flow</strong>.
          </p>
          <p class="modal-content-last">
            Click below to access the Chrome Web Store
          </p>
        </div>
        <img id="chrome-web-store" src=${mo} class="modal-content-image" alt="Download from Chrome Web Store" />
        <a href="https://cede.store" target="_blank" class="modal-banner-link">
          Discover more about cede.store
        </a>
      </section>
    </div>
  </div>
`, Do = (e) => (t, n) => {
  const s = t.html.querySelector("#close-modal"), u = t.html.querySelector("#chrome-web-store");
  !s || !u || (s.addEventListener("click", () => {
    n.remove(t);
  }), u.addEventListener("click", () => {
    localStorage.setItem("cede.store-onboarding", JSON.stringify(e ?? {})), window.open("https://chrome.google.com/webstore/detail/cedestore/dcfphbfmjohnlcpelbhfbjolhmmlcbhd", "_blank");
  }));
}, bo = (e) => ({
  style: jo,
  html: No,
  action: Do(e)
}), To = (e) => `
  .login-container {
    height: 100%;
    width: 100%;
    padding: ${e.custom.gutterMargin} 0;
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    flex-direction: column;
    box-sizing: border-box;
  }

  .login-banner {
    margin-top: 122px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .login-logo {
    height: ${e.custom.imgSize.large};
    width: ${e.custom.imgSize.large};
    margin-bottom: ${e.custom.gutterMargin};
  }

  .login-title {
    font-size: 20px;
    margin-bottom: 4px;
  }

  .login-title-link {
    font-size: 20px;
    color: ${e.palette.primary.main};
    display: inline;
    text-decoration: none;
  }

  .login-title-link:hover {
    text-decoration: underline;
  }

  .login-title-2 {
    margin-top: 4px;
    font-size: ${e.typography(e.palette).body1.fontSize};
    font-weight: normal;
    color: ${e.palette.text.secondary};
    text-align: center;
  }

  .login-footer {
    margin-top: 40px;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: ${e.custom.gutterMargin};
    padding-top: ${e.custom.bigGutterMargin};
  }
`, So = () => `
  <section class="login-container">
    <div class="login-banner">
      <div class="login-logo cede-logo">
        ${Dt}
      </div>
      <h1 class="login-title">
        Welcome to <a href="https://cede.store" target="_blank" class="login-title-link">cede.store</a> send portal
      </h1>
      <h2 class="login-title-2">
        ${Cr.WIDGETS.SEND.TRANSFER_CEX_ASSETS}
      </h2>
    </div>
    <div class="login-footer">
      <button class="cede-button" data-testid="widget-connect-button" id="login-btn">${Cr.WIDGETS.SEND.CONNECT}</button>
    </div>
  </section>
`, Eo = (e, t) => {
  const n = e.html.querySelector("#login-btn");
  n && n.addEventListener("click", () => {
    t.renderHtml(bo(), { clearPrevious: !1, animateOnExit: !0 });
  });
}, xo = {
  style: To,
  html: So,
  action: Eo
}, vo = "data:image/svg+xml;base64,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", Oo = (e) => `
  .not-supported-container {
    height: 100%;
    width: 100%;
    padding: ${e.custom.gutterMargin} 0;
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    flex-direction: column;
  }

  .not-supported-banner {
    text-align: center;
    margin-top: 116px;
  }

  .not-supported-logo {
    height: ${e.custom.imgSize.large};
    width: ${e.custom.imgSize.large};
  }

  .not-supported-title {
    font-size: 20px;
    font-weight: 600;
    color: ${e.palette.text.primary};
    margin-top: ${e.custom.gutterMargin};
    line-height: 1.167;
  }

  .not-supported-title span {
    font-size: 20px;
    color: ${e.palette.primary.main};
    display: inline;
  }

  .not-supported-banner-retry {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: ${e.custom.gutterMargin};
    padding-top: ${e.custom.gutterMargin};
  }

  .not-supported-banner-retry p {
    color: ${e.palette.text.secondary};
  }

  .not-supported-footer {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: ${e.custom.gutterMargin};
    margin-top: 40px;
  }

  .not-supported-banner-link {
    color: ${e.palette.text.secondary};
    margin-top: ${e.custom.smallGutterMargin};
    display: inline-flex;
    align-items: center;
    gap: ${e.custom.smallGutterMargin};
  }
  
  .not-supported-banner-link path {
    stroke: ${e.palette.text.secondary};
  }
`, zo = () => `
  <section id="not-supported-page" class="not-supported-container">
    <div class="not-supported-banner">
      <div class="not-supported-logo cede-logo">
        ${Dt}
      </div>
      <h1 class="not-supported-title">
        <span>Cede.store</span>
        send portal is not available on ${qr() ? "mobile" : "your current browser"}.
      </h1>
      <div class="not-supported-banner-retry">
        <p>
          Retry on a ${qr() ? "desktop" : ""} chromium browser.
        </p>
        <img src="${vo}" width="20" alt="Google Chrome Icon" />
      </div>
      <a
        href="https://en.wikipedia.org/wiki/Chromium_(web_browser)#Active"
        target="_blank"
        rel="noopener noreferrer"
        class="not-supported-banner-link"
      >
        List of compatible browser 
        <svg width="13" height="13" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M11 1H7.66667M11 1L6 6M11 1V4.33333" stroke="#B8B8B8" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M11 6.55556V9.88889C11 10.5026 10.5026 11 9.88889 11H2.11111C1.49746 11 1 10.5026 1 9.88889V2.11111C1 1.49746 1.49746 1 2.11111 1H5.44444" stroke="#B8B8B8" stroke-linecap="round"/>
        </svg>
      </a>
    </div>
    <div class="not-supported-footer">
      <button class="cede-button" id="return-to-menu">Return to the menu</button>
    </div>
  </section>
`, ko = (e) => {
  const t = e.html.querySelector("#return-to-menu");
  if (!t)
    throw new Error("Could not find button");
  t.addEventListener("click", () => {
    window.location.href = "/";
  });
}, _o = {
  style: Oo,
  html: zo,
  action: ko
}, Bo = (e) => `
  * {
    color: ${e.palette.text.primary};
    font-family: ${e.typography(e.palette).fontFamily};
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  .cede-layout {
    position: relative;
    overflow: hidden;
    max-width: ${e.custom.storeSize.widgetMaxWidth};
    min-width: ${e.custom.storeSize.widgetMinWidth};
    background: ${e.palette.background.default};
    width: ${e.custom.storeSize.widgetWidth};
    height: ${e.custom.storeSize.widgetHeight};
    border-radius: 12px;
    padding: 12px;
    border: 1px solid transparent;
  }

  .component-container {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    padding: 12px;
    box-sizing: border-box;
  }

  .cede-button {
    height: 50px;
    border-radius: 14px;
    background: ${e.palette.primary.main};
    color: ${e.palette.text.primary};
    border: none;
    color: rgba(0, 0, 0, 0.87);
    cursor: pointer;
    width: 100%;
    font-size: ${e.typography(e.palette).body1.fontSize};
  }

  .icon-button {
    border: none;
    background: transparent;
    cursor: pointer;
  }

  .cede-logo, .cede-logo * {
    color: ${e.palette.logoBorderColor};
    display: inline-block;
  }

  .animate-exit {
    z-index: 2;
    animation: fade-out .5s ease-in forwards;
  }

  @keyframes fade-out {
    from { opacity: 1; }
    to { opacity: 0; }
  }

  @keyframes fade-in {
    from { opacity: 0; }
    to { opacity: 1; }
  }
`;
class Ro {
  constructor(t, n, s) {
    // Shadow dom to isolate styles
    Me(this, "shadow");
    // Layout to contain components
    Me(this, "layout");
    // Keep track of active components to remove them later
    Me(this, "activeComponents", []);
    this.root = t, this.theme = n, this.config = s;
    const u = document.createElement("div");
    this.root.appendChild(u), this.shadow = u.attachShadow({ mode: "open" });
    const d = document.createElement("style");
    d.innerHTML = Bo(this.theme), d.id = "cede-global-style", this.shadow.appendChild(d), this.layout = document.createElement("div"), (s == null ? void 0 : s.displayLayout) !== !1 && this.layout.classList.add("cede-layout"), this.layout.id = "cede-layout", this.shadow.appendChild(this.layout);
  }
  renderHtml(t, { clearPrevious: n = !0, animateOnExit: s = !1, layout: u = !1, data: d = {} } = {}) {
    var D;
    (D = this.activeComponents) != null && D.length && n && !u && (this.activeComponents.forEach((M) => this.remove(M)), this.activeComponents = []);
    const c = document.createElement("style");
    c.innerHTML = t.style(this.theme), this.shadow.appendChild(c), t.name && (c.id = `${t.name}-style`);
    const p = document.createElement("div");
    p.classList.add("component-container"), p.innerHTML = t.html(this.config, d), this.layout.appendChild(p), t.name && (p.id = `${t.name}-html`);
    const y = { style: c, html: p, opts: { animateOnExit: s } };
    u || this.activeComponents.push(y), t.action && t.action(y, this);
  }
  remove(t) {
    var n;
    if ((n = t.opts) != null && n.animateOnExit) {
      t.html.classList.add("animate-exit"), setTimeout(() => {
        this.layout.removeChild(t.html), this.shadow.removeChild(t.style);
      }, 600);
      return;
    }
    this.layout.removeChild(t.html), this.shadow.removeChild(t.style);
  }
  clear() {
    this.root.innerHTML = "";
  }
}
const Rr = {
  primaryDarkBlue: "#3D4E5B",
  //Grey Blue
  secondaryDarkBlue: "#247CEC",
  //Navy blue
  cedePrimaryColor: "#5EA6FF",
  //Blue
  cedePrimaryColorLight: "#9acfed",
  // This color is not part of the DS can change at any time
  cedeSecondaryColor: "#A6FB74",
  //Green
  cedeSuccessColor: "#A6FB74",
  // Same color as above but this is not a primary color it is a success color
  cedeWarningColor: "#FFA726",
  cedeWarningLightColor: "#E2C395",
  cedeErrorColor: "#f44335",
  cedeSecondaryColorDark: "#0B7400",
  // This color is not part of the DS can change at any time
  cedePrimaryBackgroundColor: "#0A0B0b",
  //Black
  cedeTextPrimaryColor: "#FFFFFF",
  //White
  cedeTextSecondaryColor: "#9B9B9B",
  cedeSecondaryBackgroundColor: "#1B1B1B",
  //Black
  cedeTextGrey: "rgba(255, 255, 255, 0.5)",
  cedeTextDisabled: "rgba(255, 255, 255, 0.7)",
  cedeSkeleton: "rgba(255, 255, 255, 0.2)",
  cedeComponentHr: "rgba(255, 255, 255, 0.12)",
  cedeComponentBackgroundColor: "rgba(255, 255, 255, 0.08)",
  cedeComponentBorderGreyColor: "#A3A3A3",
  cedeComponentHoveredBackgroundColor: "rgba(255, 255, 255, 0.18)",
  cedePaperBackgroundColor: "linear-gradient(180deg, rgba(255, 255, 255, 0.12) 0%, rgba(255, 255, 255, 0.12) 100%), #121212",
  cedePaperLightBackgroundColor: "#373737",
  cedePaperDarkBackgroundColor: "#1F1F1F",
  cedePaperGradientBackground: "linear-gradient(180deg, rgba(255, 255, 255, 0.13) 0%, rgba(255, 255, 255, 0.13) 100%), #121212",
  cedePaperModalGradientBackground: "linear-gradient(180deg, rgba(255, 255, 255, 0.05) 0%, rgba(255, 255, 255, 0.05) 100%), #121212",
  cedeBubbleBackgroundColor: "#616161E5",
  cedeGradientPrimaryBackground: "linear-gradient(140.84deg, #5EA6FF -14.8%, #A6FB75 127.29%);",
  cedeBuyColor: "#11cb81",
  cedeSellColor: "#f5465d",
  cedeHelpBackgroundColor: "#404040"
}, Po = {
  ...Rr,
  cedePrimaryBackgroundColor: "#FFFEFD",
  cedeTextPrimaryColor: "#1B2026",
  cedeTextSecondaryColor: "#525860",
  cedeHelpBackgroundColor: "#EDEDED",
  cedePaperLightBackgroundColor: "#EDEDED",
  cedePaperDarkBackgroundColor: "#F6F6F6",
  cedePaperBackgroundColor: "#FFFEFD",
  cedeTextDisabled: "rgba(54, 63, 77, 0.5)",
  cedeSkeleton: "rgba(54, 63, 77, 0.2)",
  cedeComponentBackgroundColor: "#F6F6F6",
  cedeSuccessColor: "rgb(91, 188, 33)",
  cedeComponentHr: "#EDEDED"
}, Uo = (e, t = "dark") => ({
  mode: t,
  background: {
    default: e.cedePrimaryBackgroundColor,
    paper: e.cedePaperBackgroundColor,
    lightPaper: e.cedePaperLightBackgroundColor,
    darkPaper: e.cedePaperDarkBackgroundColor,
    component: e.cedeComponentBackgroundColor,
    help: e.cedeHelpBackgroundColor
  },
  primary: { main: e.cedePrimaryColor },
  secondary: { main: e.cedeSecondaryColor },
  text: {
    primary: e.cedeTextPrimaryColor,
    secondary: e.cedeTextSecondaryColor,
    disabled: e.cedeTextDisabled
  },
  action: {
    disabledBackground: e.cedeComponentHr,
    disabled: e.cedeTextDisabled
  },
  success: {
    main: e.cedeSuccessColor
  },
  warning: {
    main: e.cedeWarningColor,
    light: e.cedeWarningLightColor
  },
  error: {
    main: e.cedeErrorColor
  },
  logoBorderColor: e.cedePrimaryColor,
  ...e
}), Yo = {
  zIndex: {
    baseLayer: 1,
    mediumLayer: 5,
    topLayer: 10,
    extraLayer: 15
  },
  storeSize: {
    width: "370px",
    tabWidth: "450px",
    bigTabWidth: "1265px",
    requestTabWidth: "600px",
    height: "600px",
    tabHeight: "600px",
    bigTabHeight: "800px",
    requestTabHeight: "500px",
    widgetWidth: "385px",
    widgetHeight: "565px",
    widgetMinWidth: "330px",
    widgetMaxWidth: "500px"
  },
  navBarSize: {
    height: "50px",
    widgetHeight: "35px"
  },
  defaultBoxRadius: 1,
  largeBoxRadius: 3.5,
  mediumBoxRadius: 2,
  buttonSmallRadius: 3,
  buttonDefaultRadius: 3.5,
  buttonRoundedRadius: 100,
  smallGutterMargin: "8px",
  gutterMargin: "16px",
  mediumGutterMargin: "28px",
  bigGutterMargin: "40px",
  cedeLinkBigContentMargin: "60px",
  cedeLinkSmallContentMargin: "16px",
  cedeLinkBigContentMaxWidth: "1315px",
  inputRadius: {
    default: 4,
    rounded: 5
  },
  imgSize: {
    small: "32px",
    medium: "56px",
    large: "110px"
  },
  iconSize: {
    small: "16px",
    medium: "20px",
    large: "29px"
  },
  linkLogoWidth: {
    small: "99px",
    medium: "151px",
    large: "230px"
  },
  linkLogoHeight: {
    small: "15px",
    medium: "23px",
    large: "35px"
  },
  inputWidth: {
    small: "256px"
  },
  circleSize: {
    small: "8px"
  },
  opacity: {
    alert: 0.6,
    legend: 0.7
  },
  textSize: {
    small: "9px",
    medium: "11px",
    large: "13px"
  },
  iconUnderlayMargin: 4,
  portfolioItemWidth: "170px",
  portfolioItemHeight: "60px",
  linkInactiveFilterWidth: "160px",
  linkActiveFilterWidth: "200px",
  txHistoryItem: {
    height: 50
  },
  txHistoryList: {
    dateLineHeight: 74,
    dateLineMargin: 16,
    txDate: {
      margin: 15,
      height: 35
    },
    txPlace: {
      margin: 16,
      height: 50
    },
    txItem: {
      collapsed: 75,
      toggled: 145
    }
  },
  dappListItemHeight: 55,
  gradientButtonBackground: Rr.cedeGradientPrimaryBackground
}, Fo = "'Inter', sans-serif", Go = (e) => {
  var t, n, s, u, d, c, p, y, D, M;
  return {
    fontFamily: Fo,
    h1: {
      fontWeight: "600",
      marginTop: "16px",
      fontSize: "24px",
      color: (t = e.text) == null ? void 0 : t.primary
    },
    h2: {
      fontWeight: "500",
      fontSize: "20px",
      marginBottom: "15px",
      lineHeight: "18px",
      color: (n = e.text) == null ? void 0 : n.secondary
    },
    h3: {
      fontSize: "16px",
      color: (s = e.text) == null ? void 0 : s.primary
    },
    h4: {
      color: (u = e.text) == null ? void 0 : u.primary
    },
    h5: {
      color: (d = e.text) == null ? void 0 : d.primary
    },
    subtitle1: {
      color: (c = e.text) == null ? void 0 : c.primary
    },
    subtitle2: {
      color: (p = e.text) == null ? void 0 : p.secondary
    },
    body1: {
      fontSize: "14px",
      lineHeight: "18px",
      fontWeight: 400,
      color: (y = e.text) == null ? void 0 : y.primary
    },
    body2: {
      color: (D = e.text) == null ? void 0 : D.secondary,
      fontSize: "14px"
    },
    caption: {
      fontSize: "11px",
      color: (M = e.text) == null ? void 0 : M.secondary
    }
  };
}, Wo = {
  values: {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1480,
    xl: 1920
  }
}, Zo = {
  borderRadius: 4
}, lt = { palette: Uo, custom: Yo, typography: Go, breakpoints: Wo, shape: Zo }, Qo = (e) => {
  var d, c, p, y, D, M;
  const { palette: t, typography: n, custom: s } = lt, u = t((e == null ? void 0 : e.mode) === "light" ? Po : Rr, e == null ? void 0 : e.mode);
  return {
    ...lt,
    palette: {
      ...u,
      background: {
        ...u.background,
        default: (e == null ? void 0 : e.primaryColor) ?? ((d = u.background) == null ? void 0 : d.default),
        darkPaper: (e == null ? void 0 : e.primaryColor) ?? ((c = u.background) == null ? void 0 : c.darkPaper),
        paper: (e == null ? void 0 : e.secondaryColor) ?? ((p = u.background) == null ? void 0 : p.paper),
        component: (e == null ? void 0 : e.secondaryColor) ?? ((y = u.background) == null ? void 0 : y.component)
      },
      text: {
        ...u.text,
        primary: (e == null ? void 0 : e.primaryTextColor) ?? ((D = u.text) == null ? void 0 : D.primary),
        secondary: (e == null ? void 0 : e.secondaryTextColor) ?? ((M = u.text) == null ? void 0 : M.secondary)
      },
      error: {
        main: (e == null ? void 0 : e.errorColor) ?? u.cedeErrorColor
      },
      primary: {
        main: (e == null ? void 0 : e.accentColor) ?? u.cedePrimaryColor
      },
      warning: {
        main: (e == null ? void 0 : e.warningColor) ?? u.cedeWarningColor
      },
      cedeTextDisabled: (e == null ? void 0 : e.primaryTextColor) ?? u.cedeTextDisabled,
      logoBorderColor: (e == null ? void 0 : e.logoBorderColor) ?? u.logoBorderColor,
      cedeComponentHr: (e == null ? void 0 : e.inputBorderColor) ?? u.cedeComponentHr
    },
    typography: (m) => ({
      ...n(m),
      fontFamily: (e == null ? void 0 : e.fontFamily) ?? n(m).fontFamily
    }),
    shape: {
      borderRadius: (e == null ? void 0 : e.borderRadius) ?? lt.shape.borderRadius
    },
    custom: {
      ...s,
      storeSize: {
        ...s.storeSize,
        widgetWidth: (e == null ? void 0 : e.width) ?? s.storeSize.widgetWidth
      }
    },
    breakpoints: lt.breakpoints
  };
};
var mr = { exports: {} };
const bt = /* @__PURE__ */ Ki(co);
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
(function(e, t) {
  var n = bt, s = n.Buffer;
  function u(c, p) {
    for (var y in c)
      p[y] = c[y];
  }
  s.from && s.alloc && s.allocUnsafe && s.allocUnsafeSlow ? e.exports = n : (u(n, t), t.Buffer = d);
  function d(c, p, y) {
    return s(c, p, y);
  }
  d.prototype = Object.create(s.prototype), u(s, d), d.from = function(c, p, y) {
    if (typeof c == "number")
      throw new TypeError("Argument must not be a number");
    return s(c, p, y);
  }, d.alloc = function(c, p, y) {
    if (typeof c != "number")
      throw new TypeError("Argument must be a number");
    var D = s(c);
    return p !== void 0 ? typeof y == "string" ? D.fill(p, y) : D.fill(p) : D.fill(0), D;
  }, d.allocUnsafe = function(c) {
    if (typeof c != "number")
      throw new TypeError("Argument must be a number");
    return s(c);
  }, d.allocUnsafeSlow = function(c) {
    if (typeof c != "number")
      throw new TypeError("Argument must be a number");
    return n.SlowBuffer(c);
  };
})(mr, mr.exports);
var $o = mr.exports;
const Ho = {
  connect: 2,
  disconnect: 1,
  vaults: 1,
  vaultAccounts: 1,
  supportedExchanges: 1,
  getWithdrawalById: 2,
  transactions: 2,
  balances: 3,
  nfts: 2,
  openOrders: 2,
  retrieveOrder: 2,
  editOrder: 2,
  getMinAmounts: 2,
  createOrder: 2,
  prepareOrder: 2,
  getStandardizedNetworks: 1,
  getMarketPairs: 2,
  getMarketRate: 2,
  tickers: 1,
  tokens: 1,
  activeVault: 1,
  depositableTokens: 2,
  getNetworks: 2,
  deposit: 2,
  cancelOrder: 2,
  addCex: 2,
  withdrawToDefi: 2,
  withdrawableTokens: 2,
  getPrices: 1,
  prepareWithdrawal: 2,
  getSettings: 1,
  getEnvironment: 1,
  getAddressBook: 1,
  checkAddressIsWhitelisted: 1,
  searchTransaction: 1,
  getWidgetBundleUrl: 1,
  getWhitelistedAddresses: 1,
  getTradePath: 1,
  getSupportedTokens: 1,
  isWalletTypeTotupNeeded: 1,
  trackLink: 1,
  openPageWithHelper: 1,
  untrackLink: 1,
  getConfig: 1,
  fetchPartners: 1,
  getCurrentAppTab: 1,
  focusTab: 1,
  getUserId: 1
  /* V1 */
};
class tn {
  constructor(t) {
    Me(this, "inpageProvider");
    Me(this, "request", async (t) => {
      const s = Ho[t.method] ?? -1, u = t;
      return u.params ? u.params = { ...u.params, version: s } : u.params = { version: s }, this.inpageProvider.request(u);
    });
    Me(this, "on", (t, n) => (this.inpageProvider.on(t, n), this));
    Me(this, "once", (t, n) => (this.inpageProvider.on(t, n), this));
    Me(this, "off", (t, n) => (this.inpageProvider.off(t, n), this));
    Me(this, "removeListener", (t, n) => (this.inpageProvider.removeListener(t, n), this));
    Me(this, "removeAllListeners", (t) => (this.inpageProvider.removeAllListeners(t), this));
    Me(this, "emit", (t, ...n) => this.inpageProvider.emit(t, ...n));
    Me(this, "getVaultPreviews", () => this.inpageProvider.getVaultPreviews());
    Me(this, "getIsUnlocked", () => this.inpageProvider.getIsUnlocked());
    Me(this, "getIsConnected", () => this.inpageProvider.getIsConnected());
    Me(this, "getActiveVault", () => this.inpageProvider.getActiveVault());
    this.inpageProvider = t;
  }
}
function Jo(e = 1500) {
  let t = !1;
  return new Promise((n) => {
    window.cede ? s() : (window.addEventListener("cede#initialized", s, {
      once: !0
    }), setTimeout(() => {
      s();
    }, e));
    function s() {
      if (t) {
        const d = window.cede, c = new tn(d);
        n(c);
        return;
      }
      t = !0, window.removeEventListener("cede#initialized", s);
      const { cede: u } = window;
      if (u) {
        const d = window.cede, c = new tn(d);
        n(c);
      } else
        n(null);
    }
  });
}
lo($i);
var Tt = {}, jr = { exports: {} }, Nr = { exports: {} };
typeof q > "u" || !q.version || q.version.indexOf("v0.") === 0 || q.version.indexOf("v1.") === 0 && q.version.indexOf("v1.8.") !== 0 ? Nr.exports = { nextTick: Xo } : Nr.exports = q;
function Xo(e, t, n, s) {
  if (typeof e != "function")
    throw new TypeError('"callback" argument must be a function');
  var u = arguments.length, d, c;
  switch (u) {
    case 0:
    case 1:
      return q.nextTick(e);
    case 2:
      return q.nextTick(function() {
        e.call(null, t);
      });
    case 3:
      return q.nextTick(function() {
        e.call(null, t, n);
      });
    case 4:
      return q.nextTick(function() {
        e.call(null, t, n, s);
      });
    default:
      for (d = new Array(u - 1), c = 0; c < d.length; )
        d[c++] = arguments[c];
      return q.nextTick(function() {
        e.apply(null, d);
      });
  }
}
var Ge = Nr.exports, Vo = {}.toString, Ko = Array.isArray || function(e) {
  return Vo.call(e) == "[object Array]";
}, Pr = { exports: {} }, Xe = typeof Reflect == "object" ? Reflect : null, rn = Xe && typeof Xe.apply == "function" ? Xe.apply : function(t, n, s) {
  return Function.prototype.apply.call(t, n, s);
}, Mt;
Xe && typeof Xe.ownKeys == "function" ? Mt = Xe.ownKeys : Object.getOwnPropertySymbols ? Mt = function(t) {
  return Object.getOwnPropertyNames(t).concat(Object.getOwnPropertySymbols(t));
} : Mt = function(t) {
  return Object.getOwnPropertyNames(t);
};
function qo(e) {
  console && console.warn && console.warn(e);
}
var Bn = Number.isNaN || function(t) {
  return t !== t;
};
function ee() {
  ee.init.call(this);
}
Pr.exports = ee;
Pr.exports.once = na;
ee.EventEmitter = ee;
ee.prototype._events = void 0;
ee.prototype._eventsCount = 0;
ee.prototype._maxListeners = void 0;
var nn = 10;
function St(e) {
  if (typeof e != "function")
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof e);
}
Object.defineProperty(ee, "defaultMaxListeners", {
  enumerable: !0,
  get: function() {
    return nn;
  },
  set: function(e) {
    if (typeof e != "number" || e < 0 || Bn(e))
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + e + ".");
    nn = e;
  }
});
ee.init = function() {
  (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
};
ee.prototype.setMaxListeners = function(t) {
  if (typeof t != "number" || t < 0 || Bn(t))
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + t + ".");
  return this._maxListeners = t, this;
};
function Rn(e) {
  return e._maxListeners === void 0 ? ee.defaultMaxListeners : e._maxListeners;
}
ee.prototype.getMaxListeners = function() {
  return Rn(this);
};
ee.prototype.emit = function(t) {
  for (var n = [], s = 1; s < arguments.length; s++)
    n.push(arguments[s]);
  var u = t === "error", d = this._events;
  if (d !== void 0)
    u = u && d.error === void 0;
  else if (!u)
    return !1;
  if (u) {
    var c;
    if (n.length > 0 && (c = n[0]), c instanceof Error)
      throw c;
    var p = new Error("Unhandled error." + (c ? " (" + c.message + ")" : ""));
    throw p.context = c, p;
  }
  var y = d[t];
  if (y === void 0)
    return !1;
  if (typeof y == "function")
    rn(y, this, n);
  else
    for (var D = y.length, M = Gn(y, D), s = 0; s < D; ++s)
      rn(M[s], this, n);
  return !0;
};
function Pn(e, t, n, s) {
  var u, d, c;
  if (St(n), d = e._events, d === void 0 ? (d = e._events = /* @__PURE__ */ Object.create(null), e._eventsCount = 0) : (d.newListener !== void 0 && (e.emit(
    "newListener",
    t,
    n.listener ? n.listener : n
  ), d = e._events), c = d[t]), c === void 0)
    c = d[t] = n, ++e._eventsCount;
  else if (typeof c == "function" ? c = d[t] = s ? [n, c] : [c, n] : s ? c.unshift(n) : c.push(n), u = Rn(e), u > 0 && c.length > u && !c.warned) {
    c.warned = !0;
    var p = new Error("Possible EventEmitter memory leak detected. " + c.length + " " + String(t) + " listeners added. Use emitter.setMaxListeners() to increase limit");
    p.name = "MaxListenersExceededWarning", p.emitter = e, p.type = t, p.count = c.length, qo(p);
  }
  return e;
}
ee.prototype.addListener = function(t, n) {
  return Pn(this, t, n, !1);
};
ee.prototype.on = ee.prototype.addListener;
ee.prototype.prependListener = function(t, n) {
  return Pn(this, t, n, !0);
};
function ea() {
  if (!this.fired)
    return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
}
function Un(e, t, n) {
  var s = { fired: !1, wrapFn: void 0, target: e, type: t, listener: n }, u = ea.bind(s);
  return u.listener = n, s.wrapFn = u, u;
}
ee.prototype.once = function(t, n) {
  return St(n), this.on(t, Un(this, t, n)), this;
};
ee.prototype.prependOnceListener = function(t, n) {
  return St(n), this.prependListener(t, Un(this, t, n)), this;
};
ee.prototype.removeListener = function(t, n) {
  var s, u, d, c, p;
  if (St(n), u = this._events, u === void 0)
    return this;
  if (s = u[t], s === void 0)
    return this;
  if (s === n || s.listener === n)
    --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete u[t], u.removeListener && this.emit("removeListener", t, s.listener || n));
  else if (typeof s != "function") {
    for (d = -1, c = s.length - 1; c >= 0; c--)
      if (s[c] === n || s[c].listener === n) {
        p = s[c].listener, d = c;
        break;
      }
    if (d < 0)
      return this;
    d === 0 ? s.shift() : ta(s, d), s.length === 1 && (u[t] = s[0]), u.removeListener !== void 0 && this.emit("removeListener", t, p || n);
  }
  return this;
};
ee.prototype.off = ee.prototype.removeListener;
ee.prototype.removeAllListeners = function(t) {
  var n, s, u;
  if (s = this._events, s === void 0)
    return this;
  if (s.removeListener === void 0)
    return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : s[t] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete s[t]), this;
  if (arguments.length === 0) {
    var d = Object.keys(s), c;
    for (u = 0; u < d.length; ++u)
      c = d[u], c !== "removeListener" && this.removeAllListeners(c);
    return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
  }
  if (n = s[t], typeof n == "function")
    this.removeListener(t, n);
  else if (n !== void 0)
    for (u = n.length - 1; u >= 0; u--)
      this.removeListener(t, n[u]);
  return this;
};
function Yn(e, t, n) {
  var s = e._events;
  if (s === void 0)
    return [];
  var u = s[t];
  return u === void 0 ? [] : typeof u == "function" ? n ? [u.listener || u] : [u] : n ? ra(u) : Gn(u, u.length);
}
ee.prototype.listeners = function(t) {
  return Yn(this, t, !0);
};
ee.prototype.rawListeners = function(t) {
  return Yn(this, t, !1);
};
ee.listenerCount = function(e, t) {
  return typeof e.listenerCount == "function" ? e.listenerCount(t) : Fn.call(e, t);
};
ee.prototype.listenerCount = Fn;
function Fn(e) {
  var t = this._events;
  if (t !== void 0) {
    var n = t[e];
    if (typeof n == "function")
      return 1;
    if (n !== void 0)
      return n.length;
  }
  return 0;
}
ee.prototype.eventNames = function() {
  return this._eventsCount > 0 ? Mt(this._events) : [];
};
function Gn(e, t) {
  for (var n = new Array(t), s = 0; s < t; ++s)
    n[s] = e[s];
  return n;
}
function ta(e, t) {
  for (; t + 1 < e.length; t++)
    e[t] = e[t + 1];
  e.pop();
}
function ra(e) {
  for (var t = new Array(e.length), n = 0; n < t.length; ++n)
    t[n] = e[n].listener || e[n];
  return t;
}
function na(e, t) {
  return new Promise(function(n, s) {
    function u(c) {
      e.removeListener(t, d), s(c);
    }
    function d() {
      typeof e.removeListener == "function" && e.removeListener("error", u), n([].slice.call(arguments));
    }
    Wn(e, t, d, { once: !0 }), t !== "error" && ia(e, u, { once: !0 });
  });
}
function ia(e, t, n) {
  typeof e.on == "function" && Wn(e, "error", t, n);
}
function Wn(e, t, n, s) {
  if (typeof e.on == "function")
    s.once ? e.once(t, n) : e.on(t, n);
  else if (typeof e.addEventListener == "function")
    e.addEventListener(t, function u(d) {
      s.once && e.removeEventListener(t, u), n(d);
    });
  else
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof e);
}
var et = Pr.exports, Zn = et.EventEmitter, Dr = { exports: {} };
(function(e, t) {
  var n = bt, s = n.Buffer;
  function u(c, p) {
    for (var y in c)
      p[y] = c[y];
  }
  s.from && s.alloc && s.allocUnsafe && s.allocUnsafeSlow ? e.exports = n : (u(n, t), t.Buffer = d);
  function d(c, p, y) {
    return s(c, p, y);
  }
  u(s, d), d.from = function(c, p, y) {
    if (typeof c == "number")
      throw new TypeError("Argument must not be a number");
    return s(c, p, y);
  }, d.alloc = function(c, p, y) {
    if (typeof c != "number")
      throw new TypeError("Argument must be a number");
    var D = s(c);
    return p !== void 0 ? typeof y == "string" ? D.fill(p, y) : D.fill(p) : D.fill(0), D;
  }, d.allocUnsafe = function(c) {
    if (typeof c != "number")
      throw new TypeError("Argument must be a number");
    return s(c);
  }, d.allocUnsafeSlow = function(c) {
    if (typeof c != "number")
      throw new TypeError("Argument must be a number");
    return n.SlowBuffer(c);
  };
})(Dr, Dr.exports);
var Ur = Dr.exports, oe = {};
function oa(e) {
  return Array.isArray ? Array.isArray(e) : Et(e) === "[object Array]";
}
oe.isArray = oa;
function aa(e) {
  return typeof e == "boolean";
}
oe.isBoolean = aa;
function sa(e) {
  return e === null;
}
oe.isNull = sa;
function ua(e) {
  return e == null;
}
oe.isNullOrUndefined = ua;
function ca(e) {
  return typeof e == "number";
}
oe.isNumber = ca;
function la(e) {
  return typeof e == "string";
}
oe.isString = la;
function da(e) {
  return typeof e == "symbol";
}
oe.isSymbol = da;
function fa(e) {
  return e === void 0;
}
oe.isUndefined = fa;
function ga(e) {
  return Et(e) === "[object RegExp]";
}
oe.isRegExp = ga;
function ha(e) {
  return typeof e == "object" && e !== null;
}
oe.isObject = ha;
function pa(e) {
  return Et(e) === "[object Date]";
}
oe.isDate = pa;
function ya(e) {
  return Et(e) === "[object Error]" || e instanceof Error;
}
oe.isError = ya;
function Ma(e) {
  return typeof e == "function";
}
oe.isFunction = Ma;
function Ia(e) {
  return e === null || typeof e == "boolean" || typeof e == "number" || typeof e == "string" || typeof e == "symbol" || // ES6 symbol
  typeof e > "u";
}
oe.isPrimitive = Ia;
oe.isBuffer = bt.Buffer.isBuffer;
function Et(e) {
  return Object.prototype.toString.call(e);
}
var br = { exports: {} };
typeof Object.create == "function" ? br.exports = function(t, n) {
  n && (t.super_ = n, t.prototype = Object.create(n.prototype, {
    constructor: {
      value: t,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }));
} : br.exports = function(t, n) {
  if (n) {
    t.super_ = n;
    var s = function() {
    };
    s.prototype = n.prototype, t.prototype = new s(), t.prototype.constructor = t;
  }
};
var Se = br.exports, at = {}, Qn = {}, $n = function() {
  if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
    return !1;
  if (typeof Symbol.iterator == "symbol")
    return !0;
  var t = {}, n = Symbol("test"), s = Object(n);
  if (typeof n == "string" || Object.prototype.toString.call(n) !== "[object Symbol]" || Object.prototype.toString.call(s) !== "[object Symbol]")
    return !1;
  var u = 42;
  t[n] = u;
  for (n in t)
    return !1;
  if (typeof Object.keys == "function" && Object.keys(t).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(t).length !== 0)
    return !1;
  var d = Object.getOwnPropertySymbols(t);
  if (d.length !== 1 || d[0] !== n || !Object.prototype.propertyIsEnumerable.call(t, n))
    return !1;
  if (typeof Object.getOwnPropertyDescriptor == "function") {
    var c = Object.getOwnPropertyDescriptor(t, n);
    if (c.value !== u || c.enumerable !== !0)
      return !1;
  }
  return !0;
}, wa = $n, st = function() {
  return wa() && !!Symbol.toStringTag;
}, Wt, on;
function Ca() {
  if (on)
    return Wt;
  on = 1;
  var e = typeof Symbol < "u" && Symbol, t = $n;
  return Wt = function() {
    return typeof e != "function" || typeof Symbol != "function" || typeof e("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : t();
  }, Wt;
}
var Zt, an;
function Aa() {
  if (an)
    return Zt;
  an = 1;
  var e = "Function.prototype.bind called on incompatible ", t = Array.prototype.slice, n = Object.prototype.toString, s = "[object Function]";
  return Zt = function(d) {
    var c = this;
    if (typeof c != "function" || n.call(c) !== s)
      throw new TypeError(e + c);
    for (var p = t.call(arguments, 1), y, D = function() {
      if (this instanceof y) {
        var _ = c.apply(
          this,
          p.concat(t.call(arguments))
        );
        return Object(_) === _ ? _ : this;
      } else
        return c.apply(
          d,
          p.concat(t.call(arguments))
        );
    }, M = Math.max(0, c.length - p.length), m = [], z = 0; z < M; z++)
      m.push("$" + z);
    if (y = Function("binder", "return function (" + m.join(",") + "){ return binder.apply(this,arguments); }")(D), c.prototype) {
      var R = function() {
      };
      R.prototype = c.prototype, y.prototype = new R(), R.prototype = null;
    }
    return y;
  }, Zt;
}
var Qt, sn;
function La() {
  if (sn)
    return Qt;
  sn = 1;
  var e = Aa();
  return Qt = Function.prototype.bind || e, Qt;
}
var $t, un;
function ma() {
  if (un)
    return $t;
  un = 1;
  var e = "Function.prototype.bind called on incompatible ", t = Array.prototype.slice, n = Object.prototype.toString, s = "[object Function]";
  return $t = function(d) {
    var c = this;
    if (typeof c != "function" || n.call(c) !== s)
      throw new TypeError(e + c);
    for (var p = t.call(arguments, 1), y, D = function() {
      if (this instanceof y) {
        var _ = c.apply(
          this,
          p.concat(t.call(arguments))
        );
        return Object(_) === _ ? _ : this;
      } else
        return c.apply(
          d,
          p.concat(t.call(arguments))
        );
    }, M = Math.max(0, c.length - p.length), m = [], z = 0; z < M; z++)
      m.push("$" + z);
    if (y = Function("binder", "return function (" + m.join(",") + "){ return binder.apply(this,arguments); }")(D), c.prototype) {
      var R = function() {
      };
      R.prototype = c.prototype, y.prototype = new R(), R.prototype = null;
    }
    return y;
  }, $t;
}
var Ht, cn;
function ja() {
  if (cn)
    return Ht;
  cn = 1;
  var e = ma();
  return Ht = Function.prototype.bind || e, Ht;
}
var Jt, ln;
function Na() {
  if (ln)
    return Jt;
  ln = 1;
  var e = ja();
  return Jt = e.call(Function.call, Object.prototype.hasOwnProperty), Jt;
}
var Xt, dn;
function Yr() {
  if (dn)
    return Xt;
  dn = 1;
  var e, t = SyntaxError, n = Function, s = TypeError, u = function(J) {
    try {
      return n('"use strict"; return (' + J + ").constructor;")();
    } catch {
    }
  }, d = Object.getOwnPropertyDescriptor;
  if (d)
    try {
      d({}, "");
    } catch {
      d = null;
    }
  var c = function() {
    throw new s();
  }, p = d ? function() {
    try {
      return arguments.callee, c;
    } catch {
      try {
        return d(arguments, "callee").get;
      } catch {
        return c;
      }
    }
  }() : c, y = Ca()(), D = Object.getPrototypeOf || function(J) {
    return J.__proto__;
  }, M = {}, m = typeof Uint8Array > "u" ? e : D(Uint8Array), z = {
    "%AggregateError%": typeof AggregateError > "u" ? e : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer > "u" ? e : ArrayBuffer,
    "%ArrayIteratorPrototype%": y ? D([][Symbol.iterator]()) : e,
    "%AsyncFromSyncIteratorPrototype%": e,
    "%AsyncFunction%": M,
    "%AsyncGenerator%": M,
    "%AsyncGeneratorFunction%": M,
    "%AsyncIteratorPrototype%": M,
    "%Atomics%": typeof Atomics > "u" ? e : Atomics,
    "%BigInt%": typeof BigInt > "u" ? e : BigInt,
    "%BigInt64Array%": typeof BigInt64Array > "u" ? e : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array > "u" ? e : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView > "u" ? e : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": Error,
    "%eval%": eval,
    // eslint-disable-line no-eval
    "%EvalError%": EvalError,
    "%Float32Array%": typeof Float32Array > "u" ? e : Float32Array,
    "%Float64Array%": typeof Float64Array > "u" ? e : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? e : FinalizationRegistry,
    "%Function%": n,
    "%GeneratorFunction%": M,
    "%Int8Array%": typeof Int8Array > "u" ? e : Int8Array,
    "%Int16Array%": typeof Int16Array > "u" ? e : Int16Array,
    "%Int32Array%": typeof Int32Array > "u" ? e : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": y ? D(D([][Symbol.iterator]())) : e,
    "%JSON%": typeof JSON == "object" ? JSON : e,
    "%Map%": typeof Map > "u" ? e : Map,
    "%MapIteratorPrototype%": typeof Map > "u" || !y ? e : D((/* @__PURE__ */ new Map())[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise > "u" ? e : Promise,
    "%Proxy%": typeof Proxy > "u" ? e : Proxy,
    "%RangeError%": RangeError,
    "%ReferenceError%": ReferenceError,
    "%Reflect%": typeof Reflect > "u" ? e : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set > "u" ? e : Set,
    "%SetIteratorPrototype%": typeof Set > "u" || !y ? e : D((/* @__PURE__ */ new Set())[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? e : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": y ? D(""[Symbol.iterator]()) : e,
    "%Symbol%": y ? Symbol : e,
    "%SyntaxError%": t,
    "%ThrowTypeError%": p,
    "%TypedArray%": m,
    "%TypeError%": s,
    "%Uint8Array%": typeof Uint8Array > "u" ? e : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? e : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array > "u" ? e : Uint16Array,
    "%Uint32Array%": typeof Uint32Array > "u" ? e : Uint32Array,
    "%URIError%": URIError,
    "%WeakMap%": typeof WeakMap > "u" ? e : WeakMap,
    "%WeakRef%": typeof WeakRef > "u" ? e : WeakRef,
    "%WeakSet%": typeof WeakSet > "u" ? e : WeakSet
  };
  try {
    null.error;
  } catch (J) {
    var R = D(D(J));
    z["%Error.prototype%"] = R;
  }
  var _ = function J(Q) {
    var V;
    if (Q === "%AsyncFunction%")
      V = u("async function () {}");
    else if (Q === "%GeneratorFunction%")
      V = u("function* () {}");
    else if (Q === "%AsyncGeneratorFunction%")
      V = u("async function* () {}");
    else if (Q === "%AsyncGenerator%") {
      var W = J("%AsyncGeneratorFunction%");
      W && (V = W.prototype);
    } else if (Q === "%AsyncIteratorPrototype%") {
      var K = J("%AsyncGenerator%");
      K && (V = D(K.prototype));
    }
    return z[Q] = V, V;
  }, B = {
    "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
    "%ArrayPrototype%": ["Array", "prototype"],
    "%ArrayProto_entries%": ["Array", "prototype", "entries"],
    "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
    "%ArrayProto_keys%": ["Array", "prototype", "keys"],
    "%ArrayProto_values%": ["Array", "prototype", "values"],
    "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
    "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
    "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
    "%BooleanPrototype%": ["Boolean", "prototype"],
    "%DataViewPrototype%": ["DataView", "prototype"],
    "%DatePrototype%": ["Date", "prototype"],
    "%ErrorPrototype%": ["Error", "prototype"],
    "%EvalErrorPrototype%": ["EvalError", "prototype"],
    "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
    "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
    "%FunctionPrototype%": ["Function", "prototype"],
    "%Generator%": ["GeneratorFunction", "prototype"],
    "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
    "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
    "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
    "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
    "%JSONParse%": ["JSON", "parse"],
    "%JSONStringify%": ["JSON", "stringify"],
    "%MapPrototype%": ["Map", "prototype"],
    "%NumberPrototype%": ["Number", "prototype"],
    "%ObjectPrototype%": ["Object", "prototype"],
    "%ObjProto_toString%": ["Object", "prototype", "toString"],
    "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
    "%PromisePrototype%": ["Promise", "prototype"],
    "%PromiseProto_then%": ["Promise", "prototype", "then"],
    "%Promise_all%": ["Promise", "all"],
    "%Promise_reject%": ["Promise", "reject"],
    "%Promise_resolve%": ["Promise", "resolve"],
    "%RangeErrorPrototype%": ["RangeError", "prototype"],
    "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
    "%RegExpPrototype%": ["RegExp", "prototype"],
    "%SetPrototype%": ["Set", "prototype"],
    "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
    "%StringPrototype%": ["String", "prototype"],
    "%SymbolPrototype%": ["Symbol", "prototype"],
    "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
    "%TypedArrayPrototype%": ["TypedArray", "prototype"],
    "%TypeErrorPrototype%": ["TypeError", "prototype"],
    "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
    "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
    "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
    "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
    "%URIErrorPrototype%": ["URIError", "prototype"],
    "%WeakMapPrototype%": ["WeakMap", "prototype"],
    "%WeakSetPrototype%": ["WeakSet", "prototype"]
  }, Z = La(), b = Na(), S = Z.call(Function.call, Array.prototype.concat), F = Z.call(Function.apply, Array.prototype.splice), $ = Z.call(Function.call, String.prototype.replace), H = Z.call(Function.call, String.prototype.slice), ye = Z.call(Function.call, RegExp.prototype.exec), se = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, te = /\\(\\)?/g, ue = function(Q) {
    var V = H(Q, 0, 1), W = H(Q, -1);
    if (V === "%" && W !== "%")
      throw new t("invalid intrinsic syntax, expected closing `%`");
    if (W === "%" && V !== "%")
      throw new t("invalid intrinsic syntax, expected opening `%`");
    var K = [];
    return $(Q, se, function(re, f, g, A) {
      K[K.length] = g ? $(A, te, "$1") : f || re;
    }), K;
  }, fe = function(Q, V) {
    var W = Q, K;
    if (b(B, W) && (K = B[W], W = "%" + K[0] + "%"), b(z, W)) {
      var re = z[W];
      if (re === M && (re = _(W)), typeof re > "u" && !V)
        throw new s("intrinsic " + Q + " exists, but is not available. Please file an issue!");
      return {
        alias: K,
        name: W,
        value: re
      };
    }
    throw new t("intrinsic " + Q + " does not exist!");
  };
  return Xt = function(Q, V) {
    if (typeof Q != "string" || Q.length === 0)
      throw new s("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof V != "boolean")
      throw new s('"allowMissing" argument must be a boolean');
    if (ye(/^%?[^%]*%?$/, Q) === null)
      throw new t("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var W = ue(Q), K = W.length > 0 ? W[0] : "", re = fe("%" + K + "%", V), f = re.name, g = re.value, A = !1, v = re.alias;
    v && (K = v[0], F(W, S([0, 1], v)));
    for (var U = 1, w = !0; U < W.length; U += 1) {
      var j = W[U], T = H(j, 0, 1), Y = H(j, -1);
      if ((T === '"' || T === "'" || T === "`" || Y === '"' || Y === "'" || Y === "`") && T !== Y)
        throw new t("property names with quotes must have matching quotes");
      if ((j === "constructor" || !w) && (A = !0), K += "." + j, f = "%" + K + "%", b(z, f))
        g = z[f];
      else if (g != null) {
        if (!(j in g)) {
          if (!V)
            throw new s("base intrinsic for " + Q + " exists, but the property is not available.");
          return;
        }
        if (d && U + 1 >= W.length) {
          var G = d(g, j);
          w = !!G, w && "get" in G && !("originalValue" in G.get) ? g = G.get : g = g[j];
        } else
          w = b(g, j), g = g[j];
        w && !A && (z[f] = g);
      }
    }
    return g;
  }, Xt;
}
var Vt = { exports: {} }, Kt, fn;
function Da() {
  if (fn)
    return Kt;
  fn = 1;
  var e = "Function.prototype.bind called on incompatible ", t = Array.prototype.slice, n = Object.prototype.toString, s = "[object Function]";
  return Kt = function(d) {
    var c = this;
    if (typeof c != "function" || n.call(c) !== s)
      throw new TypeError(e + c);
    for (var p = t.call(arguments, 1), y, D = function() {
      if (this instanceof y) {
        var _ = c.apply(
          this,
          p.concat(t.call(arguments))
        );
        return Object(_) === _ ? _ : this;
      } else
        return c.apply(
          d,
          p.concat(t.call(arguments))
        );
    }, M = Math.max(0, c.length - p.length), m = [], z = 0; z < M; z++)
      m.push("$" + z);
    if (y = Function("binder", "return function (" + m.join(",") + "){ return binder.apply(this,arguments); }")(D), c.prototype) {
      var R = function() {
      };
      R.prototype = c.prototype, y.prototype = new R(), R.prototype = null;
    }
    return y;
  }, Kt;
}
var qt, gn;
function ba() {
  if (gn)
    return qt;
  gn = 1;
  var e = Da();
  return qt = Function.prototype.bind || e, qt;
}
var hn;
function Ta() {
  return hn || (hn = 1, function(e) {
    var t = ba(), n = Yr(), s = n("%Function.prototype.apply%"), u = n("%Function.prototype.call%"), d = n("%Reflect.apply%", !0) || t.call(u, s), c = n("%Object.getOwnPropertyDescriptor%", !0), p = n("%Object.defineProperty%", !0), y = n("%Math.max%");
    if (p)
      try {
        p({}, "a", { value: 1 });
      } catch {
        p = null;
      }
    e.exports = function(m) {
      var z = d(t, u, arguments);
      if (c && p) {
        var R = c(z, "length");
        R.configurable && p(
          z,
          "length",
          { value: 1 + y(0, m.length - (arguments.length - 1)) }
        );
      }
      return z;
    };
    var D = function() {
      return d(t, s, arguments);
    };
    p ? p(e.exports, "apply", { value: D }) : e.exports.apply = D;
  }(Vt)), Vt.exports;
}
var Hn = Yr(), Jn = Ta(), Sa = Jn(Hn("String.prototype.indexOf")), xt = function(t, n) {
  var s = Hn(t, !!n);
  return typeof s == "function" && Sa(t, ".prototype.") > -1 ? Jn(s) : s;
}, Ea = st(), xa = xt, Tr = xa("Object.prototype.toString"), vt = function(t) {
  return Ea && t && typeof t == "object" && Symbol.toStringTag in t ? !1 : Tr(t) === "[object Arguments]";
}, Xn = function(t) {
  return vt(t) ? !0 : t !== null && typeof t == "object" && typeof t.length == "number" && t.length >= 0 && Tr(t) !== "[object Array]" && Tr(t.callee) === "[object Function]";
}, va = function() {
  return vt(arguments);
}();
vt.isLegacyArguments = Xn;
var Oa = va ? vt : Xn, za = Object.prototype.toString, ka = Function.prototype.toString, _a = /^\s*(?:function)?\*/, Vn = st(), er = Object.getPrototypeOf, Ba = function() {
  if (!Vn)
    return !1;
  try {
    return Function("return function*() {}")();
  } catch {
  }
}, tr, Ra = function(t) {
  if (typeof t != "function")
    return !1;
  if (_a.test(ka.call(t)))
    return !0;
  if (!Vn) {
    var n = za.call(t);
    return n === "[object GeneratorFunction]";
  }
  if (!er)
    return !1;
  if (typeof tr > "u") {
    var s = Ba();
    tr = s ? er(s) : !1;
  }
  return er(t) === tr;
}, Kn = Function.prototype.toString, He = typeof Reflect == "object" && Reflect !== null && Reflect.apply, Sr, It;
if (typeof He == "function" && typeof Object.defineProperty == "function")
  try {
    Sr = Object.defineProperty({}, "length", {
      get: function() {
        throw It;
      }
    }), It = {}, He(function() {
      throw 42;
    }, null, Sr);
  } catch (e) {
    e !== It && (He = null);
  }
else
  He = null;
var Pa = /^\s*class\b/, Er = function(t) {
  try {
    var n = Kn.call(t);
    return Pa.test(n);
  } catch {
    return !1;
  }
}, rr = function(t) {
  try {
    return Er(t) ? !1 : (Kn.call(t), !0);
  } catch {
    return !1;
  }
}, wt = Object.prototype.toString, Ua = "[object Object]", Ya = "[object Function]", Fa = "[object GeneratorFunction]", Ga = "[object HTMLAllCollection]", Wa = "[object HTML document.all class]", Za = "[object HTMLCollection]", Qa = typeof Symbol == "function" && !!Symbol.toStringTag, $a = !(0 in [,]), xr = function() {
  return !1;
};
if (typeof document == "object") {
  var Ha = document.all;
  wt.call(Ha) === wt.call(document.all) && (xr = function(t) {
    if (($a || !t) && (typeof t > "u" || typeof t == "object"))
      try {
        var n = wt.call(t);
        return (n === Ga || n === Wa || n === Za || n === Ua) && t("") == null;
      } catch {
      }
    return !1;
  });
}
var Ja = He ? function(t) {
  if (xr(t))
    return !0;
  if (!t || typeof t != "function" && typeof t != "object")
    return !1;
  try {
    He(t, null, Sr);
  } catch (n) {
    if (n !== It)
      return !1;
  }
  return !Er(t) && rr(t);
} : function(t) {
  if (xr(t))
    return !0;
  if (!t || typeof t != "function" && typeof t != "object")
    return !1;
  if (Qa)
    return rr(t);
  if (Er(t))
    return !1;
  var n = wt.call(t);
  return n !== Ya && n !== Fa && !/^\[object HTML/.test(n) ? !1 : rr(t);
}, Xa = Ja, Va = Object.prototype.toString, qn = Object.prototype.hasOwnProperty, Ka = function(t, n, s) {
  for (var u = 0, d = t.length; u < d; u++)
    qn.call(t, u) && (s == null ? n(t[u], u, t) : n.call(s, t[u], u, t));
}, qa = function(t, n, s) {
  for (var u = 0, d = t.length; u < d; u++)
    s == null ? n(t.charAt(u), u, t) : n.call(s, t.charAt(u), u, t);
}, es = function(t, n, s) {
  for (var u in t)
    qn.call(t, u) && (s == null ? n(t[u], u, t) : n.call(s, t[u], u, t));
}, ts = function(t, n, s) {
  if (!Xa(n))
    throw new TypeError("iterator must be a function");
  var u;
  arguments.length >= 3 && (u = s), Va.call(t) === "[object Array]" ? Ka(t, n, u) : typeof t == "string" ? qa(t, n, u) : es(t, n, u);
}, Fr = ts, nr = [
  "BigInt64Array",
  "BigUint64Array",
  "Float32Array",
  "Float64Array",
  "Int16Array",
  "Int32Array",
  "Int8Array",
  "Uint16Array",
  "Uint32Array",
  "Uint8Array",
  "Uint8ClampedArray"
], rs = typeof globalThis > "u" ? ie : globalThis, Gr = function() {
  for (var t = [], n = 0; n < nr.length; n++)
    typeof rs[nr[n]] == "function" && (t[t.length] = nr[n]);
  return t;
}, ns = Yr(), Ct = ns("%Object.getOwnPropertyDescriptor%", !0);
if (Ct)
  try {
    Ct([], "length");
  } catch {
    Ct = null;
  }
var Wr = Ct, ir, pn;
function is() {
  if (pn)
    return ir;
  pn = 1;
  var e = Fr, t = Gr, n = xt, s = n("Object.prototype.toString"), u = st(), d = Wr, c = typeof globalThis > "u" ? ie : globalThis, p = t(), y = n("Array.prototype.indexOf", !0) || function(_, B) {
    for (var Z = 0; Z < _.length; Z += 1)
      if (_[Z] === B)
        return Z;
    return -1;
  }, D = n("String.prototype.slice"), M = {}, m = Object.getPrototypeOf;
  u && d && m && e(p, function(R) {
    var _ = new c[R]();
    if (Symbol.toStringTag in _) {
      var B = m(_), Z = d(B, Symbol.toStringTag);
      if (!Z) {
        var b = m(B);
        Z = d(b, Symbol.toStringTag);
      }
      M[R] = Z.get;
    }
  });
  var z = function(_) {
    var B = !1;
    return e(M, function(Z, b) {
      if (!B)
        try {
          B = Z.call(_) === b;
        } catch {
        }
    }), B;
  };
  return ir = function(_) {
    if (!_ || typeof _ != "object")
      return !1;
    if (!u || !(Symbol.toStringTag in _)) {
      var B = D(s(_), 8, -1);
      return y(p, B) > -1;
    }
    return d ? z(_) : !1;
  }, ir;
}
var ei = Fr, os = Gr, ti = xt, or = Wr, as = ti("Object.prototype.toString"), ri = st(), yn = typeof globalThis > "u" ? ie : globalThis, ss = os(), us = ti("String.prototype.slice"), ni = {}, ar = Object.getPrototypeOf;
ri && or && ar && ei(ss, function(e) {
  if (typeof yn[e] == "function") {
    var t = new yn[e]();
    if (Symbol.toStringTag in t) {
      var n = ar(t), s = or(n, Symbol.toStringTag);
      if (!s) {
        var u = ar(n);
        s = or(u, Symbol.toStringTag);
      }
      ni[e] = s.get;
    }
  }
});
var cs = function(t) {
  var n = !1;
  return ei(ni, function(s, u) {
    if (!n)
      try {
        var d = s.call(t);
        d === u && (n = d);
      } catch {
      }
  }), n;
}, ls = is(), ds = function(t) {
  return ls(t) ? !ri || !(Symbol.toStringTag in t) ? us(as(t), 8, -1) : cs(t) : !1;
}, ii = Fr, fs = Gr, Zr = xt, gs = Zr("Object.prototype.toString"), oi = st(), At = Wr, hs = typeof globalThis > "u" ? ie : globalThis, ai = fs(), ps = Zr("Array.prototype.indexOf", !0) || function(t, n) {
  for (var s = 0; s < t.length; s += 1)
    if (t[s] === n)
      return s;
  return -1;
}, ys = Zr("String.prototype.slice"), si = {}, sr = Object.getPrototypeOf;
oi && At && sr && ii(ai, function(e) {
  var t = new hs[e]();
  if (Symbol.toStringTag in t) {
    var n = sr(t), s = At(n, Symbol.toStringTag);
    if (!s) {
      var u = sr(n);
      s = At(u, Symbol.toStringTag);
    }
    si[e] = s.get;
  }
});
var Ms = function(t) {
  var n = !1;
  return ii(si, function(s, u) {
    if (!n)
      try {
        n = s.call(t) === u;
      } catch {
      }
  }), n;
}, Is = function(t) {
  if (!t || typeof t != "object")
    return !1;
  if (!oi || !(Symbol.toStringTag in t)) {
    var n = ys(gs(t), 8, -1);
    return ps(ai, n) > -1;
  }
  return At ? Ms(t) : !1;
};
(function(e) {
  var t = Oa, n = Ra, s = ds, u = Is;
  function d(x) {
    return x.call.bind(x);
  }
  var c = typeof BigInt < "u", p = typeof Symbol < "u", y = d(Object.prototype.toString), D = d(Number.prototype.valueOf), M = d(String.prototype.valueOf), m = d(Boolean.prototype.valueOf);
  if (c)
    var z = d(BigInt.prototype.valueOf);
  if (p)
    var R = d(Symbol.prototype.valueOf);
  function _(x, Le) {
    if (typeof x != "object")
      return !1;
    try {
      return Le(x), !0;
    } catch {
      return !1;
    }
  }
  e.isArgumentsObject = t, e.isGeneratorFunction = n, e.isTypedArray = u;
  function B(x) {
    return typeof Promise < "u" && x instanceof Promise || x !== null && typeof x == "object" && typeof x.then == "function" && typeof x.catch == "function";
  }
  e.isPromise = B;
  function Z(x) {
    return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? ArrayBuffer.isView(x) : u(x) || j(x);
  }
  e.isArrayBufferView = Z;
  function b(x) {
    return s(x) === "Uint8Array";
  }
  e.isUint8Array = b;
  function S(x) {
    return s(x) === "Uint8ClampedArray";
  }
  e.isUint8ClampedArray = S;
  function F(x) {
    return s(x) === "Uint16Array";
  }
  e.isUint16Array = F;
  function $(x) {
    return s(x) === "Uint32Array";
  }
  e.isUint32Array = $;
  function H(x) {
    return s(x) === "Int8Array";
  }
  e.isInt8Array = H;
  function ye(x) {
    return s(x) === "Int16Array";
  }
  e.isInt16Array = ye;
  function se(x) {
    return s(x) === "Int32Array";
  }
  e.isInt32Array = se;
  function te(x) {
    return s(x) === "Float32Array";
  }
  e.isFloat32Array = te;
  function ue(x) {
    return s(x) === "Float64Array";
  }
  e.isFloat64Array = ue;
  function fe(x) {
    return s(x) === "BigInt64Array";
  }
  e.isBigInt64Array = fe;
  function J(x) {
    return s(x) === "BigUint64Array";
  }
  e.isBigUint64Array = J;
  function Q(x) {
    return y(x) === "[object Map]";
  }
  Q.working = typeof Map < "u" && Q(/* @__PURE__ */ new Map());
  function V(x) {
    return typeof Map > "u" ? !1 : Q.working ? Q(x) : x instanceof Map;
  }
  e.isMap = V;
  function W(x) {
    return y(x) === "[object Set]";
  }
  W.working = typeof Set < "u" && W(/* @__PURE__ */ new Set());
  function K(x) {
    return typeof Set > "u" ? !1 : W.working ? W(x) : x instanceof Set;
  }
  e.isSet = K;
  function re(x) {
    return y(x) === "[object WeakMap]";
  }
  re.working = typeof WeakMap < "u" && re(/* @__PURE__ */ new WeakMap());
  function f(x) {
    return typeof WeakMap > "u" ? !1 : re.working ? re(x) : x instanceof WeakMap;
  }
  e.isWeakMap = f;
  function g(x) {
    return y(x) === "[object WeakSet]";
  }
  g.working = typeof WeakSet < "u" && g(/* @__PURE__ */ new WeakSet());
  function A(x) {
    return g(x);
  }
  e.isWeakSet = A;
  function v(x) {
    return y(x) === "[object ArrayBuffer]";
  }
  v.working = typeof ArrayBuffer < "u" && v(new ArrayBuffer());
  function U(x) {
    return typeof ArrayBuffer > "u" ? !1 : v.working ? v(x) : x instanceof ArrayBuffer;
  }
  e.isArrayBuffer = U;
  function w(x) {
    return y(x) === "[object DataView]";
  }
  w.working = typeof ArrayBuffer < "u" && typeof DataView < "u" && w(new DataView(new ArrayBuffer(1), 0, 1));
  function j(x) {
    return typeof DataView > "u" ? !1 : w.working ? w(x) : x instanceof DataView;
  }
  e.isDataView = j;
  var T = typeof SharedArrayBuffer < "u" ? SharedArrayBuffer : void 0;
  function Y(x) {
    return y(x) === "[object SharedArrayBuffer]";
  }
  function G(x) {
    return typeof T > "u" ? !1 : (typeof Y.working > "u" && (Y.working = Y(new T())), Y.working ? Y(x) : x instanceof T);
  }
  e.isSharedArrayBuffer = G;
  function o(x) {
    return y(x) === "[object AsyncFunction]";
  }
  e.isAsyncFunction = o;
  function a(x) {
    return y(x) === "[object Map Iterator]";
  }
  e.isMapIterator = a;
  function I(x) {
    return y(x) === "[object Set Iterator]";
  }
  e.isSetIterator = I;
  function L(x) {
    return y(x) === "[object Generator]";
  }
  e.isGeneratorObject = L;
  function k(x) {
    return y(x) === "[object WebAssembly.Module]";
  }
  e.isWebAssemblyCompiledModule = k;
  function O(x) {
    return _(x, D);
  }
  e.isNumberObject = O;
  function P(x) {
    return _(x, M);
  }
  e.isStringObject = P;
  function he(x) {
    return _(x, m);
  }
  e.isBooleanObject = he;
  function we(x) {
    return c && _(x, z);
  }
  e.isBigIntObject = we;
  function Ce(x) {
    return p && _(x, R);
  }
  e.isSymbolObject = Ce;
  function De(x) {
    return O(x) || P(x) || he(x) || we(x) || Ce(x);
  }
  e.isBoxedPrimitive = De;
  function be(x) {
    return typeof Uint8Array < "u" && (U(x) || G(x));
  }
  e.isAnyArrayBuffer = be, ["isProxy", "isExternal", "isModuleNamespaceObject"].forEach(function(x) {
    Object.defineProperty(e, x, {
      enumerable: !1,
      value: function() {
        throw new Error(x + " is not supported in userland");
      }
    });
  });
})(Qn);
var ws = function(t) {
  return t && typeof t == "object" && typeof t.copy == "function" && typeof t.fill == "function" && typeof t.readUInt8 == "function";
};
(function(e) {
  var t = Object.getOwnPropertyDescriptors || function(j) {
    for (var T = Object.keys(j), Y = {}, G = 0; G < T.length; G++)
      Y[T[G]] = Object.getOwnPropertyDescriptor(j, T[G]);
    return Y;
  }, n = /%[sdj%]/g;
  e.format = function(w) {
    if (!H(w)) {
      for (var j = [], T = 0; T < arguments.length; T++)
        j.push(c(arguments[T]));
      return j.join(" ");
    }
    for (var T = 1, Y = arguments, G = Y.length, o = String(w).replace(n, function(I) {
      if (I === "%%")
        return "%";
      if (T >= G)
        return I;
      switch (I) {
        case "%s":
          return String(Y[T++]);
        case "%d":
          return Number(Y[T++]);
        case "%j":
          try {
            return JSON.stringify(Y[T++]);
          } catch {
            return "[Circular]";
          }
        default:
          return I;
      }
    }), a = Y[T]; T < G; a = Y[++T])
      S(a) || !ue(a) ? o += " " + a : o += " " + c(a);
    return o;
  }, e.deprecate = function(w, j) {
    if (typeof q < "u" && q.noDeprecation === !0)
      return w;
    if (typeof q > "u")
      return function() {
        return e.deprecate(w, j).apply(this, arguments);
      };
    var T = !1;
    function Y() {
      if (!T) {
        if (q.throwDeprecation)
          throw new Error(j);
        q.traceDeprecation ? console.trace(j) : console.error(j), T = !0;
      }
      return w.apply(this, arguments);
    }
    return Y;
  };
  var s = {}, u = /^$/;
  if (q.env.NODE_DEBUG) {
    var d = q.env.NODE_DEBUG;
    d = d.replace(/[|\\{}()[\]^$+?.]/g, "\\$&").replace(/\*/g, ".*").replace(/,/g, "$|^").toUpperCase(), u = new RegExp("^" + d + "$", "i");
  }
  e.debuglog = function(w) {
    if (w = w.toUpperCase(), !s[w])
      if (u.test(w)) {
        var j = q.pid;
        s[w] = function() {
          var T = e.format.apply(e, arguments);
          console.error("%s %d: %s", w, j, T);
        };
      } else
        s[w] = function() {
        };
    return s[w];
  };
  function c(w, j) {
    var T = {
      seen: [],
      stylize: y
    };
    return arguments.length >= 3 && (T.depth = arguments[2]), arguments.length >= 4 && (T.colors = arguments[3]), b(j) ? T.showHidden = j : j && e._extend(T, j), se(T.showHidden) && (T.showHidden = !1), se(T.depth) && (T.depth = 2), se(T.colors) && (T.colors = !1), se(T.customInspect) && (T.customInspect = !0), T.colors && (T.stylize = p), M(T, w, T.depth);
  }
  e.inspect = c, c.colors = {
    bold: [1, 22],
    italic: [3, 23],
    underline: [4, 24],
    inverse: [7, 27],
    white: [37, 39],
    grey: [90, 39],
    black: [30, 39],
    blue: [34, 39],
    cyan: [36, 39],
    green: [32, 39],
    magenta: [35, 39],
    red: [31, 39],
    yellow: [33, 39]
  }, c.styles = {
    special: "cyan",
    number: "yellow",
    boolean: "yellow",
    undefined: "grey",
    null: "bold",
    string: "green",
    date: "magenta",
    // "name": intentionally not styling
    regexp: "red"
  };
  function p(w, j) {
    var T = c.styles[j];
    return T ? "\x1B[" + c.colors[T][0] + "m" + w + "\x1B[" + c.colors[T][1] + "m" : w;
  }
  function y(w, j) {
    return w;
  }
  function D(w) {
    var j = {};
    return w.forEach(function(T, Y) {
      j[T] = !0;
    }), j;
  }
  function M(w, j, T) {
    if (w.customInspect && j && Q(j.inspect) && // Filter out the util module, it's inspect function is special
    j.inspect !== e.inspect && // Also filter out any prototype objects using the circular check.
    !(j.constructor && j.constructor.prototype === j)) {
      var Y = j.inspect(T, w);
      return H(Y) || (Y = M(w, Y, T)), Y;
    }
    var G = m(w, j);
    if (G)
      return G;
    var o = Object.keys(j), a = D(o);
    if (w.showHidden && (o = Object.getOwnPropertyNames(j)), J(j) && (o.indexOf("message") >= 0 || o.indexOf("description") >= 0))
      return z(j);
    if (o.length === 0) {
      if (Q(j)) {
        var I = j.name ? ": " + j.name : "";
        return w.stylize("[Function" + I + "]", "special");
      }
      if (te(j))
        return w.stylize(RegExp.prototype.toString.call(j), "regexp");
      if (fe(j))
        return w.stylize(Date.prototype.toString.call(j), "date");
      if (J(j))
        return z(j);
    }
    var L = "", k = !1, O = ["{", "}"];
    if (Z(j) && (k = !0, O = ["[", "]"]), Q(j)) {
      var P = j.name ? ": " + j.name : "";
      L = " [Function" + P + "]";
    }
    if (te(j) && (L = " " + RegExp.prototype.toString.call(j)), fe(j) && (L = " " + Date.prototype.toUTCString.call(j)), J(j) && (L = " " + z(j)), o.length === 0 && (!k || j.length == 0))
      return O[0] + L + O[1];
    if (T < 0)
      return te(j) ? w.stylize(RegExp.prototype.toString.call(j), "regexp") : w.stylize("[Object]", "special");
    w.seen.push(j);
    var he;
    return k ? he = R(w, j, T, a, o) : he = o.map(function(we) {
      return _(w, j, T, a, we, k);
    }), w.seen.pop(), B(he, L, O);
  }
  function m(w, j) {
    if (se(j))
      return w.stylize("undefined", "undefined");
    if (H(j)) {
      var T = "'" + JSON.stringify(j).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
      return w.stylize(T, "string");
    }
    if ($(j))
      return w.stylize("" + j, "number");
    if (b(j))
      return w.stylize("" + j, "boolean");
    if (S(j))
      return w.stylize("null", "null");
  }
  function z(w) {
    return "[" + Error.prototype.toString.call(w) + "]";
  }
  function R(w, j, T, Y, G) {
    for (var o = [], a = 0, I = j.length; a < I; ++a)
      g(j, String(a)) ? o.push(_(
        w,
        j,
        T,
        Y,
        String(a),
        !0
      )) : o.push("");
    return G.forEach(function(L) {
      L.match(/^\d+$/) || o.push(_(
        w,
        j,
        T,
        Y,
        L,
        !0
      ));
    }), o;
  }
  function _(w, j, T, Y, G, o) {
    var a, I, L;
    if (L = Object.getOwnPropertyDescriptor(j, G) || { value: j[G] }, L.get ? L.set ? I = w.stylize("[Getter/Setter]", "special") : I = w.stylize("[Getter]", "special") : L.set && (I = w.stylize("[Setter]", "special")), g(Y, G) || (a = "[" + G + "]"), I || (w.seen.indexOf(L.value) < 0 ? (S(T) ? I = M(w, L.value, null) : I = M(w, L.value, T - 1), I.indexOf(`
`) > -1 && (o ? I = I.split(`
`).map(function(k) {
      return "  " + k;
    }).join(`
`).slice(2) : I = `
` + I.split(`
`).map(function(k) {
      return "   " + k;
    }).join(`
`))) : I = w.stylize("[Circular]", "special")), se(a)) {
      if (o && G.match(/^\d+$/))
        return I;
      a = JSON.stringify("" + G), a.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (a = a.slice(1, -1), a = w.stylize(a, "name")) : (a = a.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), a = w.stylize(a, "string"));
    }
    return a + ": " + I;
  }
  function B(w, j, T) {
    var Y = w.reduce(function(G, o) {
      return o.indexOf(`
`) >= 0, G + o.replace(/\u001b\[\d\d?m/g, "").length + 1;
    }, 0);
    return Y > 60 ? T[0] + (j === "" ? "" : j + `
 `) + " " + w.join(`,
  `) + " " + T[1] : T[0] + j + " " + w.join(", ") + " " + T[1];
  }
  e.types = Qn;
  function Z(w) {
    return Array.isArray(w);
  }
  e.isArray = Z;
  function b(w) {
    return typeof w == "boolean";
  }
  e.isBoolean = b;
  function S(w) {
    return w === null;
  }
  e.isNull = S;
  function F(w) {
    return w == null;
  }
  e.isNullOrUndefined = F;
  function $(w) {
    return typeof w == "number";
  }
  e.isNumber = $;
  function H(w) {
    return typeof w == "string";
  }
  e.isString = H;
  function ye(w) {
    return typeof w == "symbol";
  }
  e.isSymbol = ye;
  function se(w) {
    return w === void 0;
  }
  e.isUndefined = se;
  function te(w) {
    return ue(w) && W(w) === "[object RegExp]";
  }
  e.isRegExp = te, e.types.isRegExp = te;
  function ue(w) {
    return typeof w == "object" && w !== null;
  }
  e.isObject = ue;
  function fe(w) {
    return ue(w) && W(w) === "[object Date]";
  }
  e.isDate = fe, e.types.isDate = fe;
  function J(w) {
    return ue(w) && (W(w) === "[object Error]" || w instanceof Error);
  }
  e.isError = J, e.types.isNativeError = J;
  function Q(w) {
    return typeof w == "function";
  }
  e.isFunction = Q;
  function V(w) {
    return w === null || typeof w == "boolean" || typeof w == "number" || typeof w == "string" || typeof w == "symbol" || // ES6 symbol
    typeof w > "u";
  }
  e.isPrimitive = V, e.isBuffer = ws;
  function W(w) {
    return Object.prototype.toString.call(w);
  }
  function K(w) {
    return w < 10 ? "0" + w.toString(10) : w.toString(10);
  }
  var re = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ];
  function f() {
    var w = /* @__PURE__ */ new Date(), j = [
      K(w.getHours()),
      K(w.getMinutes()),
      K(w.getSeconds())
    ].join(":");
    return [w.getDate(), re[w.getMonth()], j].join(" ");
  }
  e.log = function() {
    console.log("%s - %s", f(), e.format.apply(e, arguments));
  }, e.inherits = Se, e._extend = function(w, j) {
    if (!j || !ue(j))
      return w;
    for (var T = Object.keys(j), Y = T.length; Y--; )
      w[T[Y]] = j[T[Y]];
    return w;
  };
  function g(w, j) {
    return Object.prototype.hasOwnProperty.call(w, j);
  }
  var A = typeof Symbol < "u" ? Symbol("util.promisify.custom") : void 0;
  e.promisify = function(j) {
    if (typeof j != "function")
      throw new TypeError('The "original" argument must be of type Function');
    if (A && j[A]) {
      var T = j[A];
      if (typeof T != "function")
        throw new TypeError('The "util.promisify.custom" argument must be of type Function');
      return Object.defineProperty(T, A, {
        value: T,
        enumerable: !1,
        writable: !1,
        configurable: !0
      }), T;
    }
    function T() {
      for (var Y, G, o = new Promise(function(L, k) {
        Y = L, G = k;
      }), a = [], I = 0; I < arguments.length; I++)
        a.push(arguments[I]);
      a.push(function(L, k) {
        L ? G(L) : Y(k);
      });
      try {
        j.apply(this, a);
      } catch (L) {
        G(L);
      }
      return o;
    }
    return Object.setPrototypeOf(T, Object.getPrototypeOf(j)), A && Object.defineProperty(T, A, {
      value: T,
      enumerable: !1,
      writable: !1,
      configurable: !0
    }), Object.defineProperties(
      T,
      t(j)
    );
  }, e.promisify.custom = A;
  function v(w, j) {
    if (!w) {
      var T = new Error("Promise was rejected with a falsy value");
      T.reason = w, w = T;
    }
    return j(w);
  }
  function U(w) {
    if (typeof w != "function")
      throw new TypeError('The "original" argument must be of type Function');
    function j() {
      for (var T = [], Y = 0; Y < arguments.length; Y++)
        T.push(arguments[Y]);
      var G = T.pop();
      if (typeof G != "function")
        throw new TypeError("The last argument must be of type Function");
      var o = this, a = function() {
        return G.apply(o, arguments);
      };
      w.apply(this, T).then(
        function(I) {
          q.nextTick(a.bind(null, null, I));
        },
        function(I) {
          q.nextTick(v.bind(null, I, a));
        }
      );
    }
    return Object.setPrototypeOf(j, Object.getPrototypeOf(w)), Object.defineProperties(
      j,
      t(w)
    ), j;
  }
  e.callbackify = U;
})(at);
var ur = { exports: {} }, Mn;
function Cs() {
  return Mn || (Mn = 1, function(e) {
    function t(d, c) {
      if (!(d instanceof c))
        throw new TypeError("Cannot call a class as a function");
    }
    var n = Ur.Buffer, s = at;
    function u(d, c, p) {
      d.copy(c, p);
    }
    e.exports = function() {
      function d() {
        t(this, d), this.head = null, this.tail = null, this.length = 0;
      }
      return d.prototype.push = function(p) {
        var y = { data: p, next: null };
        this.length > 0 ? this.tail.next = y : this.head = y, this.tail = y, ++this.length;
      }, d.prototype.unshift = function(p) {
        var y = { data: p, next: this.head };
        this.length === 0 && (this.tail = y), this.head = y, ++this.length;
      }, d.prototype.shift = function() {
        if (this.length !== 0) {
          var p = this.head.data;
          return this.length === 1 ? this.head = this.tail = null : this.head = this.head.next, --this.length, p;
        }
      }, d.prototype.clear = function() {
        this.head = this.tail = null, this.length = 0;
      }, d.prototype.join = function(p) {
        if (this.length === 0)
          return "";
        for (var y = this.head, D = "" + y.data; y = y.next; )
          D += p + y.data;
        return D;
      }, d.prototype.concat = function(p) {
        if (this.length === 0)
          return n.alloc(0);
        for (var y = n.allocUnsafe(p >>> 0), D = this.head, M = 0; D; )
          u(D.data, y, M), M += D.data.length, D = D.next;
        return y;
      }, d;
    }(), s && s.inspect && s.inspect.custom && (e.exports.prototype[s.inspect.custom] = function() {
      var d = s.inspect({ length: this.length });
      return this.constructor.name + " " + d;
    });
  }(ur)), ur.exports;
}
var dt = Ge;
function As(e, t) {
  var n = this, s = this._readableState && this._readableState.destroyed, u = this._writableState && this._writableState.destroyed;
  return s || u ? (t ? t(e) : e && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, dt.nextTick(ft, this, e)) : dt.nextTick(ft, this, e)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(e || null, function(d) {
    !t && d ? n._writableState ? n._writableState.errorEmitted || (n._writableState.errorEmitted = !0, dt.nextTick(ft, n, d)) : dt.nextTick(ft, n, d) : t && t(d);
  }), this);
}
function Ls() {
  this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
}
function ft(e, t) {
  e.emit("error", t);
}
function ms(e, t) {
  if (cr("noDeprecation"))
    return e;
  var n = !1;
  function s() {
    if (!n) {
      if (cr("throwDeprecation"))
        throw new Error(t);
      cr("traceDeprecation") ? console.trace(t) : console.warn(t), n = !0;
    }
    return e.apply(this, arguments);
  }
  return s;
}
var ui = {
  destroy: As,
  undestroy: Ls
}, ci = ms;

function cr(e) {
  try {
    if (!ie.localStorage)
      return !1;
  } catch {
    return !1;
  }
  var t = ie.localStorage[e];
  return t == null ? !1 : String(t).toLowerCase() === "true";
}
var lr, In;
function li() {
  if (In)
    return lr;
  In = 1;
  var e = Ge;
  lr = B;
  function t(f) {
    var g = this;
    this.next = null, this.entry = null, this.finish = function() {
      re(g, f);
    };
  }
  var n = !q.browser && ["v0.10", "v0.9."].indexOf(q.version.slice(0, 5)) > -1 ? setImmediate : e.nextTick, s;
  B.WritableState = R;
  var u = Object.create(oe);
  u.inherits = Se;
  var d = {
    deprecate: ci
  }, c = Zn, p = Ur.Buffer, y = (typeof ie < "u" ? ie : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
  };
  function D(f) {
    return p.from(f);
  }
  function M(f) {
    return p.isBuffer(f) || f instanceof y;
  }
  var m = ui;
  u.inherits(B, c);
  function z() {
  }
  function R(f, g) {
    s = s || Ke(), f = f || {};
    var A = g instanceof s;
    this.objectMode = !!f.objectMode, A && (this.objectMode = this.objectMode || !!f.writableObjectMode);
    var v = f.highWaterMark, U = f.writableHighWaterMark, w = this.objectMode ? 16 : 16 * 1024;
    v || v === 0 ? this.highWaterMark = v : A && (U || U === 0) ? this.highWaterMark = U : this.highWaterMark = w, this.highWaterMark = Math.floor(this.highWaterMark), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
    var j = f.decodeStrings === !1;
    this.decodeStrings = !j, this.defaultEncoding = f.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(T) {
      se(g, T);
    }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.bufferedRequestCount = 0, this.corkedRequestsFree = new t(this);
  }
  R.prototype.getBuffer = function() {
    for (var g = this.bufferedRequest, A = []; g; )
      A.push(g), g = g.next;
    return A;
  }, function() {
    try {
      Object.defineProperty(R.prototype, "buffer", {
        get: d.deprecate(function() {
          return this.getBuffer();
        }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
      });
    } catch {
    }
  }();
  var _;
  typeof Symbol == "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] == "function" ? (_ = Function.prototype[Symbol.hasInstance], Object.defineProperty(B, Symbol.hasInstance, {
    value: function(f) {
      return _.call(this, f) ? !0 : this !== B ? !1 : f && f._writableState instanceof R;
    }
  })) : _ = function(f) {
    return f instanceof this;
  };
  function B(f) {
    if (s = s || Ke(), !_.call(B, this) && !(this instanceof s))
      return new B(f);
    this._writableState = new R(f, this), this.writable = !0, f && (typeof f.write == "function" && (this._write = f.write), typeof f.writev == "function" && (this._writev = f.writev), typeof f.destroy == "function" && (this._destroy = f.destroy), typeof f.final == "function" && (this._final = f.final)), c.call(this);
  }
  B.prototype.pipe = function() {
    this.emit("error", new Error("Cannot pipe, not readable"));
  };
  function Z(f, g) {
    var A = new Error("write after end");
    f.emit("error", A), e.nextTick(g, A);
  }
  function b(f, g, A, v) {
    var U = !0, w = !1;
    return A === null ? w = new TypeError("May not write null values to stream") : typeof A != "string" && A !== void 0 && !g.objectMode && (w = new TypeError("Invalid non-string/buffer chunk")), w && (f.emit("error", w), e.nextTick(v, w), U = !1), U;
  }
  B.prototype.write = function(f, g, A) {
    var v = this._writableState, U = !1, w = !v.objectMode && M(f);
    return w && !p.isBuffer(f) && (f = D(f)), typeof g == "function" && (A = g, g = null), w ? g = "buffer" : g || (g = v.defaultEncoding), typeof A != "function" && (A = z), v.ended ? Z(this, A) : (w || b(this, v, f, A)) && (v.pendingcb++, U = F(this, v, w, f, g, A)), U;
  }, B.prototype.cork = function() {
    var f = this._writableState;
    f.corked++;
  }, B.prototype.uncork = function() {
    var f = this._writableState;
    f.corked && (f.corked--, !f.writing && !f.corked && !f.bufferProcessing && f.bufferedRequest && fe(this, f));
  }, B.prototype.setDefaultEncoding = function(g) {
    if (typeof g == "string" && (g = g.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((g + "").toLowerCase()) > -1))
      throw new TypeError("Unknown encoding: " + g);
    return this._writableState.defaultEncoding = g, this;
  };
  function S(f, g, A) {
    return !f.objectMode && f.decodeStrings !== !1 && typeof g == "string" && (g = p.from(g, A)), g;
  }
  Object.defineProperty(B.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  });
  function F(f, g, A, v, U, w) {
    if (!A) {
      var j = S(g, v, U);
      v !== j && (A = !0, U = "buffer", v = j);
    }
    var T = g.objectMode ? 1 : v.length;
    g.length += T;
    var Y = g.length < g.highWaterMark;
    if (Y || (g.needDrain = !0), g.writing || g.corked) {
      var G = g.lastBufferedRequest;
      g.lastBufferedRequest = {
        chunk: v,
        encoding: U,
        isBuf: A,
        callback: w,
        next: null
      }, G ? G.next = g.lastBufferedRequest : g.bufferedRequest = g.lastBufferedRequest, g.bufferedRequestCount += 1;
    } else
      $(f, g, !1, T, v, U, w);
    return Y;
  }
  function $(f, g, A, v, U, w, j) {
    g.writelen = v, g.writecb = j, g.writing = !0, g.sync = !0, A ? f._writev(U, g.onwrite) : f._write(U, w, g.onwrite), g.sync = !1;
  }
  function H(f, g, A, v, U) {
    --g.pendingcb, A ? (e.nextTick(U, v), e.nextTick(W, f, g), f._writableState.errorEmitted = !0, f.emit("error", v)) : (U(v), f._writableState.errorEmitted = !0, f.emit("error", v), W(f, g));
  }
  function ye(f) {
    f.writing = !1, f.writecb = null, f.length -= f.writelen, f.writelen = 0;
  }
  function se(f, g) {
    var A = f._writableState, v = A.sync, U = A.writecb;
    if (ye(A), g)
      H(f, A, v, g, U);
    else {
      var w = J(A);
      !w && !A.corked && !A.bufferProcessing && A.bufferedRequest && fe(f, A), v ? n(te, f, A, w, U) : te(f, A, w, U);
    }
  }
  function te(f, g, A, v) {
    A || ue(f, g), g.pendingcb--, v(), W(f, g);
  }
  function ue(f, g) {
    g.length === 0 && g.needDrain && (g.needDrain = !1, f.emit("drain"));
  }
  function fe(f, g) {
    g.bufferProcessing = !0;
    var A = g.bufferedRequest;
    if (f._writev && A && A.next) {
      var v = g.bufferedRequestCount, U = new Array(v), w = g.corkedRequestsFree;
      w.entry = A;
      for (var j = 0, T = !0; A; )
        U[j] = A, A.isBuf || (T = !1), A = A.next, j += 1;
      U.allBuffers = T, $(f, g, !0, g.length, U, "", w.finish), g.pendingcb++, g.lastBufferedRequest = null, w.next ? (g.corkedRequestsFree = w.next, w.next = null) : g.corkedRequestsFree = new t(g), g.bufferedRequestCount = 0;
    } else {
      for (; A; ) {
        var Y = A.chunk, G = A.encoding, o = A.callback, a = g.objectMode ? 1 : Y.length;
        if ($(f, g, !1, a, Y, G, o), A = A.next, g.bufferedRequestCount--, g.writing)
          break;
      }
      A === null && (g.lastBufferedRequest = null);
    }
    g.bufferedRequest = A, g.bufferProcessing = !1;
  }
  B.prototype._write = function(f, g, A) {
    A(new Error("_write() is not implemented"));
  }, B.prototype._writev = null, B.prototype.end = function(f, g, A) {
    var v = this._writableState;
    typeof f == "function" ? (A = f, f = null, g = null) : typeof g == "function" && (A = g, g = null), f != null && this.write(f, g), v.corked && (v.corked = 1, this.uncork()), v.ending || K(this, v, A);
  };
  function J(f) {
    return f.ending && f.length === 0 && f.bufferedRequest === null && !f.finished && !f.writing;
  }
  function Q(f, g) {
    f._final(function(A) {
      g.pendingcb--, A && f.emit("error", A), g.prefinished = !0, f.emit("prefinish"), W(f, g);
    });
  }
  function V(f, g) {
    !g.prefinished && !g.finalCalled && (typeof f._final == "function" ? (g.pendingcb++, g.finalCalled = !0, e.nextTick(Q, f, g)) : (g.prefinished = !0, f.emit("prefinish")));
  }
  function W(f, g) {
    var A = J(g);
    return A && (V(f, g), g.pendingcb === 0 && (g.finished = !0, f.emit("finish"))), A;
  }
  function K(f, g, A) {
    g.ending = !0, W(f, g), A && (g.finished ? e.nextTick(A) : f.once("finish", A)), g.ended = !0, f.writable = !1;
  }
  function re(f, g, A) {
    var v = f.entry;
    for (f.entry = null; v; ) {
      var U = v.callback;
      g.pendingcb--, U(A), v = v.next;
    }
    g.corkedRequestsFree.next = f;
  }
  return Object.defineProperty(B.prototype, "destroyed", {
    get: function() {
      return this._writableState === void 0 ? !1 : this._writableState.destroyed;
    },
    set: function(f) {
      this._writableState && (this._writableState.destroyed = f);
    }
  }), B.prototype.destroy = m.destroy, B.prototype._undestroy = m.undestroy, B.prototype._destroy = function(f, g) {
    this.end(), g(f);
  }, lr;
}
var dr, wn;
function Ke() {
  if (wn)
    return dr;
  wn = 1;
  var e = Ge, t = Object.keys || function(m) {
    var z = [];
    for (var R in m)
      z.push(R);
    return z;
  };
  dr = y;
  var n = Object.create(oe);
  n.inherits = Se;
  var s = di(), u = li();
  n.inherits(y, s);
  for (var d = t(u.prototype), c = 0; c < d.length; c++) {
    var p = d[c];
    y.prototype[p] || (y.prototype[p] = u.prototype[p]);
  }
  function y(m) {
    if (!(this instanceof y))
      return new y(m);
    s.call(this, m), u.call(this, m), m && m.readable === !1 && (this.readable = !1), m && m.writable === !1 && (this.writable = !1), this.allowHalfOpen = !0, m && m.allowHalfOpen === !1 && (this.allowHalfOpen = !1), this.once("end", D);
  }
  Object.defineProperty(y.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  });
  function D() {
    this.allowHalfOpen || this._writableState.ended || e.nextTick(M, this);
  }
  function M(m) {
    m.end();
  }
  return Object.defineProperty(y.prototype, "destroyed", {
    get: function() {
      return this._readableState === void 0 || this._writableState === void 0 ? !1 : this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function(m) {
      this._readableState === void 0 || this._writableState === void 0 || (this._readableState.destroyed = m, this._writableState.destroyed = m);
    }
  }), y.prototype._destroy = function(m, z) {
    this.push(null), this.end(), e.nextTick(z, m);
  }, dr;
}
var fr = {}, Cn;
function mt() {
  if (Cn)
    return fr;
  Cn = 1;
  var e = $o.Buffer, t = e.isEncoding || function(b) {
    switch (b = "" + b, b && b.toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
      case "raw":
        return !0;
      default:
        return !1;
    }
  };
  function n(b) {
    if (!b)
      return "utf8";
    for (var S; ; )
      switch (b) {
        case "utf8":
        case "utf-8":
          return "utf8";
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return "utf16le";
        case "latin1":
        case "binary":
          return "latin1";
        case "base64":
        case "ascii":
        case "hex":
          return b;
        default:
          if (S)
            return;
          b = ("" + b).toLowerCase(), S = !0;
      }
  }
  function s(b) {
    var S = n(b);
    if (typeof S != "string" && (e.isEncoding === t || !t(b)))
      throw new Error("Unknown encoding: " + b);
    return S || b;
  }
  fr.StringDecoder = u;
  function u(b) {
    this.encoding = s(b);
    var S;
    switch (this.encoding) {
      case "utf16le":
        this.text = m, this.end = z, S = 4;
        break;
      case "utf8":
        this.fillLast = y, S = 4;
        break;
      case "base64":
        this.text = R, this.end = _, S = 3;
        break;
      default:
        this.write = B, this.end = Z;
        return;
    }
    this.lastNeed = 0, this.lastTotal = 0, this.lastChar = e.allocUnsafe(S);
  }
  u.prototype.write = function(b) {
    if (b.length === 0)
      return "";
    var S, F;
    if (this.lastNeed) {
      if (S = this.fillLast(b), S === void 0)
        return "";
      F = this.lastNeed, this.lastNeed = 0;
    } else
      F = 0;
    return F < b.length ? S ? S + this.text(b, F) : this.text(b, F) : S || "";
  }, u.prototype.end = M, u.prototype.text = D, u.prototype.fillLast = function(b) {
    if (this.lastNeed <= b.length)
      return b.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
    b.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, b.length), this.lastNeed -= b.length;
  };
  function d(b) {
    return b <= 127 ? 0 : b >> 5 === 6 ? 2 : b >> 4 === 14 ? 3 : b >> 3 === 30 ? 4 : b >> 6 === 2 ? -1 : -2;
  }
  function c(b, S, F) {
    var $ = S.length - 1;
    if ($ < F)
      return 0;
    var H = d(S[$]);
    return H >= 0 ? (H > 0 && (b.lastNeed = H - 1), H) : --$ < F || H === -2 ? 0 : (H = d(S[$]), H >= 0 ? (H > 0 && (b.lastNeed = H - 2), H) : --$ < F || H === -2 ? 0 : (H = d(S[$]), H >= 0 ? (H > 0 && (H === 2 ? H = 0 : b.lastNeed = H - 3), H) : 0));
  }
  function p(b, S, F) {
    if ((S[0] & 192) !== 128)
      return b.lastNeed = 0, "�";
    if (b.lastNeed > 1 && S.length > 1) {
      if ((S[1] & 192) !== 128)
        return b.lastNeed = 1, "�";
      if (b.lastNeed > 2 && S.length > 2 && (S[2] & 192) !== 128)
        return b.lastNeed = 2, "�";
    }
  }
  function y(b) {
    var S = this.lastTotal - this.lastNeed, F = p(this, b);
    if (F !== void 0)
      return F;
    if (this.lastNeed <= b.length)
      return b.copy(this.lastChar, S, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
    b.copy(this.lastChar, S, 0, b.length), this.lastNeed -= b.length;
  }
  function D(b, S) {
    var F = c(this, b, S);
    if (!this.lastNeed)
      return b.toString("utf8", S);
    this.lastTotal = F;
    var $ = b.length - (F - this.lastNeed);
    return b.copy(this.lastChar, 0, $), b.toString("utf8", S, $);
  }
  function M(b) {
    var S = b && b.length ? this.write(b) : "";
    return this.lastNeed ? S + "�" : S;
  }
  function m(b, S) {
    if ((b.length - S) % 2 === 0) {
      var F = b.toString("utf16le", S);
      if (F) {
        var $ = F.charCodeAt(F.length - 1);
        if ($ >= 55296 && $ <= 56319)
          return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = b[b.length - 2], this.lastChar[1] = b[b.length - 1], F.slice(0, -1);
      }
      return F;
    }
    return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = b[b.length - 1], b.toString("utf16le", S, b.length - 1);
  }
  function z(b) {
    var S = b && b.length ? this.write(b) : "";
    if (this.lastNeed) {
      var F = this.lastTotal - this.lastNeed;
      return S + this.lastChar.toString("utf16le", 0, F);
    }
    return S;
  }
  function R(b, S) {
    var F = (b.length - S) % 3;
    return F === 0 ? b.toString("base64", S) : (this.lastNeed = 3 - F, this.lastTotal = 3, F === 1 ? this.lastChar[0] = b[b.length - 1] : (this.lastChar[0] = b[b.length - 2], this.lastChar[1] = b[b.length - 1]), b.toString("base64", S, b.length - F));
  }
  function _(b) {
    var S = b && b.length ? this.write(b) : "";
    return this.lastNeed ? S + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : S;
  }
  function B(b) {
    return b.toString(this.encoding);
  }
  function Z(b) {
    return b && b.length ? this.write(b) : "";
  }
  return fr;
}
var gr, An;
function di() {
  if (An)
    return gr;
  An = 1;
  var e = Ge;
  gr = S;
  var t = Ko, n;
  S.ReadableState = b, et.EventEmitter;
  var s = function(o, a) {
    return o.listeners(a).length;
  }, u = Zn, d = Ur.Buffer, c = (typeof ie < "u" ? ie : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
  };
  function p(o) {
    return d.from(o);
  }
  function y(o) {
    return d.isBuffer(o) || o instanceof c;
  }
  var D = Object.create(oe);
  D.inherits = Se;
  var M = at, m = void 0;
  M && M.debuglog ? m = M.debuglog("stream") : m = function() {
  };
  var z = Cs(), R = ui, _;
  D.inherits(S, u);
  var B = ["error", "close", "destroy", "pause", "resume"];
  function Z(o, a, I) {
    if (typeof o.prependListener == "function")
      return o.prependListener(a, I);
    !o._events || !o._events[a] ? o.on(a, I) : t(o._events[a]) ? o._events[a].unshift(I) : o._events[a] = [I, o._events[a]];
  }
  function b(o, a) {
    n = n || Ke(), o = o || {};
    var I = a instanceof n;
    this.objectMode = !!o.objectMode, I && (this.objectMode = this.objectMode || !!o.readableObjectMode);
    var L = o.highWaterMark, k = o.readableHighWaterMark, O = this.objectMode ? 16 : 16 * 1024;
    L || L === 0 ? this.highWaterMark = L : I && (k || k === 0) ? this.highWaterMark = k : this.highWaterMark = O, this.highWaterMark = Math.floor(this.highWaterMark), this.buffer = new z(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.destroyed = !1, this.defaultEncoding = o.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, o.encoding && (_ || (_ = mt().StringDecoder), this.decoder = new _(o.encoding), this.encoding = o.encoding);
  }
  function S(o) {
    if (n = n || Ke(), !(this instanceof S))
      return new S(o);
    this._readableState = new b(o, this), this.readable = !0, o && (typeof o.read == "function" && (this._read = o.read), typeof o.destroy == "function" && (this._destroy = o.destroy)), u.call(this);
  }
  Object.defineProperty(S.prototype, "destroyed", {
    get: function() {
      return this._readableState === void 0 ? !1 : this._readableState.destroyed;
    },
    set: function(o) {
      this._readableState && (this._readableState.destroyed = o);
    }
  }), S.prototype.destroy = R.destroy, S.prototype._undestroy = R.undestroy, S.prototype._destroy = function(o, a) {
    this.push(null), a(o);
  }, S.prototype.push = function(o, a) {
    var I = this._readableState, L;
    return I.objectMode ? L = !0 : typeof o == "string" && (a = a || I.defaultEncoding, a !== I.encoding && (o = d.from(o, a), a = ""), L = !0), F(this, o, a, !1, L);
  }, S.prototype.unshift = function(o) {
    return F(this, o, null, !0, !1);
  };
  function F(o, a, I, L, k) {
    var O = o._readableState;
    if (a === null)
      O.reading = !1, fe(o, O);
    else {
      var P;
      k || (P = H(O, a)), P ? o.emit("error", P) : O.objectMode || a && a.length > 0 ? (typeof a != "string" && !O.objectMode && Object.getPrototypeOf(a) !== d.prototype && (a = p(a)), L ? O.endEmitted ? o.emit("error", new Error("stream.unshift() after end event")) : $(o, O, a, !0) : O.ended ? o.emit("error", new Error("stream.push() after EOF")) : (O.reading = !1, O.decoder && !I ? (a = O.decoder.write(a), O.objectMode || a.length !== 0 ? $(o, O, a, !1) : V(o, O)) : $(o, O, a, !1))) : L || (O.reading = !1);
    }
    return ye(O);
  }
  function $(o, a, I, L) {
    a.flowing && a.length === 0 && !a.sync ? (o.emit("data", I), o.read(0)) : (a.length += a.objectMode ? 1 : I.length, L ? a.buffer.unshift(I) : a.buffer.push(I), a.needReadable && J(o)), V(o, a);
  }
  function H(o, a) {
    var I;
    return !y(a) && typeof a != "string" && a !== void 0 && !o.objectMode && (I = new TypeError("Invalid non-string/buffer chunk")), I;
  }
  function ye(o) {
    return !o.ended && (o.needReadable || o.length < o.highWaterMark || o.length === 0);
  }
  S.prototype.isPaused = function() {
    return this._readableState.flowing === !1;
  }, S.prototype.setEncoding = function(o) {
    return _ || (_ = mt().StringDecoder), this._readableState.decoder = new _(o), this._readableState.encoding = o, this;
  };
  var se = 8388608;
  function te(o) {
    return o >= se ? o = se : (o--, o |= o >>> 1, o |= o >>> 2, o |= o >>> 4, o |= o >>> 8, o |= o >>> 16, o++), o;
  }
  function ue(o, a) {
    return o <= 0 || a.length === 0 && a.ended ? 0 : a.objectMode ? 1 : o !== o ? a.flowing && a.length ? a.buffer.head.data.length : a.length : (o > a.highWaterMark && (a.highWaterMark = te(o)), o <= a.length ? o : a.ended ? a.length : (a.needReadable = !0, 0));
  }
  S.prototype.read = function(o) {
    m("read", o), o = parseInt(o, 10);
    var a = this._readableState, I = o;
    if (o !== 0 && (a.emittedReadable = !1), o === 0 && a.needReadable && (a.length >= a.highWaterMark || a.ended))
      return m("read: emitReadable", a.length, a.ended), a.length === 0 && a.ended ? T(this) : J(this), null;
    if (o = ue(o, a), o === 0 && a.ended)
      return a.length === 0 && T(this), null;
    var L = a.needReadable;
    m("need readable", L), (a.length === 0 || a.length - o < a.highWaterMark) && (L = !0, m("length less than watermark", L)), a.ended || a.reading ? (L = !1, m("reading or ended", L)) : L && (m("do read"), a.reading = !0, a.sync = !0, a.length === 0 && (a.needReadable = !0), this._read(a.highWaterMark), a.sync = !1, a.reading || (o = ue(I, a)));
    var k;
    return o > 0 ? k = v(o, a) : k = null, k === null ? (a.needReadable = !0, o = 0) : a.length -= o, a.length === 0 && (a.ended || (a.needReadable = !0), I !== o && a.ended && T(this)), k !== null && this.emit("data", k), k;
  };
  function fe(o, a) {
    if (!a.ended) {
      if (a.decoder) {
        var I = a.decoder.end();
        I && I.length && (a.buffer.push(I), a.length += a.objectMode ? 1 : I.length);
      }
      a.ended = !0, J(o);
    }
  }
  function J(o) {
    var a = o._readableState;
    a.needReadable = !1, a.emittedReadable || (m("emitReadable", a.flowing), a.emittedReadable = !0, a.sync ? e.nextTick(Q, o) : Q(o));
  }
  function Q(o) {
    m("emit readable"), o.emit("readable"), A(o);
  }
  function V(o, a) {
    a.readingMore || (a.readingMore = !0, e.nextTick(W, o, a));
  }
  function W(o, a) {
    for (var I = a.length; !a.reading && !a.flowing && !a.ended && a.length < a.highWaterMark && (m("maybeReadMore read 0"), o.read(0), I !== a.length); )
      I = a.length;
    a.readingMore = !1;
  }
  S.prototype._read = function(o) {
    this.emit("error", new Error("_read() is not implemented"));
  }, S.prototype.pipe = function(o, a) {
    var I = this, L = this._readableState;
    switch (L.pipesCount) {
      case 0:
        L.pipes = o;
        break;
      case 1:
        L.pipes = [L.pipes, o];
        break;
      default:
        L.pipes.push(o);
        break;
    }
    L.pipesCount += 1, m("pipe count=%d opts=%j", L.pipesCount, a);
    var k = (!a || a.end !== !1) && o !== q.stdout && o !== q.stderr, O = k ? he : Ae;
    L.endEmitted ? e.nextTick(O) : I.once("end", O), o.on("unpipe", P);
    function P(pe, ce) {
      m("onunpipe"), pe === I && ce && ce.hasUnpiped === !1 && (ce.hasUnpiped = !0, De());
    }
    function he() {
      m("onend"), o.end();
    }
    var we = K(I);
    o.on("drain", we);
    var Ce = !1;
    function De() {
      m("cleanup"), o.removeListener("close", Ee), o.removeListener("finish", ze), o.removeListener("drain", we), o.removeListener("error", Le), o.removeListener("unpipe", P), I.removeListener("end", he), I.removeListener("end", Ae), I.removeListener("data", x), Ce = !0, L.awaitDrain && (!o._writableState || o._writableState.needDrain) && we();
    }
    var be = !1;
    I.on("data", x);
    function x(pe) {
      m("ondata"), be = !1;
      var ce = o.write(pe);
      ce === !1 && !be && ((L.pipesCount === 1 && L.pipes === o || L.pipesCount > 1 && G(L.pipes, o) !== -1) && !Ce && (m("false write response, pause", L.awaitDrain), L.awaitDrain++, be = !0), I.pause());
    }
    function Le(pe) {
      m("onerror", pe), Ae(), o.removeListener("error", Le), s(o, "error") === 0 && o.emit("error", pe);
    }
    Z(o, "error", Le);
    function Ee() {
      o.removeListener("finish", ze), Ae();
    }
    o.once("close", Ee);
    function ze() {
      m("onfinish"), o.removeListener("close", Ee), Ae();
    }
    o.once("finish", ze);
    function Ae() {
      m("unpipe"), I.unpipe(o);
    }
    return o.emit("pipe", I), L.flowing || (m("pipe resume"), I.resume()), o;
  };
  function K(o) {
    return function() {
      var a = o._readableState;
      m("pipeOnDrain", a.awaitDrain), a.awaitDrain && a.awaitDrain--, a.awaitDrain === 0 && s(o, "data") && (a.flowing = !0, A(o));
    };
  }
  S.prototype.unpipe = function(o) {
    var a = this._readableState, I = { hasUnpiped: !1 };
    if (a.pipesCount === 0)
      return this;
    if (a.pipesCount === 1)
      return o && o !== a.pipes ? this : (o || (o = a.pipes), a.pipes = null, a.pipesCount = 0, a.flowing = !1, o && o.emit("unpipe", this, I), this);
    if (!o) {
      var L = a.pipes, k = a.pipesCount;
      a.pipes = null, a.pipesCount = 0, a.flowing = !1;
      for (var O = 0; O < k; O++)
        L[O].emit("unpipe", this, { hasUnpiped: !1 });
      return this;
    }
    var P = G(a.pipes, o);
    return P === -1 ? this : (a.pipes.splice(P, 1), a.pipesCount -= 1, a.pipesCount === 1 && (a.pipes = a.pipes[0]), o.emit("unpipe", this, I), this);
  }, S.prototype.on = function(o, a) {
    var I = u.prototype.on.call(this, o, a);
    if (o === "data")
      this._readableState.flowing !== !1 && this.resume();
    else if (o === "readable") {
      var L = this._readableState;
      !L.endEmitted && !L.readableListening && (L.readableListening = L.needReadable = !0, L.emittedReadable = !1, L.reading ? L.length && J(this) : e.nextTick(re, this));
    }
    return I;
  }, S.prototype.addListener = S.prototype.on;
  function re(o) {
    m("readable nexttick read 0"), o.read(0);
  }
  S.prototype.resume = function() {
    var o = this._readableState;
    return o.flowing || (m("resume"), o.flowing = !0, f(this, o)), this;
  };
  function f(o, a) {
    a.resumeScheduled || (a.resumeScheduled = !0, e.nextTick(g, o, a));
  }
  function g(o, a) {
    a.reading || (m("resume read 0"), o.read(0)), a.resumeScheduled = !1, a.awaitDrain = 0, o.emit("resume"), A(o), a.flowing && !a.reading && o.read(0);
  }
  S.prototype.pause = function() {
    return m("call pause flowing=%j", this._readableState.flowing), this._readableState.flowing !== !1 && (m("pause"), this._readableState.flowing = !1, this.emit("pause")), this;
  };
  function A(o) {
    var a = o._readableState;
    for (m("flow", a.flowing); a.flowing && o.read() !== null; )
      ;
  }
  S.prototype.wrap = function(o) {
    var a = this, I = this._readableState, L = !1;
    o.on("end", function() {
      if (m("wrapped end"), I.decoder && !I.ended) {
        var P = I.decoder.end();
        P && P.length && a.push(P);
      }
      a.push(null);
    }), o.on("data", function(P) {
      if (m("wrapped data"), I.decoder && (P = I.decoder.write(P)), !(I.objectMode && P == null) && !(!I.objectMode && (!P || !P.length))) {
        var he = a.push(P);
        he || (L = !0, o.pause());
      }
    });
    for (var k in o)
      this[k] === void 0 && typeof o[k] == "function" && (this[k] = function(P) {
        return function() {
          return o[P].apply(o, arguments);
        };
      }(k));
    for (var O = 0; O < B.length; O++)
      o.on(B[O], this.emit.bind(this, B[O]));
    return this._read = function(P) {
      m("wrapped _read", P), L && (L = !1, o.resume());
    }, this;
  }, Object.defineProperty(S.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.highWaterMark;
    }
  }), S._fromList = v;
  function v(o, a) {
    if (a.length === 0)
      return null;
    var I;
    return a.objectMode ? I = a.buffer.shift() : !o || o >= a.length ? (a.decoder ? I = a.buffer.join("") : a.buffer.length === 1 ? I = a.buffer.head.data : I = a.buffer.concat(a.length), a.buffer.clear()) : I = U(o, a.buffer, a.decoder), I;
  }
  function U(o, a, I) {
    var L;
    return o < a.head.data.length ? (L = a.head.data.slice(0, o), a.head.data = a.head.data.slice(o)) : o === a.head.data.length ? L = a.shift() : L = I ? w(o, a) : j(o, a), L;
  }
  function w(o, a) {
    var I = a.head, L = 1, k = I.data;
    for (o -= k.length; I = I.next; ) {
      var O = I.data, P = o > O.length ? O.length : o;
      if (P === O.length ? k += O : k += O.slice(0, o), o -= P, o === 0) {
        P === O.length ? (++L, I.next ? a.head = I.next : a.head = a.tail = null) : (a.head = I, I.data = O.slice(P));
        break;
      }
      ++L;
    }
    return a.length -= L, k;
  }
  function j(o, a) {
    var I = d.allocUnsafe(o), L = a.head, k = 1;
    for (L.data.copy(I), o -= L.data.length; L = L.next; ) {
      var O = L.data, P = o > O.length ? O.length : o;
      if (O.copy(I, I.length - o, 0, P), o -= P, o === 0) {
        P === O.length ? (++k, L.next ? a.head = L.next : a.head = a.tail = null) : (a.head = L, L.data = O.slice(P));
        break;
      }
      ++k;
    }
    return a.length -= k, I;
  }
  function T(o) {
    var a = o._readableState;
    if (a.length > 0)
      throw new Error('"endReadable()" called on non-empty stream');
    a.endEmitted || (a.ended = !0, e.nextTick(Y, a, o));
  }
  function Y(o, a) {
    !o.endEmitted && o.length === 0 && (o.endEmitted = !0, a.readable = !1, a.emit("end"));
  }
  function G(o, a) {
    for (var I = 0, L = o.length; I < L; I++)
      if (o[I] === a)
        return I;
    return -1;
  }
  return gr;
}
var fi = Be, Ot = Ke(), gi = Object.create(oe);
gi.inherits = Se;
gi.inherits(Be, Ot);
function js(e, t) {
  var n = this._transformState;
  n.transforming = !1;
  var s = n.writecb;
  if (!s)
    return this.emit("error", new Error("write callback called multiple times"));
  n.writechunk = null, n.writecb = null, t != null && this.push(t), s(e);
  var u = this._readableState;
  u.reading = !1, (u.needReadable || u.length < u.highWaterMark) && this._read(u.highWaterMark);
}
function Be(e) {
  if (!(this instanceof Be))
    return new Be(e);
  Ot.call(this, e), this._transformState = {
    afterTransform: js.bind(this),
    needTransform: !1,
    transforming: !1,
    writecb: null,
    writechunk: null,
    writeencoding: null
  }, this._readableState.needReadable = !0, this._readableState.sync = !1, e && (typeof e.transform == "function" && (this._transform = e.transform), typeof e.flush == "function" && (this._flush = e.flush)), this.on("prefinish", Ns);
}
function Ns() {
  var e = this;
  typeof this._flush == "function" ? this._flush(function(t, n) {
    Ln(e, t, n);
  }) : Ln(this, null, null);
}
Be.prototype.push = function(e, t) {
  return this._transformState.needTransform = !1, Ot.prototype.push.call(this, e, t);
};
Be.prototype._transform = function(e, t, n) {
  throw new Error("_transform() is not implemented");
};
Be.prototype._write = function(e, t, n) {
  var s = this._transformState;
  if (s.writecb = n, s.writechunk = e, s.writeencoding = t, !s.transforming) {
    var u = this._readableState;
    (s.needTransform || u.needReadable || u.length < u.highWaterMark) && this._read(u.highWaterMark);
  }
};
Be.prototype._read = function(e) {
  var t = this._transformState;
  t.writechunk !== null && t.writecb && !t.transforming ? (t.transforming = !0, this._transform(t.writechunk, t.writeencoding, t.afterTransform)) : t.needTransform = !0;
};
Be.prototype._destroy = function(e, t) {
  var n = this;
  Ot.prototype._destroy.call(this, e, function(s) {
    t(s), n.emit("close");
  });
};
function Ln(e, t, n) {
  if (t)
    return e.emit("error", t);
  if (n != null && e.push(n), e._writableState.length)
    throw new Error("Calling transform done when ws.length != 0");
  if (e._transformState.transforming)
    throw new Error("Calling transform done when still transforming");
  return e.push(null);
}
var Ds = rt, hi = fi, pi = Object.create(oe);
pi.inherits = Se;
pi.inherits(rt, hi);
function rt(e) {
  if (!(this instanceof rt))
    return new rt(e);
  hi.call(this, e);
}
rt.prototype._transform = function(e, t, n) {
  n(null, e);
};
(function(e, t) {
  t = e.exports = di(), t.Stream = t, t.Readable = t, t.Writable = li(), t.Duplex = Ke(), t.Transform = fi, t.PassThrough = Ds;
})(jr, jr.exports);
var yi = jr.exports, Qr = { exports: {} }, bs = Mi;
function Mi(e, t) {
  if (e && t)
    return Mi(e)(t);
  if (typeof e != "function")
    throw new TypeError("need wrapper function");
  return Object.keys(e).forEach(function(s) {
    n[s] = e[s];
  }), n;
  function n() {
    for (var s = new Array(arguments.length), u = 0; u < s.length; u++)
      s[u] = arguments[u];
    var d = e.apply(this, s), c = s[s.length - 1];
    return typeof d == "function" && d !== c && Object.keys(c).forEach(function(p) {
      d[p] = c[p];
    }), d;
  }
}
var Ii = bs;
Qr.exports = Ii(Lt);
Qr.exports.strict = Ii(wi);
Lt.proto = Lt(function() {
  Object.defineProperty(Function.prototype, "once", {
    value: function() {
      return Lt(this);
    },
    configurable: !0
  }), Object.defineProperty(Function.prototype, "onceStrict", {
    value: function() {
      return wi(this);
    },
    configurable: !0
  });
});
function Lt(e) {
  var t = function() {
    return t.called ? t.value : (t.called = !0, t.value = e.apply(this, arguments));
  };
  return t.called = !1, t;
}
function wi(e) {
  var t = function() {
    if (t.called)
      throw new Error(t.onceError);
    return t.called = !0, t.value = e.apply(this, arguments);
  }, n = e.name || "Function wrapped with `once`";
  return t.onceError = n + " shouldn't be called more than once", t.called = !1, t;
}
var Ci = Qr.exports, Ts = Ci, Ss = function() {
}, Es = function(e) {
  return e.setHeader && typeof e.abort == "function";
}, xs = function(e) {
  return e.stdio && Array.isArray(e.stdio) && e.stdio.length === 3;
}, Ai = function(e, t, n) {
  if (typeof t == "function")
    return Ai(e, null, t);
  t || (t = {}), n = Ts(n || Ss);
  var s = e._writableState, u = e._readableState, d = t.readable || t.readable !== !1 && e.readable, c = t.writable || t.writable !== !1 && e.writable, p = !1, y = function() {
    e.writable || D();
  }, D = function() {
    c = !1, d || n.call(e);
  }, M = function() {
    d = !1, c || n.call(e);
  }, m = function(Z) {
    n.call(e, Z ? new Error("exited with error code: " + Z) : null);
  }, z = function(Z) {
    n.call(e, Z);
  }, R = function() {
    q.nextTick(_);
  }, _ = function() {
    if (!p) {
      if (d && !(u && u.ended && !u.destroyed))
        return n.call(e, new Error("premature close"));
      if (c && !(s && s.ended && !s.destroyed))
        return n.call(e, new Error("premature close"));
    }
  }, B = function() {
    e.req.on("finish", D);
  };
  return Es(e) ? (e.on("complete", D), e.on("abort", R), e.req ? B() : e.on("request", B)) : c && !s && (e.on("end", y), e.on("close", y)), xs(e) && e.on("exit", m), e.on("end", M), e.on("finish", D), t.error !== !1 && e.on("error", z), e.on("close", R), function() {
    p = !0, e.removeListener("complete", D), e.removeListener("abort", R), e.removeListener("request", B), e.req && e.req.removeListener("finish", D), e.removeListener("end", y), e.removeListener("close", y), e.removeListener("finish", D), e.removeListener("exit", m), e.removeListener("end", M), e.removeListener("error", z), e.removeListener("close", R);
  };
}, vs = Ai, zt = {};
Object.defineProperty(zt, "__esModule", { value: !0 });
zt.Substream = void 0;
const Os = yi;
class zs extends Os.Duplex {
  constructor({ parent: t, name: n }) {
    super({ objectMode: !0 }), this._parent = t, this._name = n;
  }
  /**
   * Explicitly sets read operations to a no-op.
   */
  _read() {
  }
  /**
   * Called when data should be written to this writable stream.
   *
   * @param chunk - Arbitrary object to write
   * @param encoding - Encoding to use when writing payload
   * @param callback - Called when writing is complete or an error occurs
   */
  _write(t, n, s) {
    this._parent.push({
      name: this._name,
      data: t
    }), s();
  }
}
zt.Substream = zs;
var Li = ie && ie.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Tt, "__esModule", { value: !0 });
Tt.ObjectMultiplex = void 0;
const ks = yi, mn = Li(vs), _s = Li(Ci), Bs = zt, jn = Symbol("IGNORE_SUBSTREAM");
class Rs extends ks.Duplex {
  constructor(t = {}) {
    super(Object.assign(Object.assign({}, t), { objectMode: !0 })), this._substreams = {};
  }
  createStream(t) {
    if (this.destroyed)
      throw new Error(`ObjectMultiplex - parent stream for name "${t}" already destroyed`);
    if (this._readableState.ended || this._writableState.ended)
      throw new Error(`ObjectMultiplex - parent stream for name "${t}" already ended`);
    if (!t)
      throw new Error("ObjectMultiplex - name must not be empty");
    if (this._substreams[t])
      throw new Error(`ObjectMultiplex - Substream for name "${t}" already exists`);
    const n = new Bs.Substream({ parent: this, name: t });
    return this._substreams[t] = n, Ps(this, (s) => n.destroy(s || void 0)), n;
  }
  // ignore streams (dont display orphaned data warning)
  ignoreStream(t) {
    if (!t)
      throw new Error("ObjectMultiplex - name must not be empty");
    if (this._substreams[t])
      throw new Error(`ObjectMultiplex - Substream for name "${t}" already exists`);
    this._substreams[t] = jn;
  }
  _read() {
  }
  _write(t, n, s) {
    const { name: u, data: d } = t;
    if (!u)
      return console.warn(`ObjectMultiplex - malformed chunk without name "${t}"`), s();
    const c = this._substreams[u];
    return c ? (c !== jn && c.push(d), s()) : (console.warn(`ObjectMultiplex - orphaned data for stream "${u}"`), s());
  }
}
Tt.ObjectMultiplex = Rs;
function Ps(e, t) {
  const n = _s.default(t);
  mn.default(e, { readable: !1 }, n), mn.default(e, { writable: !1 }, n);
}
const Us = Tt;
Us.ObjectMultiplex;
var mi = {};
Object.defineProperty(mi, "__esModule", { value: !0 });
const Ys = {
  errors: {
    disconnected: () => "MetaMask: Disconnected from chain. Attempting to connect.",
    permanentlyDisconnected: () => "MetaMask: Disconnected from MetaMask background. Page reload required.",
    sendSiteMetadata: () => "MetaMask: Failed to send site metadata. This is an internal error, please report this bug.",
    unsupportedSync: (e) => `MetaMask: The MetaMask Ethereum provider does not support synchronous methods like ${e} without a callback parameter.`,
    invalidDuplexStream: () => "Must provide a Node.js-style duplex stream.",
    invalidRequestArgs: () => "Expected a single, non-array, object argument.",
    invalidRequestMethod: () => "'args.method' must be a non-empty string.",
    invalidRequestParams: () => "'args.params' must be an object or array if provided.",
    invalidLoggerObject: () => "'args.logger' must be an object if provided.",
    invalidLoggerMethod: (e) => `'args.logger' must include required method '${e}'.`
  },
  info: {
    connected: (e) => `MetaMask: Connected to chain with ID "${e}".`
  },
  warnings: {
    // deprecated methods
    enableDeprecation: `MetaMask: 'ethereum.enable()' is deprecated and may be removed in the future. Please use the 'eth_requestAccounts' RPC method instead.
For more information, see: https://eips.ethereum.org/EIPS/eip-1102`,
    sendDeprecation: `MetaMask: 'ethereum.send(...)' is deprecated and may be removed in the future. Please use 'ethereum.sendAsync(...)' or 'ethereum.request(...)' instead.
For more information, see: https://eips.ethereum.org/EIPS/eip-1193`,
    // deprecated events
    events: {
      close: `MetaMask: The event 'close' is deprecated and may be removed in the future. Please use 'disconnect' instead.
For more information, see: https://eips.ethereum.org/EIPS/eip-1193#disconnect`,
      data: `MetaMask: The event 'data' is deprecated and will be removed in the future. Use 'message' instead.
For more information, see: https://eips.ethereum.org/EIPS/eip-1193#message`,
      networkChanged: `MetaMask: The event 'networkChanged' is deprecated and may be removed in the future. Use 'chainChanged' instead.
For more information, see: https://eips.ethereum.org/EIPS/eip-1193#chainchanged`,
      notification: `MetaMask: The event 'notification' is deprecated and may be removed in the future. Use 'message' instead.
For more information, see: https://eips.ethereum.org/EIPS/eip-1193#message`
    },
    // misc
    experimentalMethods: "MetaMask: 'ethereum._metamask' exposes non-standard, experimental methods. They may be removed or changed without warning."
  }
};
mi.default = Ys;
var Te = {}, $r = {}, Ye = {}, Fs = nt;
nt.default = nt;
nt.stable = Di;
nt.stableStringify = Di;
var jt = "[...]", ji = "[Circular]", Qe = [], Ze = [];
function Ni() {
  return {
    depthLimit: Number.MAX_SAFE_INTEGER,
    edgesLimit: Number.MAX_SAFE_INTEGER
  };
}
function nt(e, t, n, s) {
  typeof s > "u" && (s = Ni()), vr(e, "", 0, [], void 0, 0, s);
  var u;
  try {
    Ze.length === 0 ? u = JSON.stringify(e, t, n) : u = JSON.stringify(e, bi(t), n);
  } catch {
    return JSON.stringify("[unable to serialize, circular reference is too complex to analyze]");
  } finally {
    for (; Qe.length !== 0; ) {
      var d = Qe.pop();
      d.length === 4 ? Object.defineProperty(d[0], d[1], d[3]) : d[0][d[1]] = d[2];
    }
  }
  return u;
}
function Ve(e, t, n, s) {
  var u = Object.getOwnPropertyDescriptor(s, n);
  u.get !== void 0 ? u.configurable ? (Object.defineProperty(s, n, { value: e }), Qe.push([s, n, t, u])) : Ze.push([t, n, e]) : (s[n] = e, Qe.push([s, n, t]));
}
function vr(e, t, n, s, u, d, c) {
  d += 1;
  var p;
  if (typeof e == "object" && e !== null) {
    for (p = 0; p < s.length; p++)
      if (s[p] === e) {
        Ve(ji, e, t, u);
        return;
      }
    if (typeof c.depthLimit < "u" && d > c.depthLimit) {
      Ve(jt, e, t, u);
      return;
    }
    if (typeof c.edgesLimit < "u" && n + 1 > c.edgesLimit) {
      Ve(jt, e, t, u);
      return;
    }
    if (s.push(e), Array.isArray(e))
      for (p = 0; p < e.length; p++)
        vr(e[p], p, p, s, e, d, c);
    else {
      var y = Object.keys(e);
      for (p = 0; p < y.length; p++) {
        var D = y[p];
        vr(e[D], D, p, s, e, d, c);
      }
    }
    s.pop();
  }
}
function Gs(e, t) {
  return e < t ? -1 : e > t ? 1 : 0;
}
function Di(e, t, n, s) {
  typeof s > "u" && (s = Ni());
  var u = Or(e, "", 0, [], void 0, 0, s) || e, d;
  try {
    Ze.length === 0 ? d = JSON.stringify(u, t, n) : d = JSON.stringify(u, bi(t), n);
  } catch {
    return JSON.stringify("[unable to serialize, circular reference is too complex to analyze]");
  } finally {
    for (; Qe.length !== 0; ) {
      var c = Qe.pop();
      c.length === 4 ? Object.defineProperty(c[0], c[1], c[3]) : c[0][c[1]] = c[2];
    }
  }
  return d;
}
function Or(e, t, n, s, u, d, c) {
  d += 1;
  var p;
  if (typeof e == "object" && e !== null) {
    for (p = 0; p < s.length; p++)
      if (s[p] === e) {
        Ve(ji, e, t, u);
        return;
      }
    try {
      if (typeof e.toJSON == "function")
        return;
    } catch {
      return;
    }
    if (typeof c.depthLimit < "u" && d > c.depthLimit) {
      Ve(jt, e, t, u);
      return;
    }
    if (typeof c.edgesLimit < "u" && n + 1 > c.edgesLimit) {
      Ve(jt, e, t, u);
      return;
    }
    if (s.push(e), Array.isArray(e))
      for (p = 0; p < e.length; p++)
        Or(e[p], p, p, s, e, d, c);
    else {
      var y = {}, D = Object.keys(e).sort(Gs);
      for (p = 0; p < D.length; p++) {
        var M = D[p];
        Or(e[M], M, p, s, e, d, c), y[M] = e[M];
      }
      if (typeof u < "u")
        Qe.push([u, t, e]), u[t] = y;
      else
        return y;
    }
    s.pop();
  }
}
function bi(e) {
  return e = typeof e < "u" ? e : function(t, n) {
    return n;
  }, function(t, n) {
    if (Ze.length > 0)
      for (var s = 0; s < Ze.length; s++) {
        var u = Ze[s];
        if (u[1] === t && u[0] === n) {
          n = u[2], Ze.splice(s, 1);
          break;
        }
      }
    return e.call(this, t, n);
  };
}
Object.defineProperty(Ye, "__esModule", { value: !0 });
Ye.EthereumProviderError = Ye.EthereumRpcError = void 0;
const Ws = Fs;
class Ti extends Error {
  constructor(t, n, s) {
    if (!Number.isInteger(t))
      throw new Error('"code" must be an integer.');
    if (!n || typeof n != "string")
      throw new Error('"message" must be a nonempty string.');
    super(n), this.code = t, s !== void 0 && (this.data = s);
  }
  /**
   * Returns a plain object with all public class properties.
   */
  serialize() {
    const t = {
      code: this.code,
      message: this.message
    };
    return this.data !== void 0 && (t.data = this.data), this.stack && (t.stack = this.stack), t;
  }
  /**
   * Return a string representation of the serialized error, omitting
   * any circular references.
   */
  toString() {
    return Ws.default(this.serialize(), $s, 2);
  }
}
Ye.EthereumRpcError = Ti;
class Zs extends Ti {
  /**
   * Create an Ethereum Provider JSON-RPC error.
   * `code` must be an integer in the 1000 <= 4999 range.
   */
  constructor(t, n, s) {
    if (!Qs(t))
      throw new Error('"code" must be an integer such that: 1000 <= code <= 4999');
    super(t, n, s);
  }
}
Ye.EthereumProviderError = Zs;
function Qs(e) {
  return Number.isInteger(e) && e >= 1e3 && e <= 4999;
}
function $s(e, t) {
  if (t !== "[Circular]")
    return t;
}
var Hr = {}, Fe = {};
Object.defineProperty(Fe, "__esModule", { value: !0 });
Fe.errorValues = Fe.errorCodes = void 0;
Fe.errorCodes = {
  rpc: {
    invalidInput: -32e3,
    resourceNotFound: -32001,
    resourceUnavailable: -32002,
    transactionRejected: -32003,
    methodNotSupported: -32004,
    limitExceeded: -32005,
    parse: -32700,
    invalidRequest: -32600,
    methodNotFound: -32601,
    invalidParams: -32602,
    internal: -32603
  },
  provider: {
    userRejectedRequest: 4001,
    unauthorized: 4100,
    unsupportedMethod: 4200,
    disconnected: 4900,
    chainDisconnected: 4901
  }
};
Fe.errorValues = {
  "-32700": {
    standard: "JSON RPC 2.0",
    message: "Invalid JSON was received by the server. An error occurred on the server while parsing the JSON text."
  },
  "-32600": {
    standard: "JSON RPC 2.0",
    message: "The JSON sent is not a valid Request object."
  },
  "-32601": {
    standard: "JSON RPC 2.0",
    message: "The method does not exist / is not available."
  },
  "-32602": {
    standard: "JSON RPC 2.0",
    message: "Invalid method parameter(s)."
  },
  "-32603": {
    standard: "JSON RPC 2.0",
    message: "Internal JSON-RPC error."
  },
  "-32000": {
    standard: "EIP-1474",
    message: "Invalid input."
  },
  "-32001": {
    standard: "EIP-1474",
    message: "Resource not found."
  },
  "-32002": {
    standard: "EIP-1474",
    message: "Resource unavailable."
  },
  "-32003": {
    standard: "EIP-1474",
    message: "Transaction rejected."
  },
  "-32004": {
    standard: "EIP-1474",
    message: "Method not supported."
  },
  "-32005": {
    standard: "EIP-1474",
    message: "Request limit exceeded."
  },
  4001: {
    standard: "EIP-1193",
    message: "User rejected the request."
  },
  4100: {
    standard: "EIP-1193",
    message: "The requested account and/or method has not been authorized by the user."
  },
  4200: {
    standard: "EIP-1193",
    message: "The requested method is not supported by this Ethereum provider."
  },
  4900: {
    standard: "EIP-1193",
    message: "The provider is disconnected from all chains."
  },
  4901: {
    standard: "EIP-1193",
    message: "The provider is disconnected from the specified chain."
  }
};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.serializeError = e.isValidCode = e.getMessageFromCode = e.JSON_RPC_SERVER_ERROR_MESSAGE = void 0;
  const t = Fe, n = Ye, s = t.errorCodes.rpc.internal, u = "Unspecified error message. This is a bug, please report it.", d = {
    code: s,
    message: c(s)
  };
  e.JSON_RPC_SERVER_ERROR_MESSAGE = "Unspecified server error.";
  function c(z, R = u) {
    if (Number.isInteger(z)) {
      const _ = z.toString();
      if (m(t.errorValues, _))
        return t.errorValues[_].message;
      if (D(z))
        return e.JSON_RPC_SERVER_ERROR_MESSAGE;
    }
    return R;
  }
  e.getMessageFromCode = c;
  function p(z) {
    if (!Number.isInteger(z))
      return !1;
    const R = z.toString();
    return !!(t.errorValues[R] || D(z));
  }
  e.isValidCode = p;
  function y(z, { fallbackError: R = d, shouldIncludeStack: _ = !1 } = {}) {
    var B, Z;
    if (!R || !Number.isInteger(R.code) || typeof R.message != "string")
      throw new Error("Must provide fallback error with integer number code and string message.");
    if (z instanceof n.EthereumRpcError)
      return z.serialize();
    const b = {};
    if (z && typeof z == "object" && !Array.isArray(z) && m(z, "code") && p(z.code)) {
      const F = z;
      b.code = F.code, F.message && typeof F.message == "string" ? (b.message = F.message, m(F, "data") && (b.data = F.data)) : (b.message = c(b.code), b.data = { originalError: M(z) });
    } else {
      b.code = R.code;
      const F = (B = z) === null || B === void 0 ? void 0 : B.message;
      b.message = F && typeof F == "string" ? F : R.message, b.data = { originalError: M(z) };
    }
    const S = (Z = z) === null || Z === void 0 ? void 0 : Z.stack;
    return _ && z && S && typeof S == "string" && (b.stack = S), b;
  }
  e.serializeError = y;
  function D(z) {
    return z >= -32099 && z <= -32e3;
  }
  function M(z) {
    return z && typeof z == "object" && !Array.isArray(z) ? Object.assign({}, z) : z;
  }
  function m(z, R) {
    return Object.prototype.hasOwnProperty.call(z, R);
  }
})(Hr);
var kt = {};
Object.defineProperty(kt, "__esModule", { value: !0 });
kt.ethErrors = void 0;
const Jr = Ye, Si = Hr, Ie = Fe;
kt.ethErrors = {
  rpc: {
    /**
     * Get a JSON RPC 2.0 Parse (-32700) error.
     */
    parse: (e) => me(Ie.errorCodes.rpc.parse, e),
    /**
     * Get a JSON RPC 2.0 Invalid Request (-32600) error.
     */
    invalidRequest: (e) => me(Ie.errorCodes.rpc.invalidRequest, e),
    /**
     * Get a JSON RPC 2.0 Invalid Params (-32602) error.
     */
    invalidParams: (e) => me(Ie.errorCodes.rpc.invalidParams, e),
    /**
     * Get a JSON RPC 2.0 Method Not Found (-32601) error.
     */
    methodNotFound: (e) => me(Ie.errorCodes.rpc.methodNotFound, e),
    /**
     * Get a JSON RPC 2.0 Internal (-32603) error.
     */
    internal: (e) => me(Ie.errorCodes.rpc.internal, e),
    /**
     * Get a JSON RPC 2.0 Server error.
     * Permits integer error codes in the [ -32099 <= -32005 ] range.
     * Codes -32000 through -32004 are reserved by EIP-1474.
     */
    server: (e) => {
      if (!e || typeof e != "object" || Array.isArray(e))
        throw new Error("Ethereum RPC Server errors must provide single object argument.");
      const { code: t } = e;
      if (!Number.isInteger(t) || t > -32005 || t < -32099)
        throw new Error('"code" must be an integer such that: -32099 <= code <= -32005');
      return me(t, e);
    },
    /**
     * Get an Ethereum JSON RPC Invalid Input (-32000) error.
     */
    invalidInput: (e) => me(Ie.errorCodes.rpc.invalidInput, e),
    /**
     * Get an Ethereum JSON RPC Resource Not Found (-32001) error.
     */
    resourceNotFound: (e) => me(Ie.errorCodes.rpc.resourceNotFound, e),
    /**
     * Get an Ethereum JSON RPC Resource Unavailable (-32002) error.
     */
    resourceUnavailable: (e) => me(Ie.errorCodes.rpc.resourceUnavailable, e),
    /**
     * Get an Ethereum JSON RPC Transaction Rejected (-32003) error.
     */
    transactionRejected: (e) => me(Ie.errorCodes.rpc.transactionRejected, e),
    /**
     * Get an Ethereum JSON RPC Method Not Supported (-32004) error.
     */
    methodNotSupported: (e) => me(Ie.errorCodes.rpc.methodNotSupported, e),
    /**
     * Get an Ethereum JSON RPC Limit Exceeded (-32005) error.
     */
    limitExceeded: (e) => me(Ie.errorCodes.rpc.limitExceeded, e)
  },
  provider: {
    /**
     * Get an Ethereum Provider User Rejected Request (4001) error.
     */
    userRejectedRequest: (e) => tt(Ie.errorCodes.provider.userRejectedRequest, e),
    /**
     * Get an Ethereum Provider Unauthorized (4100) error.
     */
    unauthorized: (e) => tt(Ie.errorCodes.provider.unauthorized, e),
    /**
     * Get an Ethereum Provider Unsupported Method (4200) error.
     */
    unsupportedMethod: (e) => tt(Ie.errorCodes.provider.unsupportedMethod, e),
    /**
     * Get an Ethereum Provider Not Connected (4900) error.
     */
    disconnected: (e) => tt(Ie.errorCodes.provider.disconnected, e),
    /**
     * Get an Ethereum Provider Chain Not Connected (4901) error.
     */
    chainDisconnected: (e) => tt(Ie.errorCodes.provider.chainDisconnected, e),
    /**
     * Get a custom Ethereum Provider error.
     */
    custom: (e) => {
      if (!e || typeof e != "object" || Array.isArray(e))
        throw new Error("Ethereum Provider custom errors must provide single object argument.");
      const { code: t, message: n, data: s } = e;
      if (!n || typeof n != "string")
        throw new Error('"message" must be a nonempty string');
      return new Jr.EthereumProviderError(t, n, s);
    }
  }
};
function me(e, t) {
  const [n, s] = Ei(t);
  return new Jr.EthereumRpcError(e, n || Si.getMessageFromCode(e), s);
}
function tt(e, t) {
  const [n, s] = Ei(t);
  return new Jr.EthereumProviderError(e, n || Si.getMessageFromCode(e), s);
}
function Ei(e) {
  if (e) {
    if (typeof e == "string")
      return [e];
    if (typeof e == "object" && !Array.isArray(e)) {
      const { message: t, data: n } = e;
      if (t && typeof t != "string")
        throw new Error("Must specify string message.");
      return [t || void 0, n];
    }
  }
  return [];
}
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.getMessageFromCode = e.serializeError = e.EthereumProviderError = e.EthereumRpcError = e.ethErrors = e.errorCodes = void 0;
  const t = Ye;
  Object.defineProperty(e, "EthereumRpcError", { enumerable: !0, get: function() {
    return t.EthereumRpcError;
  } }), Object.defineProperty(e, "EthereumProviderError", { enumerable: !0, get: function() {
    return t.EthereumProviderError;
  } });
  const n = Hr;
  Object.defineProperty(e, "serializeError", { enumerable: !0, get: function() {
    return n.serializeError;
  } }), Object.defineProperty(e, "getMessageFromCode", { enumerable: !0, get: function() {
    return n.getMessageFromCode;
  } });
  const s = kt;
  Object.defineProperty(e, "ethErrors", { enumerable: !0, get: function() {
    return s.ethErrors;
  } });
  const u = Fe;
  Object.defineProperty(e, "errorCodes", { enumerable: !0, get: function() {
    return u.errorCodes;
  } });
})($r);
Object.defineProperty(Te, "__esModule", { value: !0 });
Te.EMITTED_NOTIFICATIONS = Te.NOOP = Te.logStreamDisconnectWarning = Te.getRpcPromiseCallback = Te.createErrorMiddleware = void 0;
const Hs = $r;
function Js(e) {
  return (t, n, s) => {
    (typeof t.method != "string" || !t.method) && (n.error = Hs.ethErrors.rpc.invalidRequest({
      message: "The request 'method' must be a non-empty string.",
      data: t
    })), s((u) => {
      const { error: d } = n;
      return d && e.error(`MetaMask - RPC Error: ${d.message}`, d), u();
    });
  };
}
Te.createErrorMiddleware = Js;
const Xs = (e, t, n = !0) => (s, u) => {
  s || u.error ? t(s || u.error) : !n || Array.isArray(u) ? e(u) : e(u.result);
};
Te.getRpcPromiseCallback = Xs;
function Vs(e, t, n, s) {
  let u = `MetaMask: Lost connection to "${t}".`;
  n != null && n.stack && (u += `
${n.stack}`), e.warn(u), s && s.listenerCount("error") > 0 && s.emit("error", u);
}
Te.logStreamDisconnectWarning = Vs;
const Ks = () => {
};
Te.NOOP = Ks;
Te.EMITTED_NOTIFICATIONS = [
  "eth_subscription"
  // per eth-json-rpc-filters/subscriptionManager
];
var xi = {};
Object.defineProperty(xi, "__esModule", { value: !0 });
const qs = et;
function Nn(e, t, n) {
  try {
    Reflect.apply(e, t, n);
  } catch (s) {
    setTimeout(() => {
      throw s;
    });
  }
}
function eu(e) {
  const t = e.length, n = new Array(t);
  for (let s = 0; s < t; s += 1)
    n[s] = e[s];
  return n;
}
let tu = class extends qs.EventEmitter {
  emit(t, ...n) {
    let s = t === "error";
    const u = this._events;
    if (u !== void 0)
      s = s && u.error === void 0;
    else if (!s)
      return !1;
    if (s) {
      let c;
      if (n.length > 0 && ([c] = n), c instanceof Error)
        throw c;
      const p = new Error(`Unhandled error.${c ? ` (${c.message})` : ""}`);
      throw p.context = c, p;
    }
    const d = u[t];
    if (d === void 0)
      return !1;
    if (typeof d == "function")
      Nn(d, this, n);
    else {
      const c = d.length, p = eu(d);
      for (let y = 0; y < c; y += 1)
        Nn(p[y], this, n);
    }
    return !0;
  }
};
xi.default = tu;
var ru = {}, _t = {}, ut = {};
Object.defineProperty(ut, "__esModule", { value: !0 });
ut.getUniqueId = void 0;
const vi = 4294967295;
let hr = Math.floor(Math.random() * vi);
function nu() {
  return hr = (hr + 1) % vi, hr;
}
ut.getUniqueId = nu;
Object.defineProperty(_t, "__esModule", { value: !0 });
_t.createIdRemapMiddleware = void 0;
const iu = ut;
function ou() {
  return (e, t, n, s) => {
    const u = e.id, d = iu.getUniqueId();
    e.id = d, t.id = d, n((c) => {
      e.id = u, t.id = u, c();
    });
  };
}
_t.createIdRemapMiddleware = ou;
var Bt = {};
Object.defineProperty(Bt, "__esModule", { value: !0 });
Bt.createAsyncMiddleware = void 0;
function au(e) {
  return async (t, n, s, u) => {
    let d;
    const c = new Promise((M) => {
      d = M;
    });
    let p = null, y = !1;
    const D = async () => {
      y = !0, s((M) => {
        p = M, d();
      }), await c;
    };
    try {
      await e(t, n, D), y ? (await c, p(null)) : u(null);
    } catch (M) {
      p ? p(M) : u(M);
    }
  };
}
Bt.createAsyncMiddleware = au;
var Rt = {};
Object.defineProperty(Rt, "__esModule", { value: !0 });
Rt.createScaffoldMiddleware = void 0;
function su(e) {
  return (t, n, s, u) => {
    const d = e[t.method];
    return d === void 0 ? s() : typeof d == "function" ? d(t, n, s, u) : (n.result = d, u());
  };
}
Rt.createScaffoldMiddleware = su;
var ct = {}, Pt = {};
Object.defineProperty(Pt, "__esModule", { value: !0 });
const uu = et;
function Dn(e, t, n) {
  try {
    Reflect.apply(e, t, n);
  } catch (s) {
    setTimeout(() => {
      throw s;
    });
  }
}
function cu(e) {
  const t = e.length, n = new Array(t);
  for (let s = 0; s < t; s += 1)
    n[s] = e[s];
  return n;
}
class lu extends uu.EventEmitter {
  emit(t, ...n) {
    let s = t === "error";
    const u = this._events;
    if (u !== void 0)
      s = s && u.error === void 0;
    else if (!s)
      return !1;
    if (s) {
      let c;
      if (n.length > 0 && ([c] = n), c instanceof Error)
        throw c;
      const p = new Error(`Unhandled error.${c ? ` (${c.message})` : ""}`);
      throw p.context = c, p;
    }
    const d = u[t];
    if (d === void 0)
      return !1;
    if (typeof d == "function")
      Dn(d, this, n);
    else {
      const c = d.length, p = cu(d);
      for (let y = 0; y < c; y += 1)
        Dn(p[y], this, n);
    }
    return !0;
  }
}
Pt.default = lu;
var du = ie && ie.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(ct, "__esModule", { value: !0 });
ct.JsonRpcEngine = void 0;
const fu = du(Pt), je = $r;
class ke extends fu.default {
  constructor() {
    super(), this._middleware = [];
  }
  /**
   * Add a middleware function to the engine's middleware stack.
   *
   * @param middleware - The middleware function to add.
   */
  push(t) {
    this._middleware.push(t);
  }
  handle(t, n) {
    if (n && typeof n != "function")
      throw new Error('"callback" must be a function if provided.');
    return Array.isArray(t) ? n ? this._handleBatch(t, n) : this._handleBatch(t) : n ? this._handle(t, n) : this._promiseHandle(t);
  }
  /**
   * Returns this engine as a middleware function that can be pushed to other
   * engines.
   *
   * @returns This engine as a middleware function.
   */
  asMiddleware() {
    return async (t, n, s, u) => {
      try {
        const [d, c, p] = await ke._runAllMiddleware(t, n, this._middleware);
        return c ? (await ke._runReturnHandlers(p), u(d)) : s(async (y) => {
          try {
            await ke._runReturnHandlers(p);
          } catch (D) {
            return y(D);
          }
          return y();
        });
      } catch (d) {
        return u(d);
      }
    };
  }
  async _handleBatch(t, n) {
    try {
      const s = await Promise.all(
        // 1. Begin executing each request in the order received
        t.map(this._promiseHandle.bind(this))
      );
      return n ? n(null, s) : s;
    } catch (s) {
      if (n)
        return n(s);
      throw s;
    }
  }
  /**
   * A promise-wrapped _handle.
   */
  _promiseHandle(t) {
    return new Promise((n) => {
      this._handle(t, (s, u) => {
        n(u);
      });
    });
  }
  /**
   * Ensures that the request object is valid, processes it, and passes any
   * error and the response object to the given callback.
   *
   * Does not reject.
   */
  async _handle(t, n) {
    if (!t || Array.isArray(t) || typeof t != "object") {
      const c = new je.EthereumRpcError(je.errorCodes.rpc.invalidRequest, `Requests must be plain objects. Received: ${typeof t}`, { request: t });
      return n(c, { id: void 0, jsonrpc: "2.0", error: c });
    }
    if (typeof t.method != "string") {
      const c = new je.EthereumRpcError(je.errorCodes.rpc.invalidRequest, `Must specify a string method. Received: ${typeof t.method}`, { request: t });
      return n(c, { id: t.id, jsonrpc: "2.0", error: c });
    }
    const s = Object.assign({}, t), u = {
      id: s.id,
      jsonrpc: s.jsonrpc
    };
    let d = null;
    try {
      await this._processRequest(s, u);
    } catch (c) {
      d = c;
    }
    return d && (delete u.result, u.error || (u.error = je.serializeError(d))), n(d, u);
  }
  /**
   * For the given request and response, runs all middleware and their return
   * handlers, if any, and ensures that internal request processing semantics
   * are satisfied.
   */
  async _processRequest(t, n) {
    const [s, u, d] = await ke._runAllMiddleware(t, n, this._middleware);
    if (ke._checkForCompletion(t, n, u), await ke._runReturnHandlers(d), s)
      throw s;
  }
  /**
   * Serially executes the given stack of middleware.
   *
   * @returns An array of any error encountered during middleware execution,
   * a boolean indicating whether the request was completed, and an array of
   * middleware-defined return handlers.
   */
  static async _runAllMiddleware(t, n, s) {
    const u = [];
    let d = null, c = !1;
    for (const p of s)
      if ([d, c] = await ke._runMiddleware(t, n, p, u), c)
        break;
    return [d, c, u.reverse()];
  }
  /**
   * Runs an individual middleware.
   *
   * @returns An array of any error encountered during middleware exection,
   * and a boolean indicating whether the request should end.
   */
  static _runMiddleware(t, n, s, u) {
    return new Promise((d) => {
      const c = (y) => {
        const D = y || n.error;
        D && (n.error = je.serializeError(D)), d([D, !0]);
      }, p = (y) => {
        n.error ? c(n.error) : (y && (typeof y != "function" && c(new je.EthereumRpcError(je.errorCodes.rpc.internal, `JsonRpcEngine: "next" return handlers must be functions. Received "${typeof y}" for request:
${pr(t)}`, { request: t })), u.push(y)), d([null, !1]));
      };
      try {
        s(t, n, p, c);
      } catch (y) {
        c(y);
      }
    });
  }
  /**
   * Serially executes array of return handlers. The request and response are
   * assumed to be in their scope.
   */
  static async _runReturnHandlers(t) {
    for (const n of t)
      await new Promise((s, u) => {
        n((d) => d ? u(d) : s());
      });
  }
  /**
   * Throws an error if the response has neither a result nor an error, or if
   * the "isComplete" flag is falsy.
   */
  static _checkForCompletion(t, n, s) {
    if (!("result" in n) && !("error" in n))
      throw new je.EthereumRpcError(je.errorCodes.rpc.internal, `JsonRpcEngine: Response has no error or result for request:
${pr(t)}`, { request: t });
    if (!s)
      throw new je.EthereumRpcError(je.errorCodes.rpc.internal, `JsonRpcEngine: Nothing ended request:
${pr(t)}`, { request: t });
  }
}
ct.JsonRpcEngine = ke;
function pr(e) {
  return JSON.stringify(e, null, 2);
}
var Ut = {};
Object.defineProperty(Ut, "__esModule", { value: !0 });
Ut.mergeMiddleware = void 0;
const gu = ct;
function hu(e) {
  const t = new gu.JsonRpcEngine();
  return e.forEach((n) => t.push(n)), t.asMiddleware();
}
Ut.mergeMiddleware = hu;
(function(e) {
  var t = ie && ie.__createBinding || (Object.create ? function(s, u, d, c) {
    c === void 0 && (c = d), Object.defineProperty(s, c, { enumerable: !0, get: function() {
      return u[d];
    } });
  } : function(s, u, d, c) {
    c === void 0 && (c = d), s[c] = u[d];
  }), n = ie && ie.__exportStar || function(s, u) {
    for (var d in s)
      d !== "default" && !Object.prototype.hasOwnProperty.call(u, d) && t(u, s, d);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), n(_t, e), n(Bt, e), n(Rt, e), n(ut, e), n(ct, e), n(Ut, e);
})(ru);
var it = {}, Xr = {}, zr = { exports: {} }, pu = {}.toString, yu = Array.isArray || function(e) {
  return pu.call(e) == "[object Array]";
}, Oi = et.EventEmitter, kr = { exports: {} };
(function(e, t) {
  var n = bt, s = n.Buffer;
  function u(c, p) {
    for (var y in c)
      p[y] = c[y];
  }
  s.from && s.alloc && s.allocUnsafe && s.allocUnsafeSlow ? e.exports = n : (u(n, t), t.Buffer = d);
  function d(c, p, y) {
    return s(c, p, y);
  }
  u(s, d), d.from = function(c, p, y) {
    if (typeof c == "number")
      throw new TypeError("Argument must not be a number");
    return s(c, p, y);
  }, d.alloc = function(c, p, y) {
    if (typeof c != "number")
      throw new TypeError("Argument must be a number");
    var D = s(c);
    return p !== void 0 ? typeof y == "string" ? D.fill(p, y) : D.fill(p) : D.fill(0), D;
  }, d.allocUnsafe = function(c) {
    if (typeof c != "number")
      throw new TypeError("Argument must be a number");
    return s(c);
  }, d.allocUnsafeSlow = function(c) {
    if (typeof c != "number")
      throw new TypeError("Argument must be a number");
    return n.SlowBuffer(c);
  };
})(kr, kr.exports);
var Vr = kr.exports, yr = { exports: {} }, bn;
function Mu() {
  return bn || (bn = 1, function(e) {
    function t(d, c) {
      if (!(d instanceof c))
        throw new TypeError("Cannot call a class as a function");
    }
    var n = Vr.Buffer, s = at;
    function u(d, c, p) {
      d.copy(c, p);
    }
    e.exports = function() {
      function d() {
        t(this, d), this.head = null, this.tail = null, this.length = 0;
      }
      return d.prototype.push = function(p) {
        var y = { data: p, next: null };
        this.length > 0 ? this.tail.next = y : this.head = y, this.tail = y, ++this.length;
      }, d.prototype.unshift = function(p) {
        var y = { data: p, next: this.head };
        this.length === 0 && (this.tail = y), this.head = y, ++this.length;
      }, d.prototype.shift = function() {
        if (this.length !== 0) {
          var p = this.head.data;
          return this.length === 1 ? this.head = this.tail = null : this.head = this.head.next, --this.length, p;
        }
      }, d.prototype.clear = function() {
        this.head = this.tail = null, this.length = 0;
      }, d.prototype.join = function(p) {
        if (this.length === 0)
          return "";
        for (var y = this.head, D = "" + y.data; y = y.next; )
          D += p + y.data;
        return D;
      }, d.prototype.concat = function(p) {
        if (this.length === 0)
          return n.alloc(0);
        for (var y = n.allocUnsafe(p >>> 0), D = this.head, M = 0; D; )
          u(D.data, y, M), M += D.data.length, D = D.next;
        return y;
      }, d;
    }(), s && s.inspect && s.inspect.custom && (e.exports.prototype[s.inspect.custom] = function() {
      var d = s.inspect({ length: this.length });
      return this.constructor.name + " " + d;
    });
  }(yr)), yr.exports;
}
var gt = Ge;
function Iu(e, t) {
  var n = this, s = this._readableState && this._readableState.destroyed, u = this._writableState && this._writableState.destroyed;
  return s || u ? (t ? t(e) : e && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, gt.nextTick(ht, this, e)) : gt.nextTick(ht, this, e)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(e || null, function(d) {
    !t && d ? n._writableState ? n._writableState.errorEmitted || (n._writableState.errorEmitted = !0, gt.nextTick(ht, n, d)) : gt.nextTick(ht, n, d) : t && t(d);
  }), this);
}
function wu() {
  this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
}
function ht(e, t) {
  e.emit("error", t);
}
var zi = {
  destroy: Iu,
  undestroy: wu
}, Mr, Tn;
function ki() {
  if (Tn)
    return Mr;
  Tn = 1;
  var e = Ge;
  Mr = B;
  function t(f) {
    var g = this;
    this.next = null, this.entry = null, this.finish = function() {
      re(g, f);
    };
  }
  var n = !q.browser && ["v0.10", "v0.9."].indexOf(q.version.slice(0, 5)) > -1 ? setImmediate : e.nextTick, s;
  B.WritableState = R;
  var u = Object.create(oe);
  u.inherits = Se;
  var d = {
    deprecate: ci
  }, c = Oi, p = Vr.Buffer, y = (typeof ie < "u" ? ie : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
  };
  function D(f) {
    return p.from(f);
  }
  function M(f) {
    return p.isBuffer(f) || f instanceof y;
  }
  var m = zi;
  u.inherits(B, c);
  function z() {
  }
  function R(f, g) {
    s = s || qe(), f = f || {};
    var A = g instanceof s;
    this.objectMode = !!f.objectMode, A && (this.objectMode = this.objectMode || !!f.writableObjectMode);
    var v = f.highWaterMark, U = f.writableHighWaterMark, w = this.objectMode ? 16 : 16 * 1024;
    v || v === 0 ? this.highWaterMark = v : A && (U || U === 0) ? this.highWaterMark = U : this.highWaterMark = w, this.highWaterMark = Math.floor(this.highWaterMark), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
    var j = f.decodeStrings === !1;
    this.decodeStrings = !j, this.defaultEncoding = f.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(T) {
      se(g, T);
    }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.bufferedRequestCount = 0, this.corkedRequestsFree = new t(this);
  }
  R.prototype.getBuffer = function() {
    for (var g = this.bufferedRequest, A = []; g; )
      A.push(g), g = g.next;
    return A;
  }, function() {
    try {
      Object.defineProperty(R.prototype, "buffer", {
        get: d.deprecate(function() {
          return this.getBuffer();
        }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
      });
    } catch {
    }
  }();
  var _;
  typeof Symbol == "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] == "function" ? (_ = Function.prototype[Symbol.hasInstance], Object.defineProperty(B, Symbol.hasInstance, {
    value: function(f) {
      return _.call(this, f) ? !0 : this !== B ? !1 : f && f._writableState instanceof R;
    }
  })) : _ = function(f) {
    return f instanceof this;
  };
  function B(f) {
    if (s = s || qe(), !_.call(B, this) && !(this instanceof s))
      return new B(f);
    this._writableState = new R(f, this), this.writable = !0, f && (typeof f.write == "function" && (this._write = f.write), typeof f.writev == "function" && (this._writev = f.writev), typeof f.destroy == "function" && (this._destroy = f.destroy), typeof f.final == "function" && (this._final = f.final)), c.call(this);
  }
  B.prototype.pipe = function() {
    this.emit("error", new Error("Cannot pipe, not readable"));
  };
  function Z(f, g) {
    var A = new Error("write after end");
    f.emit("error", A), e.nextTick(g, A);
  }
  function b(f, g, A, v) {
    var U = !0, w = !1;
    return A === null ? w = new TypeError("May not write null values to stream") : typeof A != "string" && A !== void 0 && !g.objectMode && (w = new TypeError("Invalid non-string/buffer chunk")), w && (f.emit("error", w), e.nextTick(v, w), U = !1), U;
  }
  B.prototype.write = function(f, g, A) {
    var v = this._writableState, U = !1, w = !v.objectMode && M(f);
    return w && !p.isBuffer(f) && (f = D(f)), typeof g == "function" && (A = g, g = null), w ? g = "buffer" : g || (g = v.defaultEncoding), typeof A != "function" && (A = z), v.ended ? Z(this, A) : (w || b(this, v, f, A)) && (v.pendingcb++, U = F(this, v, w, f, g, A)), U;
  }, B.prototype.cork = function() {
    var f = this._writableState;
    f.corked++;
  }, B.prototype.uncork = function() {
    var f = this._writableState;
    f.corked && (f.corked--, !f.writing && !f.corked && !f.bufferProcessing && f.bufferedRequest && fe(this, f));
  }, B.prototype.setDefaultEncoding = function(g) {
    if (typeof g == "string" && (g = g.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((g + "").toLowerCase()) > -1))
      throw new TypeError("Unknown encoding: " + g);
    return this._writableState.defaultEncoding = g, this;
  };
  function S(f, g, A) {
    return !f.objectMode && f.decodeStrings !== !1 && typeof g == "string" && (g = p.from(g, A)), g;
  }
  Object.defineProperty(B.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  });
  function F(f, g, A, v, U, w) {
    if (!A) {
      var j = S(g, v, U);
      v !== j && (A = !0, U = "buffer", v = j);
    }
    var T = g.objectMode ? 1 : v.length;
    g.length += T;
    var Y = g.length < g.highWaterMark;
    if (Y || (g.needDrain = !0), g.writing || g.corked) {
      var G = g.lastBufferedRequest;
      g.lastBufferedRequest = {
        chunk: v,
        encoding: U,
        isBuf: A,
        callback: w,
        next: null
      }, G ? G.next = g.lastBufferedRequest : g.bufferedRequest = g.lastBufferedRequest, g.bufferedRequestCount += 1;
    } else
      $(f, g, !1, T, v, U, w);
    return Y;
  }
  function $(f, g, A, v, U, w, j) {
    g.writelen = v, g.writecb = j, g.writing = !0, g.sync = !0, A ? f._writev(U, g.onwrite) : f._write(U, w, g.onwrite), g.sync = !1;
  }
  function H(f, g, A, v, U) {
    --g.pendingcb, A ? (e.nextTick(U, v), e.nextTick(W, f, g), f._writableState.errorEmitted = !0, f.emit("error", v)) : (U(v), f._writableState.errorEmitted = !0, f.emit("error", v), W(f, g));
  }
  function ye(f) {
    f.writing = !1, f.writecb = null, f.length -= f.writelen, f.writelen = 0;
  }
  function se(f, g) {
    var A = f._writableState, v = A.sync, U = A.writecb;
    if (ye(A), g)
      H(f, A, v, g, U);
    else {
      var w = J(A);
      !w && !A.corked && !A.bufferProcessing && A.bufferedRequest && fe(f, A), v ? n(te, f, A, w, U) : te(f, A, w, U);
    }
  }
  function te(f, g, A, v) {
    A || ue(f, g), g.pendingcb--, v(), W(f, g);
  }
  function ue(f, g) {
    g.length === 0 && g.needDrain && (g.needDrain = !1, f.emit("drain"));
  }
  function fe(f, g) {
    g.bufferProcessing = !0;
    var A = g.bufferedRequest;
    if (f._writev && A && A.next) {
      var v = g.bufferedRequestCount, U = new Array(v), w = g.corkedRequestsFree;
      w.entry = A;
      for (var j = 0, T = !0; A; )
        U[j] = A, A.isBuf || (T = !1), A = A.next, j += 1;
      U.allBuffers = T, $(f, g, !0, g.length, U, "", w.finish), g.pendingcb++, g.lastBufferedRequest = null, w.next ? (g.corkedRequestsFree = w.next, w.next = null) : g.corkedRequestsFree = new t(g), g.bufferedRequestCount = 0;
    } else {
      for (; A; ) {
        var Y = A.chunk, G = A.encoding, o = A.callback, a = g.objectMode ? 1 : Y.length;
        if ($(f, g, !1, a, Y, G, o), A = A.next, g.bufferedRequestCount--, g.writing)
          break;
      }
      A === null && (g.lastBufferedRequest = null);
    }
    g.bufferedRequest = A, g.bufferProcessing = !1;
  }
  B.prototype._write = function(f, g, A) {
    A(new Error("_write() is not implemented"));
  }, B.prototype._writev = null, B.prototype.end = function(f, g, A) {
    var v = this._writableState;
    typeof f == "function" ? (A = f, f = null, g = null) : typeof g == "function" && (A = g, g = null), f != null && this.write(f, g), v.corked && (v.corked = 1, this.uncork()), v.ending || K(this, v, A);
  };
  function J(f) {
    return f.ending && f.length === 0 && f.bufferedRequest === null && !f.finished && !f.writing;
  }
  function Q(f, g) {
    f._final(function(A) {
      g.pendingcb--, A && f.emit("error", A), g.prefinished = !0, f.emit("prefinish"), W(f, g);
    });
  }
  function V(f, g) {
    !g.prefinished && !g.finalCalled && (typeof f._final == "function" ? (g.pendingcb++, g.finalCalled = !0, e.nextTick(Q, f, g)) : (g.prefinished = !0, f.emit("prefinish")));
  }
  function W(f, g) {
    var A = J(g);
    return A && (V(f, g), g.pendingcb === 0 && (g.finished = !0, f.emit("finish"))), A;
  }
  function K(f, g, A) {
    g.ending = !0, W(f, g), A && (g.finished ? e.nextTick(A) : f.once("finish", A)), g.ended = !0, f.writable = !1;
  }
  function re(f, g, A) {
    var v = f.entry;
    for (f.entry = null; v; ) {
      var U = v.callback;
      g.pendingcb--, U(A), v = v.next;
    }
    g.corkedRequestsFree.next = f;
  }
  return Object.defineProperty(B.prototype, "destroyed", {
    get: function() {
      return this._writableState === void 0 ? !1 : this._writableState.destroyed;
    },
    set: function(f) {
      this._writableState && (this._writableState.destroyed = f);
    }
  }), B.prototype.destroy = m.destroy, B.prototype._undestroy = m.undestroy, B.prototype._destroy = function(f, g) {
    this.end(), g(f);
  }, Mr;
}
var Ir, Sn;
function qe() {
  if (Sn)
    return Ir;
  Sn = 1;
  var e = Ge, t = Object.keys || function(m) {
    var z = [];
    for (var R in m)
      z.push(R);
    return z;
  };
  Ir = y;
  var n = Object.create(oe);
  n.inherits = Se;
  var s = _i(), u = ki();
  n.inherits(y, s);
  for (var d = t(u.prototype), c = 0; c < d.length; c++) {
    var p = d[c];
    y.prototype[p] || (y.prototype[p] = u.prototype[p]);
  }
  function y(m) {
    if (!(this instanceof y))
      return new y(m);
    s.call(this, m), u.call(this, m), m && m.readable === !1 && (this.readable = !1), m && m.writable === !1 && (this.writable = !1), this.allowHalfOpen = !0, m && m.allowHalfOpen === !1 && (this.allowHalfOpen = !1), this.once("end", D);
  }
  Object.defineProperty(y.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  });
  function D() {
    this.allowHalfOpen || this._writableState.ended || e.nextTick(M, this);
  }
  function M(m) {
    m.end();
  }
  return Object.defineProperty(y.prototype, "destroyed", {
    get: function() {
      return this._readableState === void 0 || this._writableState === void 0 ? !1 : this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function(m) {
      this._readableState === void 0 || this._writableState === void 0 || (this._readableState.destroyed = m, this._writableState.destroyed = m);
    }
  }), y.prototype._destroy = function(m, z) {
    this.push(null), this.end(), e.nextTick(z, m);
  }, Ir;
}
var wr, En;
function _i() {
  if (En)
    return wr;
  En = 1;
  var e = Ge;
  wr = S;
  var t = yu, n;
  S.ReadableState = b, et.EventEmitter;
  var s = function(o, a) {
    return o.listeners(a).length;
  }, u = Oi, d = Vr.Buffer, c = (typeof ie < "u" ? ie : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
  };
  function p(o) {
    return d.from(o);
  }
  function y(o) {
    return d.isBuffer(o) || o instanceof c;
  }
  var D = Object.create(oe);
  D.inherits = Se;
  var M = at, m = void 0;
  M && M.debuglog ? m = M.debuglog("stream") : m = function() {
  };
  var z = Mu(), R = zi, _;
  D.inherits(S, u);
  var B = ["error", "close", "destroy", "pause", "resume"];
  function Z(o, a, I) {
    if (typeof o.prependListener == "function")
      return o.prependListener(a, I);
    !o._events || !o._events[a] ? o.on(a, I) : t(o._events[a]) ? o._events[a].unshift(I) : o._events[a] = [I, o._events[a]];
  }
  function b(o, a) {
    n = n || qe(), o = o || {};
    var I = a instanceof n;
    this.objectMode = !!o.objectMode, I && (this.objectMode = this.objectMode || !!o.readableObjectMode);
    var L = o.highWaterMark, k = o.readableHighWaterMark, O = this.objectMode ? 16 : 16 * 1024;
    L || L === 0 ? this.highWaterMark = L : I && (k || k === 0) ? this.highWaterMark = k : this.highWaterMark = O, this.highWaterMark = Math.floor(this.highWaterMark), this.buffer = new z(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.destroyed = !1, this.defaultEncoding = o.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, o.encoding && (_ || (_ = mt().StringDecoder), this.decoder = new _(o.encoding), this.encoding = o.encoding);
  }
  function S(o) {
    if (n = n || qe(), !(this instanceof S))
      return new S(o);
    this._readableState = new b(o, this), this.readable = !0, o && (typeof o.read == "function" && (this._read = o.read), typeof o.destroy == "function" && (this._destroy = o.destroy)), u.call(this);
  }
  Object.defineProperty(S.prototype, "destroyed", {
    get: function() {
      return this._readableState === void 0 ? !1 : this._readableState.destroyed;
    },
    set: function(o) {
      this._readableState && (this._readableState.destroyed = o);
    }
  }), S.prototype.destroy = R.destroy, S.prototype._undestroy = R.undestroy, S.prototype._destroy = function(o, a) {
    this.push(null), a(o);
  }, S.prototype.push = function(o, a) {
    var I = this._readableState, L;
    return I.objectMode ? L = !0 : typeof o == "string" && (a = a || I.defaultEncoding, a !== I.encoding && (o = d.from(o, a), a = ""), L = !0), F(this, o, a, !1, L);
  }, S.prototype.unshift = function(o) {
    return F(this, o, null, !0, !1);
  };
  function F(o, a, I, L, k) {
    var O = o._readableState;
    if (a === null)
      O.reading = !1, fe(o, O);
    else {
      var P;
      k || (P = H(O, a)), P ? o.emit("error", P) : O.objectMode || a && a.length > 0 ? (typeof a != "string" && !O.objectMode && Object.getPrototypeOf(a) !== d.prototype && (a = p(a)), L ? O.endEmitted ? o.emit("error", new Error("stream.unshift() after end event")) : $(o, O, a, !0) : O.ended ? o.emit("error", new Error("stream.push() after EOF")) : (O.reading = !1, O.decoder && !I ? (a = O.decoder.write(a), O.objectMode || a.length !== 0 ? $(o, O, a, !1) : V(o, O)) : $(o, O, a, !1))) : L || (O.reading = !1);
    }
    return ye(O);
  }
  function $(o, a, I, L) {
    a.flowing && a.length === 0 && !a.sync ? (o.emit("data", I), o.read(0)) : (a.length += a.objectMode ? 1 : I.length, L ? a.buffer.unshift(I) : a.buffer.push(I), a.needReadable && J(o)), V(o, a);
  }
  function H(o, a) {
    var I;
    return !y(a) && typeof a != "string" && a !== void 0 && !o.objectMode && (I = new TypeError("Invalid non-string/buffer chunk")), I;
  }
  function ye(o) {
    return !o.ended && (o.needReadable || o.length < o.highWaterMark || o.length === 0);
  }
  S.prototype.isPaused = function() {
    return this._readableState.flowing === !1;
  }, S.prototype.setEncoding = function(o) {
    return _ || (_ = mt().StringDecoder), this._readableState.decoder = new _(o), this._readableState.encoding = o, this;
  };
  var se = 8388608;
  function te(o) {
    return o >= se ? o = se : (o--, o |= o >>> 1, o |= o >>> 2, o |= o >>> 4, o |= o >>> 8, o |= o >>> 16, o++), o;
  }
  function ue(o, a) {
    return o <= 0 || a.length === 0 && a.ended ? 0 : a.objectMode ? 1 : o !== o ? a.flowing && a.length ? a.buffer.head.data.length : a.length : (o > a.highWaterMark && (a.highWaterMark = te(o)), o <= a.length ? o : a.ended ? a.length : (a.needReadable = !0, 0));
  }
  S.prototype.read = function(o) {
    m("read", o), o = parseInt(o, 10);
    var a = this._readableState, I = o;
    if (o !== 0 && (a.emittedReadable = !1), o === 0 && a.needReadable && (a.length >= a.highWaterMark || a.ended))
      return m("read: emitReadable", a.length, a.ended), a.length === 0 && a.ended ? T(this) : J(this), null;
    if (o = ue(o, a), o === 0 && a.ended)
      return a.length === 0 && T(this), null;
    var L = a.needReadable;
    m("need readable", L), (a.length === 0 || a.length - o < a.highWaterMark) && (L = !0, m("length less than watermark", L)), a.ended || a.reading ? (L = !1, m("reading or ended", L)) : L && (m("do read"), a.reading = !0, a.sync = !0, a.length === 0 && (a.needReadable = !0), this._read(a.highWaterMark), a.sync = !1, a.reading || (o = ue(I, a)));
    var k;
    return o > 0 ? k = v(o, a) : k = null, k === null ? (a.needReadable = !0, o = 0) : a.length -= o, a.length === 0 && (a.ended || (a.needReadable = !0), I !== o && a.ended && T(this)), k !== null && this.emit("data", k), k;
  };
  function fe(o, a) {
    if (!a.ended) {
      if (a.decoder) {
        var I = a.decoder.end();
        I && I.length && (a.buffer.push(I), a.length += a.objectMode ? 1 : I.length);
      }
      a.ended = !0, J(o);
    }
  }
  function J(o) {
    var a = o._readableState;
    a.needReadable = !1, a.emittedReadable || (m("emitReadable", a.flowing), a.emittedReadable = !0, a.sync ? e.nextTick(Q, o) : Q(o));
  }
  function Q(o) {
    m("emit readable"), o.emit("readable"), A(o);
  }
  function V(o, a) {
    a.readingMore || (a.readingMore = !0, e.nextTick(W, o, a));
  }
  function W(o, a) {
    for (var I = a.length; !a.reading && !a.flowing && !a.ended && a.length < a.highWaterMark && (m("maybeReadMore read 0"), o.read(0), I !== a.length); )
      I = a.length;
    a.readingMore = !1;
  }
  S.prototype._read = function(o) {
    this.emit("error", new Error("_read() is not implemented"));
  }, S.prototype.pipe = function(o, a) {
    var I = this, L = this._readableState;
    switch (L.pipesCount) {
      case 0:
        L.pipes = o;
        break;
      case 1:
        L.pipes = [L.pipes, o];
        break;
      default:
        L.pipes.push(o);
        break;
    }
    L.pipesCount += 1, m("pipe count=%d opts=%j", L.pipesCount, a);
    var k = (!a || a.end !== !1) && o !== q.stdout && o !== q.stderr, O = k ? he : Ae;
    L.endEmitted ? e.nextTick(O) : I.once("end", O), o.on("unpipe", P);
    function P(pe, ce) {
      m("onunpipe"), pe === I && ce && ce.hasUnpiped === !1 && (ce.hasUnpiped = !0, De());
    }
    function he() {
      m("onend"), o.end();
    }
    var we = K(I);
    o.on("drain", we);
    var Ce = !1;
    function De() {
      m("cleanup"), o.removeListener("close", Ee), o.removeListener("finish", ze), o.removeListener("drain", we), o.removeListener("error", Le), o.removeListener("unpipe", P), I.removeListener("end", he), I.removeListener("end", Ae), I.removeListener("data", x), Ce = !0, L.awaitDrain && (!o._writableState || o._writableState.needDrain) && we();
    }
    var be = !1;
    I.on("data", x);
    function x(pe) {
      m("ondata"), be = !1;
      var ce = o.write(pe);
      ce === !1 && !be && ((L.pipesCount === 1 && L.pipes === o || L.pipesCount > 1 && G(L.pipes, o) !== -1) && !Ce && (m("false write response, pause", L.awaitDrain), L.awaitDrain++, be = !0), I.pause());
    }
    function Le(pe) {
      m("onerror", pe), Ae(), o.removeListener("error", Le), s(o, "error") === 0 && o.emit("error", pe);
    }
    Z(o, "error", Le);
    function Ee() {
      o.removeListener("finish", ze), Ae();
    }
    o.once("close", Ee);
    function ze() {
      m("onfinish"), o.removeListener("close", Ee), Ae();
    }
    o.once("finish", ze);
    function Ae() {
      m("unpipe"), I.unpipe(o);
    }
    return o.emit("pipe", I), L.flowing || (m("pipe resume"), I.resume()), o;
  };
  function K(o) {
    return function() {
      var a = o._readableState;
      m("pipeOnDrain", a.awaitDrain), a.awaitDrain && a.awaitDrain--, a.awaitDrain === 0 && s(o, "data") && (a.flowing = !0, A(o));
    };
  }
  S.prototype.unpipe = function(o) {
    var a = this._readableState, I = { hasUnpiped: !1 };
    if (a.pipesCount === 0)
      return this;
    if (a.pipesCount === 1)
      return o && o !== a.pipes ? this : (o || (o = a.pipes), a.pipes = null, a.pipesCount = 0, a.flowing = !1, o && o.emit("unpipe", this, I), this);
    if (!o) {
      var L = a.pipes, k = a.pipesCount;
      a.pipes = null, a.pipesCount = 0, a.flowing = !1;
      for (var O = 0; O < k; O++)
        L[O].emit("unpipe", this, { hasUnpiped: !1 });
      return this;
    }
    var P = G(a.pipes, o);
    return P === -1 ? this : (a.pipes.splice(P, 1), a.pipesCount -= 1, a.pipesCount === 1 && (a.pipes = a.pipes[0]), o.emit("unpipe", this, I), this);
  }, S.prototype.on = function(o, a) {
    var I = u.prototype.on.call(this, o, a);
    if (o === "data")
      this._readableState.flowing !== !1 && this.resume();
    else if (o === "readable") {
      var L = this._readableState;
      !L.endEmitted && !L.readableListening && (L.readableListening = L.needReadable = !0, L.emittedReadable = !1, L.reading ? L.length && J(this) : e.nextTick(re, this));
    }
    return I;
  }, S.prototype.addListener = S.prototype.on;
  function re(o) {
    m("readable nexttick read 0"), o.read(0);
  }
  S.prototype.resume = function() {
    var o = this._readableState;
    return o.flowing || (m("resume"), o.flowing = !0, f(this, o)), this;
  };
  function f(o, a) {
    a.resumeScheduled || (a.resumeScheduled = !0, e.nextTick(g, o, a));
  }
  function g(o, a) {
    a.reading || (m("resume read 0"), o.read(0)), a.resumeScheduled = !1, a.awaitDrain = 0, o.emit("resume"), A(o), a.flowing && !a.reading && o.read(0);
  }
  S.prototype.pause = function() {
    return m("call pause flowing=%j", this._readableState.flowing), this._readableState.flowing !== !1 && (m("pause"), this._readableState.flowing = !1, this.emit("pause")), this;
  };
  function A(o) {
    var a = o._readableState;
    for (m("flow", a.flowing); a.flowing && o.read() !== null; )
      ;
  }
  S.prototype.wrap = function(o) {
    var a = this, I = this._readableState, L = !1;
    o.on("end", function() {
      if (m("wrapped end"), I.decoder && !I.ended) {
        var P = I.decoder.end();
        P && P.length && a.push(P);
      }
      a.push(null);
    }), o.on("data", function(P) {
      if (m("wrapped data"), I.decoder && (P = I.decoder.write(P)), !(I.objectMode && P == null) && !(!I.objectMode && (!P || !P.length))) {
        var he = a.push(P);
        he || (L = !0, o.pause());
      }
    });
    for (var k in o)
      this[k] === void 0 && typeof o[k] == "function" && (this[k] = function(P) {
        return function() {
          return o[P].apply(o, arguments);
        };
      }(k));
    for (var O = 0; O < B.length; O++)
      o.on(B[O], this.emit.bind(this, B[O]));
    return this._read = function(P) {
      m("wrapped _read", P), L && (L = !1, o.resume());
    }, this;
  }, Object.defineProperty(S.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.highWaterMark;
    }
  }), S._fromList = v;
  function v(o, a) {
    if (a.length === 0)
      return null;
    var I;
    return a.objectMode ? I = a.buffer.shift() : !o || o >= a.length ? (a.decoder ? I = a.buffer.join("") : a.buffer.length === 1 ? I = a.buffer.head.data : I = a.buffer.concat(a.length), a.buffer.clear()) : I = U(o, a.buffer, a.decoder), I;
  }
  function U(o, a, I) {
    var L;
    return o < a.head.data.length ? (L = a.head.data.slice(0, o), a.head.data = a.head.data.slice(o)) : o === a.head.data.length ? L = a.shift() : L = I ? w(o, a) : j(o, a), L;
  }
  function w(o, a) {
    var I = a.head, L = 1, k = I.data;
    for (o -= k.length; I = I.next; ) {
      var O = I.data, P = o > O.length ? O.length : o;
      if (P === O.length ? k += O : k += O.slice(0, o), o -= P, o === 0) {
        P === O.length ? (++L, I.next ? a.head = I.next : a.head = a.tail = null) : (a.head = I, I.data = O.slice(P));
        break;
      }
      ++L;
    }
    return a.length -= L, k;
  }
  function j(o, a) {
    var I = d.allocUnsafe(o), L = a.head, k = 1;
    for (L.data.copy(I), o -= L.data.length; L = L.next; ) {
      var O = L.data, P = o > O.length ? O.length : o;
      if (O.copy(I, I.length - o, 0, P), o -= P, o === 0) {
        P === O.length ? (++k, L.next ? a.head = L.next : a.head = a.tail = null) : (a.head = L, L.data = O.slice(P));
        break;
      }
      ++k;
    }
    return a.length -= k, I;
  }
  function T(o) {
    var a = o._readableState;
    if (a.length > 0)
      throw new Error('"endReadable()" called on non-empty stream');
    a.endEmitted || (a.ended = !0, e.nextTick(Y, a, o));
  }
  function Y(o, a) {
    !o.endEmitted && o.length === 0 && (o.endEmitted = !0, a.readable = !1, a.emit("end"));
  }
  function G(o, a) {
    for (var I = 0, L = o.length; I < L; I++)
      if (o[I] === a)
        return I;
    return -1;
  }
  return wr;
}
var Bi = Re, Yt = qe(), Ri = Object.create(oe);
Ri.inherits = Se;
Ri.inherits(Re, Yt);
function Cu(e, t) {
  var n = this._transformState;
  n.transforming = !1;
  var s = n.writecb;
  if (!s)
    return this.emit("error", new Error("write callback called multiple times"));
  n.writechunk = null, n.writecb = null, t != null && this.push(t), s(e);
  var u = this._readableState;
  u.reading = !1, (u.needReadable || u.length < u.highWaterMark) && this._read(u.highWaterMark);
}
function Re(e) {
  if (!(this instanceof Re))
    return new Re(e);
  Yt.call(this, e), this._transformState = {
    afterTransform: Cu.bind(this),
    needTransform: !1,
    transforming: !1,
    writecb: null,
    writechunk: null,
    writeencoding: null
  }, this._readableState.needReadable = !0, this._readableState.sync = !1, e && (typeof e.transform == "function" && (this._transform = e.transform), typeof e.flush == "function" && (this._flush = e.flush)), this.on("prefinish", Au);
}
function Au() {
  var e = this;
  typeof this._flush == "function" ? this._flush(function(t, n) {
    xn(e, t, n);
  }) : xn(this, null, null);
}
Re.prototype.push = function(e, t) {
  return this._transformState.needTransform = !1, Yt.prototype.push.call(this, e, t);
};
Re.prototype._transform = function(e, t, n) {
  throw new Error("_transform() is not implemented");
};
Re.prototype._write = function(e, t, n) {
  var s = this._transformState;
  if (s.writecb = n, s.writechunk = e, s.writeencoding = t, !s.transforming) {
    var u = this._readableState;
    (s.needTransform || u.needReadable || u.length < u.highWaterMark) && this._read(u.highWaterMark);
  }
};
Re.prototype._read = function(e) {
  var t = this._transformState;
  t.writechunk !== null && t.writecb && !t.transforming ? (t.transforming = !0, this._transform(t.writechunk, t.writeencoding, t.afterTransform)) : t.needTransform = !0;
};
Re.prototype._destroy = function(e, t) {
  var n = this;
  Yt.prototype._destroy.call(this, e, function(s) {
    t(s), n.emit("close");
  });
};
function xn(e, t, n) {
  if (t)
    return e.emit("error", t);
  if (n != null && e.push(n), e._writableState.length)
    throw new Error("Calling transform done when ws.length != 0");
  if (e._transformState.transforming)
    throw new Error("Calling transform done when still transforming");
  return e.push(null);
}
var Lu = ot, Pi = Bi, Ui = Object.create(oe);
Ui.inherits = Se;
Ui.inherits(ot, Pi);
function ot(e) {
  if (!(this instanceof ot))
    return new ot(e);
  Pi.call(this, e);
}
ot.prototype._transform = function(e, t, n) {
  n(null, e);
};
(function(e, t) {
  t = e.exports = _i(), t.Stream = t, t.Readable = t, t.Writable = ki(), t.Duplex = qe(), t.Transform = Bi, t.PassThrough = Lu;
})(zr, zr.exports);
var Yi = zr.exports;
Object.defineProperty(Xr, "__esModule", { value: !0 });
const mu = Yi;
function ju(e) {
  if (!e || !e.engine)
    throw new Error("Missing engine parameter!");
  const { engine: t } = e, n = new mu.Duplex({ objectMode: !0, read: s, write: u });
  return t.on && t.on("notification", (d) => {
    n.push(d);
  }), n;
  function s() {
  }
  function u(d, c, p) {
    t.handle(d, (y, D) => {
      n.push(D);
    }), p();
  }
}
Xr.default = ju;
var Kr = {}, Nu = ie && ie.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Kr, "__esModule", { value: !0 });
const Du = Nu(Pt), bu = Yi;
function Tu() {
  const e = {}, t = new bu.Duplex({
    objectMode: !0,
    read: u,
    write: d
  }), n = new Du.default();
  return { events: n, middleware: (y, D, M, m) => {
    t.push(y), e[y.id] = { req: y, res: D, next: M, end: m };
  }, stream: t };
  function u() {
    return !1;
  }
  function d(y, D, M) {
    let m;
    try {
      !y.id ? p(y) : c(y);
    } catch (z) {
      m = z;
    }
    M(m);
  }
  function c(y) {
    const D = e[y.id];
    if (!D)
      throw new Error(`StreamMiddleware - Unknown response id "${y.id}"`);
    delete e[y.id], Object.assign(D.res, y), setTimeout(D.end);
  }
  function p(y) {
    n.emit("notification", y);
  }
}
Kr.default = Tu;
var Fi = ie && ie.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(it, "__esModule", { value: !0 });
it.createStreamMiddleware = it.createEngineStream = void 0;
const Su = Fi(Xr);
it.createEngineStream = Su.default;
const Eu = Fi(Kr);
it.createStreamMiddleware = Eu.default;
/^v?\.0/.test(q.version);
const zu = async (e, t) => {
  const n = document.querySelector(e), s = { ...t, selector: e };
  if (!n)
    throw new Error("Could not find root element");
  n.innerHTML = "", window.cedeWidgets = {
    send: s
  };
  const u = Qo(t == null ? void 0 : t.theme), d = new Ro(n, u, s);
  if (d.renderHtml(Io, { layout: !0 }), !window.chrome) {
    d.renderHtml(_o);
    return;
  }
  d.renderHtml(Lo, { animateOnExit: !0 });
  const c = await Jo();
  if (!c) {
    d.renderHtml(xo);
    return;
  }
  const p = await c.request({ method: "getWidgetBundleUrl", params: { name: "send" } }).catch(() => null);
  if (!p) {
    d.renderHtml(ho, {
      data: {
        error: Cr.WIDGETS.SEND.CANT_FETCH_BUNDLE
      }
    });
    return;
  }
  const y = document.createElement("script");
  y.src = p, document.body.appendChild(y);
};
export {
  zu as renderSendWidget
};
